const fr = {
  common: {
    // Re-passe recette Sprint 1 — clés admin manquantes (clés brutes purgées)
    saved: "Enregistré.",
    reasonRequired: "Raison requise.",
    loading: "Chargement...",
    save: "Enregistrer",
    notProvided: "Non renseigné",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    back: "Retour",
    viewAll: "Voir tout",
    viewDetails: "Voir les détails",
    search: "Rechercher",
    filter: "Filtrer",
    all: "Tous",
    status: "Statut",
    date: "Date",
    amount: "Montant",
    project: "Projet",
    type: "Type",
    actions: "Actions",
    yes: "Oui",
    no: "Non",
    confirm: "Confirmer",
    close: "Fermer",
    upload: "Téléverser",
    download: "Télécharger",
    submit: "Soumettre",
    noResults: "Aucun résultat",
    email: "E-mail",
    password: "Mot de passe",
    signIn: "Se connecter",
    signOut: "Déconnexion",
    requestAccess: "Demander l'accès",
    learnMore: "En savoir plus",
    name: "Nom",
    investor: "Investisseur",
    view: "Voir",
    manage: "Gérer",
    review: "Examiner",
    approve: "Approuver",
    reject: "Rejeter",
    processing: "Traitement...",
    export: "Exporter",
    more: "de plus",
    saving: "Enregistrement...",
    of: "sur",
    new: "Nouveau",
    active: "Actif",
    pending: "En attente",
    uploading: "Envoi en cours...",
    updated: "Mis \u00e0 jour avec succ\u00e8s",
    added: "Ajout\u00e9 avec succ\u00e8s",
    error: "Une erreur est survenue",
    uploaded: "T\u00e9l\u00e9vers\u00e9 avec succ\u00e8s",
    duplicated: "Dupliqu\u00e9 avec succ\u00e8s",
    created: "Cr\u00e9\u00e9 avec succ\u00e8s",
    deleted: "Supprim\u00e9 avec succ\u00e8s",
    confirmDelete: "\u00cates-vous s\u00fbr de vouloir supprimer cet \u00e9l\u00e9ment ?",
    draft: "Brouillon",
    internalReview: "Revue interne",
    comingSoon: "Bient\u00f4t disponible",
    open: "Ouvert",
    nearlyFull: "Quasi complet",
    full: "Complet",
    closed: "Cl\u00f4tur\u00e9",
    allValidatedInvestors: "Tous les investisseurs valid\u00e9s",
    publicPreview: "Aper\u00e7u public",
    invitationOnly: "Sur invitation uniquement",
  },

  investmentType: {
    label: "Nature de l'investissement",
    equity: "Actions / Parts sociales",
    actions: "Actions / Parts sociales",
    parts: "Parts sociales",
    bonds: "Obligations",
    debt: "Dette",
    obligations: "Obligations",
    cca: "Compte courant d'associ\u00e9 (CCA)",
    mezzanine: "Mezzanine",
    selectType: "S\u00e9lectionner la nature",
    allowedTypes: "Types de projet accept\u00e9s",
    minInvestment: "Ticket minimum",
    minInvestmentHint: "Montant minimum par souscription (EUR)",
  },

  // GO PO V3 — Espace investisseur « Ambassadeur »
  amb: {
    eyebrow: "Espace investisseur — Ambassadeur",
    heroTitle1: "Recommander",
    heroTitleGold: "Wealth",
    heroTitle2: "Management",
    heroTitle3: "Global Real Assets",
    heroLead: "Présentez en toute discrétion notre maison à des personnes de confiance.",
    signature: "Une recommandation, jamais une sollicitation.",
    heroVertical: "Des actifs réels pour un monde plus durable",
    pillar1Title: "Vous partagez votre lien",
    pillar1Text: "Avec des personnes de confiance de votre entourage.",
    pillar2Title: "Ils découvrent notre maison",
    pillar2Text: "À leur rythme, en toute autonomie et en toute discrétion.",
    pillar3Title: "Vous suivez leur parcours",
    pillar3Text: "Jusqu'à leur statut d'investisseur actif.",
    linkEyebrow: "Votre lien personnel",
    copyLink: "Copier le lien",
    share: "Partager",
    sendEmail: "Envoyer par e-mail",
    linkPermanent: "Votre lien est permanent et personnel. Il n'expire pas.",
    copied: "Lien copié. Il ne vous reste qu'à le transmettre.",
    shareCopied: "Invitation copiée — collez-la où vous le souhaitez.",
    editoOverlay: "Des relations durables créent plus que des investissements",
    editoTitle: "La confiance se partage",
    editoText: "Vous contribuez, à votre échelle, à faire découvrir une maison indépendante, engagée dans l'économie réelle.",
    editoMerci: "Merci de faire partie de notre histoire.",
    registryEyebrow: "Vos recommandations",
    registryTitle: "Votre cercle",
    sortRecent: "Les plus récentes",
    stepInvited: "Invitation envoyée",
    stepAccount: "Compte créé",
    stepActive: "Investisseur actif",
    stepGift: "Cadeau Ambassadeur — {amount} €",
    badgeGift: "Merci pour votre confiance",
    sinceInvited: "Invitation envoyée le {date}",
    sinceAccount: "Compte créé le {date}",
    sinceActive: "Investisseur actif depuis le {date}",
    registryFoot: "Seul l'avancement est présenté ici. Aucune information financière ou personnelle de vos invités ne vous est communiquée.",
    registryGiftNote: "Attention de {amount} € après activation de l'investissement — souscription finalisée et fonds effectivement reçus.",
    emptyTitle: "Votre cercle commence ici.",
    emptyText: "Vous n'avez encore recommandé personne. Lorsque vous partagerez votre lien, vous suivrez ici, en toute discrétion, le chemin de vos invités.",
    emptyCta: "Partager mon lien",
    giftEyebrow: "Notre geste de remerciement",
    giftTitle: "Une attention pour chaque recommandation aboutie",
    giftText1: "Lorsqu'une personne de votre cercle devient investisseur actif auprès de Wealth Management Global Real Assets, notre maison tient à vous remercier par une attention d'une valeur de {amount} €.",
    giftText2: "Elle vous est adressée une fois la souscription finalisée et les fonds effectivement reçus. Une manière simple de reconnaître la confiance que vous nous témoignez lorsque vous choisissez de nous présenter l'un de vos proches.",
    giftVertical: "Des valeurs qui se partagent",
    colophonTitle: "Une maison discrète.",
    colophonText: "Vos recommandations restent entre nous — elles ne quittent jamais le cercle de Wealth Management Global Real Assets.",
    unavailableTitle: "Espace Ambassadeur",
    unavailableText: "Cet espace n'est pas encore ouvert pour votre compte. Votre interlocuteur dédié reste à votre disposition.",
    shareMessage: "Je vous recommande Wealth Management Global Real Assets, maison d'investissement en actifs réels. Voici mon lien personnel pour découvrir leur approche : {link}",
    shareSubject: "Une maison d'investissement que je vous recommande",
  },


  nav: {
    investmentsGroup: "Investissements",
    documentsGroup: "Documents & Suivi",
    accountGroup: "Compte",
    home: "Accueil",
    about: "À propos",
    howItWorks: "Fonctionnement",
    contact: "Contact",
    dashboard: "Tableau de bord",
    opportunities: "Opportunités",
    myInvestments: "Mes projets",
    patrimoine: "Mon patrimoine",
    subscriptions: "Souscriptions",
    movements: "Mouvements",
    waitingList: "Liste d'attente",
    opportunityInterests: "Signaux d'int\u00e9r\u00eat",
    compliance: "Conformité KYC",
    notifications: "Notifications",
    profile: "Profil",
    ambassador: "Ambassadeur",
    projects: "Projets",
    myProjects: "Mes projets",
    documents: "Documents",
    fundraising: "Levée de fonds",
    investors: "Investisseurs",
    investorManagement: "Gestion investisseurs",
    accessRequests: "Demandes d'accès",
    complianceReview: "Centre de documents",
    updates: "Mises à jour",
    sponsors: "Commandités",
    settings: "Paramètres",
    auditLogs: "Journal d'audit",
    internalUsers: "Utilisateurs internes",
    overview: "Aperçu",
    deals: "Opérations",
    operations: "Opérations",
    system: "Système",
    secondaryMarket: "Marché secondaire",
    importData: "Import de données",
    qaConsole: "Contrôle qualité",
    goLive: "Production & go-live",
    sponsorOps: "Opérations commandités",
    distributionCalendar: "Calendrier distributions",
    taskConsole: "Tâches internes",
    templates: "Modèles opérationnels",
    commandCenter: "Centre de commande",
    onboarding: "Mise en place",
    cockpit: "Centre de contrôle",
    crm: "CRM Investisseurs",
    securityConsole: "Sécurité",
    automation: "Automatisation",
    portfolio: "Mon portefeuille",
    updates: "Mises à jour projets",
    reporting: "Centre de rapports",
    sidebarControlCenter: "Centre de contrôle",
    sidebarInvestors: "Investisseurs",
    sidebarProjects: "Projets",
    sidebarOperations: "Opérations",
    sidebarConfiguration: "Configuration",
    cockpitHome: "Cockpit",
    myTasks: "Mes tâches",
    investorDirectory: "Répertoire investisseurs",
    communications: "Communications",
    allProjects: "Tous les projets",
    interests: "Signaux d'intérêt",
    distributions: "Distributions",
    recurringSchedules: "Échéanciers récurrents",
    contributions: "Contributions",
    team: "Équipe",
    platformSettings: "Paramètres plateforme",
    auditTrail: "Journal d'audit",
    identityAccess: "Identité & Accès",
    pendingActions: "Actions en attente",
    operationsPipeline: "Opérations du jour",
    directory: "Répertoire",
    administration: "Administration",
    dataTools: "Outils de données",
    siteEditor: "Éditeur site public",
    bulkAccountPrep: "Comptes en attente",
  },

  projectList: {
    thFunded: "Financé",
    thAllocated: "Alloué",
    thInvestors: "Investisseurs",
    thPending: "En attente",
  },

  investorList: {
    thFunded: "Financé",
    thAllocated: "Alloué",
    thProjects: "Projets",
    thPending: "En attente",
  },

  corrections: {
    quickAmountEdit: "Correction de montant",
    editAmount: "Modifier le montant",
    field: "Champ à modifier",
    displayAmount: "Montant affiché (côté investisseur)",
    investedAmount: "Montant investi (source de vérité)",
    fundedAmount: "Montant financé (fonds reçus)",
    allocatedAmount: "Montant attribué au projet",
    distributedAmount: "Montant distribué (versements effectués)",
    ccaRemaining: "Solde CCA restant (compte courant d'associé)",
    currentValue: "Valeur actuelle",
    newValue: "Nouvelle valeur",
    reason: "Motif (obligatoire)",
    reasonPlaceholder: "Expliquez la raison de cette correction...",
    applyCorrection: "Appliquer la correction",
    amountUpdated: "Montant mis à jour et tracé dans l'audit.",
    displayAmountActive: "Montant affiché modifié par admin actif",
    reasonRequired: "Le montant et le motif sont obligatoires.",
    editRaise: "Modifier l'objectif de levée",
    raiseUpdated: "Objectif de levée mis à jour.",
  },

  ops: {
    // Re-passe recette Sprint 1 — filtre des positions (distributions)
    positions: {
      allTypes: "Tous les types",
    },
    overline: "Opérations",
    title: "Opérations du jour",
    subtitle: "Souscriptions nécessitant une action, classées par étape.",
    needsAction: "Actions requises",
    totalSubscriptions: "Total souscriptions",

    bucketPendingReview: "En attente de revue",
    bucketAwaitingFunds: "En attente de fonds",
    bucketFundsReceived: "Fonds reçus",
    bucketAwaitingAllocation: "En attente d'allocation",
    bucketActive: "Investissements actifs",
    bucketCompleted: "Terminés",

    hintPendingReview: "Ces souscriptions nécessitent une vérification de conformité, du montant ou une approbation",
    hintAwaitingFunds: "Approuvées — en attente du virement de l'investisseur",
    hintFundsReceived: "Fonds arrivés — confirmer et préparer l'allocation",
    hintAwaitingAllocation: "Financé — attribuer les parts ou unités à l'investisseur",
    hintActive: "Investissements actifs, aucune action sauf si signalé",
    hintCompleted: "Cycle de vie de l'investissement terminé",

    colInvestor: "Investisseur",
    colProject: "Projet",
    colAmount: "Montant",
    colStatus: "Statut",
    colWaiting: "Attente",
    colNextAction: "Prochaine action",
    colLastUpdate: "Dernière MAJ",

    status_pending_review: "En attente de revue",
    status_compliance_check: "Vérification conformité",
    status_compliance_incomplete: "Documents manquants",
    status_approved: "Approuvée",
    status_approved_awaiting_funding: "En attente de fonds",
    status_transfer_confirmed: "Fonds reçus",
    status_awaiting_allocation: "En attente d'allocation",
    status_allocated: "Alloué",
    status_active: "Actif",
    status_completed: "Terminé",
    status_cancelled: "Annulé",
    status_rejected: "Rejeté",

    actionReview: "Revoir et approuver",
    actionCheckCompliance: "Vérifier la conformité",
    actionFollowUpDocs: "Relancer pour les documents",
    actionConfirmTransfer: "Confirmer le virement",
    actionAllocateShares: "Attribuer les parts / unités",
    actionMonitor: "Suivre",
    actionNone: "Aucune action requise",

    viewProfile: "voir le profil",
    openSubscription: "Ouvrir la souscription",
    showingFirst: "Affichage des premiers",
    bucketEmpty: "Rien ici — tout est en ordre.",
    refresh: "Actualiser",
    loadError: "Impossible de charger les données opérationnelles",
  },

  home: {
    overline: "Plateforme privée de projet en actifs réels",
    heroTitle: "Accès structuré aux actifs réels internationaux",
    heroSubtitle: "Wealth Management - Global Real Assets accompagne les investisseurs qualifiés dans la sélection, la structuration et le suivi d'opérations en actifs réels sur les marchés internationaux. Un cadre rigoureux, une approche sélective, un accompagnement sur la durée.",
    approachOverline: "Notre approche",
    approachTitle: "Sélection, structuration, accompagnement",
    approachSubtitle: "Nous offrons un accès maîtrisé à des opérations habituellement réservées aux investisseurs institutionnels et family offices — avec la rigueur d'analyse, le cadre juridique et le suivi opérationnel qu'exige chaque projet en actifs réels.",
    exclusiveAccess: "Accès sélectif",
    exclusiveAccessDesc: "Plateforme accessible sur candidature. Chaque investisseur est évalué individuellement avant d'accéder aux opportunités.",
    dueDiligence: "Analyse approfondie",
    dueDiligenceDesc: "Chaque opération fait l'objet d'une due diligence complète : marché, structuration juridique, modélisation financière et analyse des risques.",
    internationalReach: "Diversification internationale",
    internationalReachDesc: "Exposition à des actifs réels sélectionnés sur plusieurs géographies, secteurs et classes d'actifs.",
    institutionalStructuring: "Structuration professionnelle",
    institutionalStructuringDesc: "Cadres juridiques adaptés et documentation sur mesure pour chaque opération.",
    opportunitiesOverline: "Projets de référence",
    opportunitiesTitle: "Un aperçu de ce que nous structurons",
    requestAccessToView: "Accéder aux opportunités en cours",
    assetClass: "Classe d'actifs",
    minInvestment: "Ticket d'entrée",
    processOverline: "Le parcours investisseur",
    processTitle: "Un processus structuré et maîtrisé",
    step1: "Candidature",
    step1Desc: "Soumettez votre demande d'accès. Notre équipe évalue chaque profil individuellement.",
    step2: "Validation et intégration",
    step2Desc: "Après examen de votre candidature, nous procédons à la vérification réglementaire et à la collecte des documents de conformité.",
    step3: "Accès aux opportunités",
    step3Desc: "Consultez les opérations structurées, accédez à la documentation détaillée et exprimez votre intérêt.",
    step4: "Souscription et suivi",
    step4Desc: "Finalisez votre souscription avec notre équipe. Suivez vos projets, mouvements et documents depuis votre espace dédié.",
    statsCapital: "Capital structuré",
    statsTransactions: "Opérations accompagnées",
    statsInvestors: "Investisseurs accompagnés",
    statsExperience: "Années d'expérience",
    ctaTitle: "Accédez à des opérations en actifs réels sur mesure",
    ctaSubtitle: "Wealth Management - Global Real Assets est accessible sur candidature. Initiez votre parcours de qualification et rejoignez une communauté d'investisseurs exigeants.",
  },

  about: {
    overline: "La maison",
    title: "Nous investissons dans ce que nous pouvons visiter.",
    p1: "La maison est née au bord de la Méditerranée, entre un chantier de marina et un carnet de rendez-vous d'investisseurs privés. Douze ans plus tard, le métier n'a pas changé : trouver des opérations immobilières que nous comprenons, les structurer proprement, et les suivre jusqu'au dernier euro distribué.",
    p2: "Nous préférons renoncer à une belle histoire plutôt que déroger à une bonne opération. Sur vingt dossiers étudiés, dix-neuf sont refusés — souvent après les avoir visités. Dans celui qui reste, nous engageons notre propre capital.",
    p3: "Chaque opération vit dans son propre véhicule, avec sa gouvernance écrite, sa documentation complète et son reporting. Nos investisseurs voient ce que nous voyons — les flux, les baux, l'avancement des chantiers — depuis leur espace privé, à tout moment.",
    rigorousSelection: "La sélection",
    rigorousSelectionDesc: "Dix-neuf dossiers sur vingt sont refusés. Nous visitons, nous contre-expertisons, nous renonçons souvent — c'est le travail.",
    coInvestment: "Le co-investissement",
    coInvestmentDesc: "Notre capital entre dans chaque opération retenue, au même prix et aux mêmes conditions que le vôtre.",
    transparency: "La transparence",
    transparencyDesc: "Flux, documents, chantiers : vous voyez ce que nous voyons, depuis votre espace privé, sans avoir à le demander.",
  },

  howItWorks: {
    overline: "Le parcours",
    title: "Trois actes. Aucune précipitation.",
    step1Title: "La candidature",
    step1Desc: "Vous nous écrivez ; nous répondons sous 48 heures ouvrées. Un échange suffit généralement à savoir si nous pouvons travailler ensemble.",
    step2Title: "Les vérifications",
    step2Desc: "KYC, LCB-FT, statut d'investisseur qualifié : le passage obligé. Nous le rendons aussi simple que la réglementation le permet.",
    step3Title: "La découverte des opérations",
    step3Desc: "Vous entrez dans l'espace privé : dossiers complets, structuration, risques, calendrier des chantiers. Vous prenez le temps qu'il faut.",
    step4Title: "La souscription",
    step4Desc: "Bulletin, virement, documents contresignés — chaque pièce est déposée dans votre espace. Rien ne circule par e-mail non sécurisé.",
    step5Title: "Le suivi",
    step5Desc: "Reporting périodique, mouvements, distributions et fiscalité, au même endroit, jusqu'à la sortie de l'opération.",
  },

  contactPage: {
    overline: "Prenons contact",
    title: "Parlons de votre projet.",
    subtitle: "Que vous souhaitiez structurer votre premier club deal, obtenir un accès investisseur ou simplement comprendre notre approche, notre équipe vous répond sous 48 heures ouvrées.",
    generalInquiries: "Renseignements généraux",
    investorRelations: "Relations investisseurs",
    office: "Bureau",
    phone: "Téléphone",
    sendMessage: "Envoyez-nous un message",
    firstName: "Prénom",
    lastName: "Nom",
    email: "E-mail",
    subject: "Objet",
    message: "Message",
    sendBtn: "Envoyer le message",
    subjectGeneral: "Renseignement général",
    subjectMembership: "Intérêt pour l'adhésion",
    subjectInvestor: "Support investisseur",
    subjectOther: "Autre",
  },

  login: {
    title: "Bienvenue",
    subtitle: "Accédez à votre espace investisseur privé",
    emailLabel: "Adresse e-mail",
    passwordLabel: "Mot de passe",
    submitBtn: "Se connecter",
    forgotPassword: "Mot de passe oublié ?",
    mfaCodeLabel: "Code d'authentification (MFA)",
    mfaCodeHint: "Entrez le code à 6 chiffres de votre application d'authentification.",
    // APEX M2 — codes de récupération (login 2 étapes)
    useRecoveryCode: "J'ai perdu l'accès à mon application — utiliser un code de récupération",
    backToTotp: "Utiliser le code de l'application",
    recoveryCodeLabel: "Code de récupération",
    recoveryCodeHint: "Saisissez un de vos codes de récupération à usage unique (format XXXX-XXXX).",
    noAccount: "Vous n'avez pas encore de compte ?",
    requestAccessLink: "Demander l'accès",
    activationNeeded: "Votre compte existe mais n'a pas encore été activé. Demandez un nouveau lien d'activation ci-dessous.",
    sendActivationLink: "Envoyer le lien",
    activationLinkSent: "Si un compte associé à cette adresse est en attente d'activation, un lien d'activation a été envoyé. Veuillez vérifier votre boîte de réception.",
    sideOverline: "Portail investisseur privé",
    sideTitle: "Accès structuré aux actifs réels internationaux",
    sideSubtitle: "Votre espace dédié pour accéder aux opportunités de projet sélectionnées, suivre vos positions et gérer votre patrimoine en actifs réels.",
  },

  forgotPassword: {
    title: "Mot de passe oublié",
    subtitle: "Saisissez votre adresse e-mail et nous vous enverrons un lien de réinitialisation.",
    emailLabel: "Adresse e-mail",
    submitBtn: "Envoyer le lien",
    backToLogin: "Retour à la connexion",
    successTitle: "Lien envoyé",
    successMsg: "Si un compte est associé à cette adresse, un e-mail de réinitialisation a été envoyé. Veuillez vérifier votre boîte de réception.",
    successHint: "L'e-mail peut mettre quelques minutes à arriver. Pensez à vérifier vos courriers indésirables.",
  },

  resetPassword: {
    title: "Définir un nouveau mot de passe",
    subtitle: "Choisissez un mot de passe sécurisé pour votre compte.",
    newPasswordLabel: "Nouveau mot de passe",
    confirmPasswordLabel: "Confirmer le mot de passe",
    submitBtn: "Réinitialiser le mot de passe",
    backToLogin: "Retour à la connexion",
    successTitle: "Mot de passe réinitialisé",
    successMsg: "Votre mot de passe a été mis à jour avec succès. Vous pouvez maintenant vous connecter.",
    goToLogin: "Se connecter",
    invalidTitle: "Lien invalide",
    invalidMsg: "Ce lien de réinitialisation est invalide ou a déjà été utilisé.",
    expiredTitle: "Lien expiré",
    expiredMsg: "Ce lien de réinitialisation a expiré. Veuillez effectuer une nouvelle demande.",
    requestNew: "Nouvelle demande",
    passwordRequirements: "Au moins 10 caractères, avec majuscules, minuscules et chiffres.",
    passwordMismatch: "Les mots de passe ne correspondent pas.",
    passwordTooShort: "10 caractères minimum",
    passwordNeedsMix: "Majuscules, minuscules et chiffres requis",
  },


  activate: {
    invalidTitle: "Lien d'activation invalide",
    invalidMsg: "Ce lien d'activation est invalide ou a expiré. Veuillez contacter notre équipe.",
    goToLogin: "Retour à la connexion",
    successTitle: "Compte activé",
    successMsg: "Votre mot de passe a été défini avec succès. Bienvenue sur votre espace investisseur.",
    successMsgAdmin: "Votre compte est activé. Veuillez vous connecter pour configurer l'authentification et accéder à l'espace d'administration.",
    goToPortal: "Accéder à mon espace",
    setPassword: "Définir votre mot de passe",
    setPasswordDesc: "Créez un mot de passe sécurisé pour accéder à votre espace investisseur privé.",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    minChars: "Minimum 8 caractères",
    repeatPassword: "Répétez votre mot de passe",
    activateBtn: "Activer mon compte",
    passwordsNoMatch: "Les mots de passe ne correspondent pas",
    passwordTooShort: "Le mot de passe doit comporter au moins 8 caractères",
  },

  accessRequest: {
    overline: "Candidature",
    title: "Demander l'accès",
    subtitle: "Wealth Management - Global Real Assets s'adresse aux investisseurs qualifiés recherchant un accès structuré à des opérations en actifs réels sur mesure. Complétez le formulaire ci-dessous pour initier votre parcours de qualification.",
    successTitle: "Candidature transmise",
    successMsg: "Merci de votre intérêt pour Wealth Management - Global Real Assets. Notre équipe examinera votre candidature et vous contactera sous 2 à 3 jours ouvrés.",
    returnHome: "Retour à l'accueil",
    yourInfo: "Vos informations",
    firstName: "Prénom",
    lastName: "Nom",
    phone: "Téléphone",
    country: "Pays de résidence",
    selectCountry: "Sélectionnez un pays",
    investorType: "Type d'investisseur",
    selectType: "Sélectionnez un type",
    investmentRange: "Capacité de projet",
    selectRange: "Sélectionnez une tranche",
    experienceLevel: "Niveau d'expérience",
    selectLevel: "Sélectionnez un niveau",
    investmentInterests: "Centres d'intérêt en projet",
    investmentInterestsPlaceholder: "ex. Immobilier, Private equity, Infrastructure, Hôtellerie",
    referralSource: "Comment avez-vous connu Wealth Management - Global Real Assets ?",
    referralPlaceholder: "Recommandation, événement, réseau professionnel…",
    otherPrecision: "Autre (préciser)",
    interests: {
      immobilierFrance: "Immobilier France",
      immobilierInternational: "Immobilier international",
      hotellerie: "Hôtellerie",
      privateEquity: "Private equity",
      dettePrivee: "Dette privée / obligations",
      clubDeals: "Club deals / co-participation",
      infrastructure: "Infrastructure / énergie",
      autre: "Autre",
    },
    referrals: {
      recommandation: "Recommandation",
      partenaireCgp: "Partenaire / CGP",
      reseauPersonnel: "Réseau personnel / professionnel",
      linkedin: "LinkedIn",
      rechercheInternet: "Recherche internet",
      evenement: "Événement / webinar",
      presse: "Presse / média",
      autre: "Autre",
    },
    additionalMessage: "Message complémentaire",
    messagePlaceholder: "Informations complémentaires que vous souhaitez partager avec notre équipe…",
    submitBtn: "Soumettre ma candidature",
    disclaimer: "En soumettant ce formulaire, vous acceptez notre Politique de confidentialité et nos Conditions générales.",
    step1Title: "Candidature",
    step1Desc: "Soumettez vos informations pour évaluation par notre équipe.",
    step2Title: "Examen du profil",
    step2Desc: "Nous évaluerons votre profil et vous contacterons sous 2-3 jours ouvrés.",
    step3Title: "Accès à votre espace",
    step3Desc: "Après validation, vous recevrez un accès sécurisé à votre espace investisseur privé.",
    importantNote: "Important :",
    importantText: "Wealth Management - Global Real Assets opère en tant que plateforme privée. Nous ne proposons pas de services de projet au grand public. Tout projet comporte des risques et s'adresse uniquement aux investisseurs qualifiés.",
    existingPendingTitle: "Votre compte existe déjà",
    existingPendingMsg: "Un compte associé à cette adresse e-mail existe déjà et est en attente d'activation. Veuillez activer votre compte pour accéder au portail investisseur.",
    existingActiveTitle: "Vous avez déjà un compte",
    existingActiveMsg: "Un compte associé à cette adresse e-mail est déjà actif. Veuillez vous connecter pour accéder à votre espace investisseur.",
    resendActivationBtn: "Envoyer le lien d'activation",
    goToLoginBtn: "Se connecter",
    activationSentMsg: "Si un compte associé à cette adresse est en attente d'activation, un lien d'activation a été envoyé. Veuillez vérifier votre boîte de réception.",
    backToForm: "Retour au formulaire de demande",
    investorTypes: {
      individual: "Personne physique / Investisseur privé",
      company: "Société / Entité juridique",
      holding: "Holding / Family office",
      trust: "Trust / Fondation",
      other: "Autre entité juridique",
    },
    experienceLevels: {
      new: "Nouveau dans l'investissement privé",
      some: "Quelques expériences (1-5 projets)",
      experienced: "Expérimenté (5-15 projets)",
      sophisticated: "Investisseur averti (15+ projets)",
    },
  },

  investor: {
    portalLabel: "Portail investisseur",
    welcome: "Bienvenue,",
    portfolioOverview: "Synthèse de votre patrimoine et de votre activité.",
    portfolioSubtitle: "Vos souscriptions et leur stade d'avancement.",
    projectSummariesSubtitle: "Aperçu de chacun de vos projets, projet par projet.",
    invested: "Investi",
    quickAccessTitle: "Accès rapides",
    recentMovementsSubtitle: "Les derniers mouvements financiers liés à vos projets.",
    totalSubscribed: "Total souscrit",
    totalAllocated: "Montant attribué au projet",
    fundsTransferred: "Fonds versés",
    distributions: "Flux reçus",
    active: "actif",
    waitlisted: "en liste d'attente",
    portfolio: "Patrimoine",
    activity: "Activité récente",
    noInvestments: "Aucun projet en cours",
    noInvestmentsDesc: "Consultez les opportunités disponibles pour initier votre premier projet.",
    browseOpportunities: "Consulter les opportunités",
    noActivity: "Aucune activité récente à signaler.",
    complianceStatus: "Conformité documentaire",
    verified: "Validée",
    pending: "En attente",
    complianceVerified: "Votre dossier de conformité est à jour. Accès complet aux opportunités.",
    compliancePending: "Veuillez compléter vos documents de conformité pour accéder à l'ensemble des opportunités.",
    profileLabel: "Profil",
    profileComplete: "Votre profil investisseur est complet.",
    profileIncomplete: "Veuillez compléter votre profil pour faciliter le traitement de vos souscriptions.",
    recentMovements: "Derniers mouvements",
    completeCompliance: "Complétez vos documents de conformité pour accéder à l'ensemble des opportunités",
    subsNeedAttention: "souscription(s) nécessitent votre attention",
    docsUnderReview: "document(s) en cours de vérification par notre équipe — vous serez notifié(e) dès validation",
    documentsCenter: "Centre de documents",
    documentsCenterDesc: "Retrouvez l'ensemble de vos documents de projet et rapports.",
    noDocumentsAvailable: "Aucun document disponible pour le moment.",
    investorStatusLabel: "Statut investisseur",
    complianceVerifiedShort: "Conformité validée",
    compliancePendingShort: "Conformité en attente",
    completeYourProfile: "Complétez votre profil investisseur",
    completedPct: "complété",
    finalizeCompliance: "Finalisez votre dossier de conformité",
    kycRequired: "Documents KYC requis pour souscrire",
    pendingSubscriptions: "souscription(s) en attente",
    actionRequired: "Action requise de votre part",
    docsBeingReviewed: "document(s) en cours de vérification",
    teamReviewingDocs: "Notre équipe examine vos documents",
    stateActiveInvestor: "Investisseur actif",
    statePendingCompliance: "Conformité en attente",
    stateReadyToInvest: "Prêt à investir",
    stateCompleteCompliance: "Finalisez votre conformité",
    stateNewInvestor: "Complétez votre profil",
    statusSubmitted: "Soumis",
    statusUnderReview: "En revue",
    statusValidated: "Validé",
    statusFunded: "Financé",
    statusPartiallyFunded: "Partiellement financé",
    statusActive: "Actif",
    statusCompleted: "Clôturé",
    statusCancelled: "Annulé",
    statusPendingSignature: "En attente de documents",
    statusSigned: "Documents reçus",
    statusPendingFunding: "En attente de versement",
    statusFundingSubmitted: "Versement soumis",
    nextValidationInProgress: "Validation en cours",
    nextAwaitingFunds: "En attente de fonds",
    nextSignRequired: "Confirmation des conditions requise",
    nextFundingReview: "En cours de vérification",
    nextSharesIssued: "Parts émises",
    nextTopUpExpected: "Complément attendu",
    nextTermsRequired: "Vérifiez et confirmez les conditions",
    statusAwaitingTransfer: "Virement en attente",
    statusTransferConfirmed: "Virement confirmé",
    subStatus: {
      submitted: "Soumise",
      pending_review: "En cours de revue",
      compliance_incomplete: "Conformité incomplète",
      approved: "Approuvée",
      awaiting_transfer: "En attente de virement",
      transfer_confirmed: "Virement confirmé",
      funded: "Financée",
      allocated: "Allouée",
      partially_allocated: "Partiellement allouée",
      active: "Active",
      completed: "Terminée",
      rejected: "Refusée",
      cancelled: "Annulée",
    },
    stepSubscribed: "Souscrit",
    stepValidated: "Validé",
    stepFunded: "Financé",
    stepActive: "Actif",
    statusReceived: "Réalisé",
    statusSent: "Envoyé",
    statusExpected: "Prévu",
    statusPending: "En attente",
    upcomingDistributions: "Prochaines distributions",
    distConfirmed: "Confirmée",
    distRecurring: "Récurrente",
    distPlanned: "Planifiée",
    distAmountTbd: "Montant à définir",
    resyncDone: "Tableau de bord resynchronisé",
  },

  portfolio: {
    // LOT 537 v46 (Daniel 06/06/2026) — Alignement i18n sur le CMS publié.
    // Avant : "Mon portefeuille" → si le CMS échouait silencieusement (network,
    // CORS, cache), Marc voyait "Mon portefeuille" alors que Quentin voyait
    // "Votre portefeuille" (servi par cmsVal depuis site_content). Divergence
    // visible qui faisait croire à 2 layouts différents. Maintenant fallback
    // i18n identique au CMS → uniformité garantie même hors-ligne.
    title: "Votre patrimoine",
    subtitle: "Vue détaillée de vos positions, mouvements et événements financiers par projet.",
    // LOT 535 — Bug Emilie #6 (29/05/2026) : clé d'erreur manquante. La page
    // affichait littéralement "portfolio.fetchError" au lieu d'un message
    // français lisible quand l'appel API échouait.
    fetchError: "Impossible de charger votre patrimoine pour le moment. Réessayez dans quelques secondes ou contactez l'administrateur si le problème persiste.",
    projectsCount: "Projets détenus",
    totalApproved: "Montant total approuvé",
    totalTransferred: "Total versé",
    totalDistributed: "Total distribué",
    noPositions: "Aucune position enregistrée pour le moment.",
    downloadStatement: "Télécharger mon relevé",
    position: "position(s)",
    positionBreakdown: "Détail des positions",
    shares: "parts",
    requested: "Demandé",
    approved: "Approuvé",
    transferred: "Transféré",
    distributed: "Distribué",
    netPosition: "Position nette",
    recentMovements: "Mouvements récents",
    financialEvents: "Événements financiers",
  },

  opportunityInterests: {
    title: "Signaux d'int\u00e9r\u00eat",
    subtitle: "Signaux d'int\u00e9r\u00eat pour les opportunit\u00e9s \u00e0 venir. Distincts des souscriptions actives.",
    totalInterests: "Total signaux",
    knownInvestors: "Investisseurs connus",
    newProspects: "Nouveaux prospects",
    newSignals: "Nouveaux (non contact\u00e9s)",
    signalsCount: "signaux",
    allProjects: "Tous les projets",
    allStatuses: "Tous les statuts",
    statusNew: "Nouveau",
    statusContacted: "Contact\u00e9",
    statusConverted: "Converti",
    statusArchived: "Archiv\u00e9",
    colProject: "Projet",
    colContact: "Contact",
    colType: "Type",
    colAmount: "Montant estim\u00e9",
    colStatus: "Statut",
    colDate: "Date",
    colActions: "Actions",
    knownInvestor: "Investisseur connu",
    prospect: "Nouveau prospect",
    adminNotesPlaceholder: "Notes admin...",
    noInterests: "Aucun signal d'int\u00e9r\u00eat pour le moment.",
  },
  projects: {
    overline: "Portail investisseur",
    title: "Opportunités de projet",
    subtitle: "Opérations sélectionnées en actifs réels sur les marchés internationaux.",
    filterAll: "Toutes les opportunités",
    filterOpen: "Ouvertes à la souscription",
    filterComingSoon: "Prochainement",
    filterNearlyFull: "Quasi complètes",
    target: "Objectif de levée",
    minInvestment: "Ticket d'entrée",
    noOpportunities: "Aucune opportunité ne correspond à votre sélection",
    noOpportunitiesDesc: "Consultez l'ensemble des opportunités ou revenez ultérieurement pour découvrir de nouvelles opérations.",
    viewAll: "Voir tout",
    waitingList: "Liste d'attente",
    viewDetails: "Consulter le détail",
    statusOpen: "Ouvert",
    statusComingSoon: "Bientôt disponible",
    statusNearlyFull: "Presque complet",
    statusClosed: "Clôturé",
    statusFunded: "Financé",
    statusLabel: "Statut",
    ctaOpenSubscription: "Ouvert aux souscriptions",
    ctaExpressInterest: "Manifestation d'intérêt",
    ctaViewDetail: "Voir le détail",
    ctaInvest: "Investir",
    ctaDiscover: "Découvrir",
    untitled: "Projet sans nom",
    noSummary: "Description bientôt disponible",
    subscriptions: "Souscriptions",
  },

  projectDetail: {
    opportunities: "Opportunités",
    targetRaise: "Objectif de levée",
    reserved: "Réservé",
    minInvestment: "Investissement min.",
    available: "Disponible",
    fundraisingProgress: "Progression de la levée",
    tabOverview: "Présentation",
    tabDetails: "Structure & Détails",
    tabDocuments: "Documents",
    tabUpdates: "Actualités",
    tabFaq: "FAQ",
    investmentThesis: "Thèse de projet",
    aboutOpportunity: "À propos de cette opportunité",
    keyHighlights: "Points clés",
    assetClassLabel: "Classe d'actifs",
    stageLabel: "Phase",
    legalStructure: "Structure juridique",
    investmentTimeline: "Horizon de projet",
    locationLabel: "Localisation",
    visibilityLabel: "Visibilité",
    subscriptionWindow: "Fenêtre de souscription",
    openEnded: "Sans date de fin",
    riskInfo: "Informations importantes sur les risques",
    investInProject: "Investir dans ce projet",
    activeSubscription: "Souscription active",
    amountLabel: "Montant :",
    statusLabel: "Statut :",
    viewMyInvestments: "Voir dans Mes projets",
    onWaitingList: "Sur liste d'attente",
    waitingListNotify: "Vous serez notifié dès qu'une place se libère.",
    subscriptionAmount: "Montant de souscription (EUR)",
    minimum: "Minimum :",
    requestSubscription: "Demander à souscrire",
    investMore: "Souscrire à nouveau",
    submitting: "Envoi en cours...",
    subscriptionDisclaimer: "Il s'agit d'une expression d'intérêt non engageante. Notre équipe vous contactera pour valider les conditions et finaliser le processus de souscription.",
    joinWaitingList: "Rejoindre la liste d'attente",
    orJoinWaitingList: "Ou rejoindre la liste d'attente",
    notOpenForSubscriptions: "Ce projet n'est pas actuellement ouvert aux souscriptions.",
    questionsTitle: "Une question sur cette opération ?",
    questionsDesc: "Notre équipe de relations investisseurs est à votre disposition pour vous fournir des informations complémentaires, organiser un échange ou vous accompagner dans votre analyse.",
    contactIR: "Contacter notre équipe",
    noDocuments: "Aucun document disponible pour ce projet pour l'instant.",
    noUpdates: "Aucune actualité publiée pour ce projet.",
    noFaqs: "Aucune FAQ disponible pour ce projet.",
    subscriptionSuccess: "Votre expression d'intérêt a été transmise. Notre équipe l'examinera et vous contactera dans les meilleurs délais.",
    waitingListSuccess: "Vous avez été ajouté à la liste d'attente. Nous vous informerons dès qu'une place se libère.",
    assetClass: "Classe d'actifs",
    stage: "Phase",
    location: "Localisation",
    visibility: "Visibilit\u00e9",
    haveQuestions: "Des questions\u00a0?",
    irDescription: "Notre \u00e9quipe de relations investisseurs est \u00e0 votre disposition pour vous accompagner dans votre analyse.",
    minSubscription: "Investissement minimum",
    nonBindingDisclaimer: "Il s'agit d'une expression d'int\u00e9r\u00eat non engageante. Notre \u00e9quipe vous contactera pour finaliser.",
    notOpen: "Ce projet n'est pas actuellement ouvert aux souscriptions.",
    budgetBreakdown: "Budget du projet",
    yieldDisclaimer: "Les rendements projetes sont des estimations basees sur des hypotheses de travail. Ils ne constituent en aucun cas une garantie de rendement. L'projet comporte un risque de perte en capital.",
    comingSoonMsg: "Cette opportunit\u00e9 n'est pas encore ouverte. Inscrivez votre int\u00e9r\u00eat pour \u00eatre inform\u00e9 lors de son lancement.",
    registerInterest: "Manifester mon int\u00e9r\u00eat",
    estimatedAmount: "Montant de projet estim\u00e9",
    estimatedAmountPlaceholder: "Facultatif",
    interestMessage: "Message (facultatif)",
    interestMessagePlaceholder: "Informations compl\u00e9mentaires...",
    interestDisclaimer: "Il s'agit d'un signal d'int\u00e9r\u00eat, pas d'un engagement.",
    interestRegistered: "Int\u00e9r\u00eat enregistr\u00e9",
    interestRegisteredMsg: "Merci pour votre int\u00e9r\u00eat. Nous vous contacterons lorsque cette opportunit\u00e9 sera ouverte.",
    tabStructure: "Structure",
    viewInvestments: "Voir dans Mes projets",
  },

  subscriptions: {
    overline: "Mes projets",
    title: "Souscriptions",
    subtitle: "Suivez l'état de vos souscriptions et le détail de chaque projet.",
    thProject: "Projet",
    thAmount: "Montant",
    thApproved: "Montant approuvé",
    thStatus: "Statut",
    thDate: "Date",
    requested: "Demandé",
    approved: "Approuvé",
    noSubscriptions: "Aucune souscription en cours",
    noSubscriptionsDesc: "Consultez les opportunités disponibles pour initier votre premier projet.",
  },

  dataRoom: {
    title: "Salle de documents",
    subtitle: "Toute la documentation projet organisée par catégorie.",
    noDocuments: "Aucun document disponible pour ce projet pour le moment.",
    noDocumentsDesc: "Les documents seront mis à disposition au fur et à mesure de l'avancement du projet.",
    catTeaser: "Teaser",
    catTeaserDesc: "Synthèse du projet",
    catInvestmentMemo: "Note de projet",
    catInvestmentMemoDesc: "Analyse détaillée et thèse de projet",
    catLegal: "Documents juridiques",
    catLegalDesc: "Statuts, contrats, structure juridique",
    catSubscription: "Documents de souscription",
    catSubscriptionDesc: "Bulletin, conditions, formulaires",
    catReporting: "Reporting",
    catReportingDesc: "Rapports périodiques, valorisations",
    catUpdates: "Mises à jour projet",
    catUpdatesDesc: "Actualités et communications",
    catFaq: "FAQ",
    catFaqDesc: "Questions fréquentes",
    catSupporting: "Documents complémentaires",
    catSupportingDesc: "Plans, études, photos, présentations",
  },

  movementsPage: {
    overline: "Mes projets",
    title: "Mouvements de fonds",
    subtitle: "Historique des appels de fonds, transferts, distributions et remboursements.",
    thDate: "Date",
    thType: "Type",
    thProject: "Projet",
    thAmount: "Montant",
    thStatus: "Statut",
    thDirection: "Direction",
    directionIncoming: "Entrant",
    directionOutgoing: "Sortant",
    noMovements: "Aucun mouvement enregistré",
    noMovementsDesc: "Les mouvements de fonds apparaîtront ici dès le traitement de vos premières opérations.",
    statusCompleted: "Réalisé",
    statusReceived: "Reçu",
    statusSent: "Envoyé",
    statusExpected: "Prévu",
    statusPending: "En attente",
    statusIncomplete: "Incomplet",
  },

  notificationsPage: {
    overline: "Portail investisseur",
    title: "Notifications",
    subtitle: "Informations et mises à jour relatives à vos projets et à votre compte.",
    noNotifications: "Aucune notification",
    noNotificationsDesc: "Vous êtes à jour. Les prochaines notifications relatives à vos projets apparaîtront ici.",
    markAsRead: "Marquer comme lu",
  },

  waitingListPage: {
    overline: "Mes projets",
    title: "Liste d'attente",
    subtitle: "Projets pour lesquels vous avez exprimé votre intérêt et êtes en attente de disponibilité.",
    desired: "Souhaité :",
    position: "Position :",
    since: "Depuis :",
    waiting: "En attente",
    willNotify: "Vous serez notifié dès qu'une place se libère.",
    noEntries: "Aucune inscription en liste d'attente",
    noEntriesDesc: "Lorsque vous rejoignez la liste d'attente d'un projet complet, il apparaîtra ici.",
  },

  compliancePage: {
    overline: "Centre de conformité",
    title: "Vérification documentaire",
    subtitle: "Téléversez les documents requis pour compléter votre vérification réglementaire.",
    verified: "Conformité validée",
    verificationPending: "Vérification en attente",
    verifiedMsg: "Votre dossier de conformité est à jour. Vous bénéficiez d'un accès complet aux opportunités de projet.",
    pendingMsg: "document(s) approuvé(s). Veuillez téléverser les documents manquants ci-dessous pour finaliser votre dossier.",
    missing: "Manquant",
    replace: "Remplacer",
    reupload: "Mettre à jour",
    needHelp: "Besoin d'assistance ?",
    helpDesc: "Pour toute question sur les documents requis ou les délais de vérification, notre équipe de conformité se tient à votre disposition.",
    invalidFileType: "Type de fichier invalide. Veuillez téléverser un PDF, JPEG, PNG ou WebP.",
    fileTooLarge: "La taille du fichier dépasse la limite de 20 Mo.",
    uploadSuccess: "téléversé avec succès !",
    docTypes: {
      id_document: "Document d'identité",
      id_document_desc: "Passeport ou carte d'identité en cours de validité",
      proof_of_address: "Justificatif de domicile",
      proof_of_address_desc: "Facture de services ou relevé bancaire de moins de 3 mois",
      bank_details: "Coordonnées bancaires",
      bank_details_desc: "Relevé bancaire ou lettre de confirmation de compte",
      source_of_funds: "Origine des fonds",
      source_of_funds_desc: "Documentation attestant l'origine des fonds de projet",
      company_registration: "Immatriculation de la société",
      company_registration_desc: "Certificat d'immatriculation",
      articles_of_association: "Statuts de la société",
      articles_of_association_desc: "Statuts et documents de gouvernance",
      beneficial_owner_docs: "Documents des bénéficiaires effectifs",
      beneficial_owner_docs_desc: "Documents d'identité de tous les bénéficiaires effectifs (>25%)",
    },
  },

  profilePage: {
    overline: "Portail investisseur",
    title: "Paramètres du profil",
    subtitle: "Gérez vos informations personnelles et professionnelles.",
    personalInfo: "Informations personnelles",
    firstName: "Prénom",
    lastName: "Nom",
    emailLabel: "E-mail",
    emailNote: "Contactez le support pour modifier votre adresse e-mail.",
    phone: "Téléphone",
    addressSection: "Adresse",
    streetAddress: "Adresse",
    city: "Ville",
    postalCode: "Code postal",
    companyInfo: "Informations professionnelles (le cas échéant)",
    companyName: "Nom de la société",
    companyType: "Type de société",
    selectType: "Sélectionnez un type",
    companyTypes: {
      limited: "Société à responsabilité limitée",
      partnership: "Société de personnes",
      llp: "LLP",
      holding: "Holding",
      trust: "Trust",
      other: "Autre",
    },
    taxId: "Numéro fiscal / TVA",
    bankingInfo: "Informations bancaires",
    bankName: "Nom de la banque",
    iban: "IBAN",
    saveChanges: "Enregistrer les modifications",
    updateSuccess: "Profil mis à jour avec succès.",
  },

  waitingList: {
    title: "Liste d'attente",
    subtitle: "Projets pour lesquels vous avez exprim\u00e9 votre int\u00e9r\u00eat.",
    position: "Position",
    empty: "Aucune inscription en liste d'attente",
    emptyDesc: "Lorsque vous rejoignez la liste d'attente d'un projet, il appara\u00eetra ici.",
  },

  movements: {
    title: "Mouvements de fonds",
    subtitle: "Historique de tous les appels de fonds, transferts et distributions.",
    empty: "Aucun mouvement enregistr\u00e9",
    emptyDesc: "Les mouvements de fonds appara\u00eetront ici une fois le traitement commenc\u00e9.",
  },

  compliance: {
    title: "Mes documents",
    subtitle: "G\u00e9rez vos documents de conformit\u00e9 et suivez leur statut.",
    allValidated: "Conformit\u00e9 v\u00e9rifi\u00e9e",
    allValidatedDesc: "Tous vos documents requis ont \u00e9t\u00e9 valid\u00e9s. Vous avez pleinement acc\u00e8s aux opportunit\u00e9s de projet.",
    documentsRequired: "Documents requis",
    documentsRequiredDesc: "Veuillez t\u00e9l\u00e9verser les documents manquants pour compl\u00e9ter votre v\u00e9rification.",
    notUploaded: "Non t\u00e9l\u00e9vers\u00e9",
    reUpload: "Ret\u00e9l\u00e9verser",
    upload: "T\u00e9l\u00e9verser",
    importantInfo: "Informations importantes",
    importantInfoDesc: "Tous les documents sont examin\u00e9s par notre \u00e9quipe de conformit\u00e9 dans un d\u00e9lai de 2 \u00e0 3 jours ouvrables. Format accept\u00e9 : PDF.",
    support: "Besoin d'assistance ? Contactez notre \u00e9quipe :",
    tabKyc: "Documents KYC",
    tabChecklist: "Statut documents",
    tabContractual: "Documents de souscription",
    tabProject: "Documents projet (généraux)",
    tabSubscription: "Certificats & pièces",
    tabMovement: "Documents financiers",
    statusMissing: "Manquant",
    statusUploaded: "T\u00e9l\u00e9vers\u00e9",
    statusPendingReview: "En attente de v\u00e9rification",
    statusApproved: "Approuv\u00e9",
    statusRejected: "Rejet\u00e9",
    statusExpired: "Expir\u00e9",
    statusReplaced: "Remplac\u00e9",
    statusArchived: "Archiv\u00e9",
    checklistProgress: "Progression des documents",
    checklistEmpty: "Votre checklist documentaire sera mise \u00e0 jour par notre \u00e9quipe.",
    actionNeeded: "Documents manquants",
    pleaseProvide: "Merci de transmettre les documents suivants \u00e0 notre \u00e9quipe.",
    statusReceived: "Re\u00e7u",
    required: "Requis",
    optional: "Optionnel",
    expired: "Expir\u00e9",
    version: "Version",
    reviewerNote: "Note du v\u00e9rificateur",
    noProjectDocs: "Aucun document projet disponible.",
    noSubscriptionDocs: "Aucun document de souscription.",
    noMovementDocs: "Aucun document de mouvement.",
    noContractualDocs: "Aucun document contractuel pour le moment.",
    documented: "Document\u00e9",
    pendingClassification: "\u00c0 classer",
    availability: "Disponibilit\u00e9",
    uploadFor: "T\u00e9l\u00e9verser pour",
    actionRequired: "Action requise",
    expiringDocsBanner: "Certains documents arrivent \u00e0 expiration ou sont expir\u00e9s. Veuillez les mettre \u00e0 jour.",
    expiresIn: "Expire dans",
    expiredSince: "Expir\u00e9 depuis",
    days: "jours",
    docTypes: {
      id_document: "Document d'identit\u00e9",
      proof_of_address: "Justificatif de domicile",
      source_of_funds: "Origine des fonds",
      tax_declaration: "D\u00e9claration fiscale",
      bank_details: "Coordonn\u00e9es bancaires / RIB",
      bank_statement: "Relev\u00e9 bancaire",
      accreditation: "Attestation investisseur qualifi\u00e9",
      subscription_agreement: "Convention de souscription",
      legal_notice: "Note juridique",
      investor_report: "Rapport investisseur",
      financial_statement: "\u00c9tat financier",
      corporate_doc: "Document soci\u00e9t\u00e9",
      signed_form: "Bulletin de souscription (hors ligne)",
      allocation_doc: "Document d'allocation",
      payment_confirmation: "Confirmation de paiement",
      proof_of_transfer: "Preuve de virement",
      payment_evidence: "Justificatif de paiement",
    },
    docDescs: {
      id_document: "Passeport ou carte d'identit\u00e9 en cours de validit\u00e9",
      proof_of_address: "Justificatif r\u00e9cent de moins de 3 mois",
      tax_declaration: "Derni\u00e8re d\u00e9claration de revenus",
      bank_details: "RIB ou relev\u00e9 bancaire",
      source_of_funds: "Attestation de l'origine des fonds de projet",
      accreditation: "Attestation d'investisseur qualifi\u00e9 ou professionnel",
    },
  },

  profile: {
    title: "Paramètres du profil",
    subtitle: "Gérez vos informations personnelles et professionnelles.",
    personalInfo: "Informations personnelles",
    firstName: "Prénom",
    lastName: "Nom",
    phone: "Téléphone",
    dateOfBirth: "Date de naissance",
    nationality: "Nationalité",
    addressInfo: "Adresse",
    address: "Adresse",
    city: "Ville",
    postalCode: "Code postal",
    country: "Pays",
    taxResidence: "Résidence fiscale",
    investorProfile: "Profil investisseur",
    investorType: "Type d'investisseur",
    selectType: "Sélectionnez un type",
    saveChanges: "Enregistrer les modifications",
    saved: "Profil mis à jour avec succès",
    sectionPersonal: "Informations personnelles",
    sectionAddress: "Adresse",
    sectionInvestor: "Profil investisseur",
    sectionTax: "Fiscalité",
    progression: "Progression",
    completeProfileHint: "Complétez votre profil pour accéder à toutes les fonctionnalités.",
    profileComplete: "Profil complet",
    completed: "complété",
    personalInfoTitle: "Informations personnelles",
    personalInfoDesc: "Ces informations sont nécessaires pour identifier votre compte investisseur.",
    addressTitle: "Adresse de résidence",
    addressDesc: "Adresse utilisée pour la correspondance et les documents officiels.",
    investorTitle: "Profil investisseur",
    investorDesc: "Sélectionnez le type d'entité à travers laquelle vous investissez.",
    taxTitle: "Informations fiscales",
    taxDesc: "Résidence fiscale pour la conformité réglementaire.",
    taxHint: "Pays dans lequel vous êtes résident fiscal.",
    prevSection: "Section précédente",
    nextSection: "Section suivante",
    typeIndividual: "Personne physique",
    typeIndividualDesc: "Personne physique investissant à titre personnel",
    typeCompany: "Société",
    typeCompanyDesc: "Investissement via une entité commerciale",
    typeHolding: "Holding / SPV",
    typeHoldingDesc: "Investissement via une structure holding ou SPV",
    typeTrust: "Trust / Fiducie",
    typeTrustDesc: "Structure gérée (trust, fiduciaire)",
  },

  sponsor: {
    portalLabel: "Portail commandité",
    welcome: "Bienvenue,",
    overview: "Vue d'ensemble de vos projets et de leur avancement.",
    totalProjects: "Projets",
    activeProjects: "Projets actifs",
    totalRaised: "Total levé",
    totalInvestors: "Investisseurs engagés",
    yourProjects: "Vos projets",
    noProjects: "Aucun projet assigné.",
    noProjectsDesc: "Vos projets apparaîtront ici une fois référencés par l'équipe Wealth Management - Global Real Assets.",
    myProjects: "Mes projets",
    myProjectsSubtitle: "Tous les projets où vous êtes référencé comme commandité ou créateur du projet.",
    documentsTitle: "Documents",
    documentsSubtitle: "Gérez et téléversez les documents liés à vos projets.",
    noDocuments: "Aucun document téléversé pour le moment.",
    fundraisingTitle: "Progression de la levée",
    fundraisingSubtitle: "Suivez l'avancement de la levée de fonds sur l'ensemble de vos projets.",
    noFundraisingData: "Aucune donnée de levée disponible pour le moment.",
    progress: "Progression",
    target: "Objectif",
    raised: "Levé",
    remaining: "Restant",
    investorCount: "Investisseurs",
    pendingSubs: "souscription(s) en attente de traitement",
    investmentThesis: "Thèse de projet",
    description: "Description",
    kpi: {
      deliverables: "Obligations",
      overdue: "En retard",
      pending: "En attente",
      submitted: "Soumis",
      approved: "Approuvés",
      waived: "Dispensés",
    },
    pendingActionTitle: "Actions requises",
    pendingActionDesc: "Livrables en attente de votre action.",
    recentUpdatesTitle: "Communications récentes",
    noRecentUpdates: "Aucune communication récente.",
    pendingDocsTitle: "Documents en revue",
    noPendingDocs: "Aucun document en attente de revue.",
    submitDeliverable: "Soumettre",
    viewProject: "Voir le projet",
    keyHighlights: "Points clés de l'opération",
    fundraisingProgressTitle: "Avancement de la levée",
    totalSubs: "Total souscriptions",
    allocated: "Alloué",
    pendingReview: "En attente de revue",
    overview_tab: "Présentation",
    documents_tab: "Documents",
    updates_tab: "Actualités",
    noDocumentsAvailable: "Aucun document disponible.",
    noUpdatesYet: "Aucune actualité publiée.",
    backToProjects: "Retour aux projets",
    targetRaise: "Objectif de levée",
    amountRaised: "Montant levé",
    allocatedInvestors: "Investisseurs engagés",
    pendingSubsLabel: "Souscriptions en attente",
    viewAllLink: "Voir tout",
    viewDetails: "Consulter le détail",
    noProjectsAssigned: "Aucun projet assigné à votre compte pour le moment.",
    obligations: "Obligations",
    obligationsSubtitle: "Livrables et documents attendus pour vos projets.",
    obligationsSummary: "Résumé",
    noObligations: "Aucune obligation pour le moment.",
    noObligationsDesc: "Les livrables attendus apparaîtront ici.",
    submitDeliverable: "Soumettre",
    submittedOn: "Soumis le",
    reviewedOn: "Évalué le",
    dueDate: "Échéance",
    noDueDate: "Pas d'échéance",
    overdueSince: "En retard depuis",
    dropOrClick: "Déposez un fichier ici ou cliquez pour sélectionner",
    resubmitFile: "Déposer un nouveau fichier pour soumettre à nouveau",
    confirmSubmit: "Confirmer la soumission",
    resubmissionNote: "Ce fichier remplacera la soumission précédente.",
    submitSuccess: "Livrable soumis avec succès.",
    changesRequested: "Modifications demandées",
    reviewerFeedback: "Retour de l'évaluateur",
    deliverableStatus: {
      pending: "En attente",
      submitted: "Soumis",
      under_review: "En revue",
      approved: "Approuvé",
      overdue: "En retard",
      waived: "Dispensé",
    },
    deliverableCategory: {
      reporting: "Reporting",
      legal: "Juridique",
      operational: "Opérationnel",
      financial: "Financier",
      documentation: "Documentation",
    },
    deliverablePriority: {
      low: "Basse",
      medium: "Moyenne",
      high: "Haute",
      critical: "Critique",
    },
  },

  admin: {
    // Re-passe recette Sprint 1 — clés brutes purgées
    crm: "CRM",
    filterActive: "Actif",
    filterFunded: "Financé",
    investmentThesis: "Thèse d'investissement",
    movOutgoing: "Sortant",
    consoleLabel: "Console d'administration",
    dashboardTitle: "Tableau de bord opérationnel",
    dashboardSubtitle: "Pilotez les accès investisseurs, la conformité, les souscriptions et les opérations en cours.",
    newRequests: "Nouvelles demandes",
    pendingCompliance: "Conformité en attente",
    openSubscriptions: "Souscriptions ouvertes",
    activeProjects: "Projets actifs",
    waitingListStat: "Liste d'attente",
    pendingMovements: "Mouvements en attente",
    createProject: "Créer un nouveau projet",
    reviewRequests: "Examiner les demandes",
    reviewDocuments: "Vérifier les documents",
    recordMovement: "Enregistrer un mouvement",
    movDerived: "depuis souscription",
    operationsPipeline: "Opérations du jour",
    operationsPipelineDesc: "Actions requises aujourd'hui",
    recentAccessRequests: "Demandes d'accès récentes",
    recentSubscriptions: "Souscriptions récentes",
    noRecentRequests: "Aucune demande récente.",
    noRecentSubscriptions: "Aucune souscription récente.",
    smWidgetTitle: "Marché secondaire",
    smWidgetNoActivity: "Aucune activité sur le marché secondaire.",
    smUnderReview: "En examen",
    smEligible: "Éligibles",
    smMatched: "Appariées",
    smPendingApproval: "Att. approbation",
    smPendingDocs: "Att. documents",
    smPendingTransfer: "Att. transfert",
    smCompleted: "Finalisées",
    smViewAll: "Voir le marché secondaire",
    subscriptionPipeline: "Pipeline de souscription",
    investorOverview: "Activité des investisseurs",
    totalInvestors: "investisseurs au total",
    recentLogins: "Connexions récentes",
    noRecentActivity: "Aucune activité investisseur récente.",
    subDetail: {
      title: "Détail de la souscription",
      backToList: "Retour aux souscriptions",
      investorSection: "Profil investisseur",
      investorType: "Type d'investisseur",
      nationality: "Nationalité",
      kycStatus: "Statut KYC",
      kycValidated: "KYC Validé",
      kycPending: "KYC En attente",
      docsApproved: "documents approuvés",
      investmentSection: "Détails de l'investissement",
      requestedAmount: "Montant demandé",
      approvedAmount: "Montant approuvé",
      investmentType: "Type de projet",
      entityType: "Type d'entité",
      entityName: "Nom de l'entité",
      subscriptionDate: "Date de souscription",
      lastUpdated: "Dernière mise à jour",
      project: "Projet",
      location: "Localisation",
      statusSection: "Statut & Workflow",
      currentStatus: "Statut actuel",
      transitionTo: "Passer à",
      confirmTransition: "Confirmer la transition",
      transitionSuccess: "Statut mis à jour avec succès",
      fundingSection: "Progression du transfert",
      fundingStatus: "Statut du transfert",
      fundingNotYet: "Transfert non encore confirmé",
      fundingConfirmed: "Transfert confirmé",
      fundingPartial: "Transfert partiel",
      confirmFunding: "Confirmer la réception des fonds",
      fundingDate: "Date de réception",
      fundingAmount: "Montant reçu",
      confirmFundingAction: "Confirmer le transfert",
      timelineSection: "Chronologie opérationnelle",
      timelineEmpty: "Aucune activité opérationnelle enregistrée.",
      timelineStatusChange: "Statut changé à",
      timelineMovement: "Mouvement de fonds",
      timelineDocument: "Document",
      by: "par",
      documentsSection: "Documents de souscription",
      documentsEmpty: "Aucun document lié à cette souscription.",
      movementsSection: "Mouvements de fonds",
      movementsEmpty: "Aucun mouvement enregistré.",
      distributionsSection: "Distributions",
      distributionsEmpty: "Aucune distribution traitée.",
      internalNotes: "Notes internes",
      notesPlaceholder: "Ajouter des notes internes pour cette souscription...",
      saveNotes: "Enregistrer les notes",
      notesSaved: "Notes enregistrées",
      statusSubmitted: "Soumise",
      statusPendingReview: "En cours d'examen",
      statusInReview: "En cours d'examen",
      statusComplianceIncomplete: "Conformité incomplète",
      statusApproved: "Contrat en attente de signature",
      statusContractPendingSignature: "Contrat en attente de signature",
      statusAwaitingTransfer: "En attente de virement",
      statusTransferConfirmed: "Virement confirmé",
      statusAllocated: "Active",
      statusPartiallyAllocated: "Partiellement financée",
      statusPartiallyFunded: "Partiellement financée",
      statusActive: "Active",
      statusCompleted: "Sortie",
      statusRejected: "Rejetée",
      statusCancelled: "Annulée",
      statusPendingSignature: "Contrat en attente de signature",
      statusSigned: "En attente de virement",
      statusPendingFunding: "En attente de virement",
      statusFundingSubmitted: "Virement confirmé",
      statusFunded: "Active",
      signatureTracking: "Suivi contractuel",
      noSignatureRequests: "Aucune donnée de suivi contractuel.",
      contractTracking: "Suivi contractuel hors ligne",
      termsAccepted: "Conditions acceptées",
      fundingProofs: "Justificatifs de versement",
      approvedAmount: "Montant approuvé",
    },

    accessRequestsTitle: "Demandes d'accès",
    accessRequestsSubtitle: "Examinez et gérez les candidatures des investisseurs.",
    accessRequestDetails: "Détails de la demande",
    filterNew: "Nouvelles",
    filterInReview: "En cours d'examen",
    filterApproved: "Approuvées",
    filterRejected: "Rejetées",
    filterAll: "Toutes",
    thName: "Nom",
    thEmail: "E-mail",
    thCountry: "Pays",
    thType: "Type",
    thDate: "Date",
    thStatus: "Statut",
    thActions: "Actions",
    noAccessRequests: "Aucune demande d'accès trouvée.",
    markInReview: "Marquer en cours d'examen",
    investorTypeLabel: "Type d'investisseur",
    investmentRangeLabel: "Tranche de projet",
    experienceLabel: "Expérience",
    referralLabel: "Source de recommandation",
    investmentInterestLabel: "Centres d'intérêt",
    allReferralSources: "Toutes les sources",
    allInterests: "Tous les intérêts",
    messageLabel: "Message",
    currentStatus: "Statut actuel",

    investorManagement: "Gestion des investisseurs",
    investorManagementSubtitle: "Consultez, filtrez et gérez les investisseurs inscrits.",
    searchPlaceholder: "Rechercher par nom ou e-mail...",
    allStatuses: "Tous les statuts",
    statusActive: "Actif",
    statusPendingActivation: "Activation en attente",
    statusSuspended: "Suspendu",
    statusDraft: "Brouillon",
    statusOpen: "Ouvert",
    statusComingSoon: "Bientôt disponible",
    statusNearlyFull: "Presque complet",
    statusClosed: "Fermé",
    statusFullyFunded: "Entièrement financé",
    movIncoming: "Appel de fonds",
    movDistribution: "Distribution",
    movReimbursement: "Remboursement",
    thInvestor: "Investisseur",
    thCompliance: "Conformité",
    thSubscribed: "Souscrit",
    activate: "Activer",
    suspend: "Suspendre",
    superAdminOnly: "Action réservée au Super Admin.",
    complianceDocuments: "Documents de conformité",
    noComplianceDocs: "Aucun document de conformité téléversé.",
    generateStatement: "Relevé portefeuille",
    subscriptionsLabel: "Souscriptions",
    noSubscriptions: "Aucune souscription.",
    internalNotes: "Notes internes",
    addNote: "Ajouter une note...",

    complianceReviewTitle: "Revue de conformité",
    complianceReviewSubtitle: "Vérifiez et validez les documents de conformité des investisseurs.",
    filterPending: "En attente de vérification",
    documentReview: "Vérification du document",
    reviewerNotes: "Notes du vérificateur (visibles par l'investisseur)",
    reviewerNotesPlaceholder: "Ajouter des notes pour l'investisseur...",
    requestInfo: "Demander des informations",
    thDocType: "Type de document",
    thFilename: "Nom du fichier",
    thUploaded: "Téléversé le",
    noDocumentsToReview: "Aucun document à vérifier.",

    // Document Center
    documentCenterTitle: "Centre de documents",
    documentCenterSubtitle: "Gérez, vérifiez et suivez tous les documents de la plateforme.",
    allCategories: "Toutes catégories",
    categoryInvestor: "Investisseur",
    categoryProject: "Projet",
    categorySubscription: "Souscription",
    categoryMovement: "Mouvement",
    allStatuses: "Tous les statuts",
    statusMissing: "Manquant",
    statusUploaded: "Téléversé",
    statusPendingReview: "En attente",
    statusApproved: "Approuvé",
    statusRejected: "Rejeté",
    statusExpired: "Expiré",
    statusReplaced: "Remplacé",
    statusArchived: "Archivé",
    searchDocuments: "Rechercher par nom, type ou investisseur...",
    thCategory: "Catégorie",
    thOwner: "Propriétaire",
    thProject: "Projet",
    thVersion: "Version",
    thExpiry: "Expiration",
    thReviewedBy: "Vérifié par",
    reviewDocument: "Vérifier le document",
    approveDocument: "Approuver",
    rejectDocument: "Rejeter",
    requestReplacement: "Demander remplacement",
    archiveDocument: "Archiver",
    markExpired: "Marquer expiré",
    internalNoteLabel: "Notes internes (non visibles)",
    expirationDateLabel: "Date d'expiration",
    uploadDocumentAdmin: "Téléverser un document",
    selectCategory: "Sélectionnez une catégorie",
    selectDocType: "Sélectionnez un type",
    selectInvestorDoc: "Sélectionnez un investisseur",
    selectProjectDoc: "Sélectionnez un projet",
    pendingReviewCount: "en attente de vérification",
    totalDocuments: "documents au total",
    versionHistory: "Historique des versions",
    noVersionHistory: "Aucune version antérieure.",
    expiryMonitoring: "Suivi des expirations",
    expiredDocuments: "Documents expirés",
    nearingExpiry: "Expiration proche",
    daysRemaining: "jours restants",
    daysOverdue: "jours de retard",
    noExpiryAlerts: "Aucune alerte d'expiration.",
    expiryAlertBanner: "Des documents nécessitent votre attention",
    warningWindow: "Alerte à",
    viewExpiring: "Voir les documents concernés",
    docTypeLabels: {
      id_document: "Document d'identité",
      proof_of_address: "Justificatif de domicile",
      tax_declaration: "Déclaration fiscale",
      bank_details: "Coordonnées bancaires / RIB",
      source_of_funds: "Origine des fonds",
      accreditation: "Attestation investisseur qualifié",
      subscription_agreement: "Convention de souscription",
      legal_notice: "Note juridique",
      investor_report: "Rapport investisseur",
      financial_statement: "État financier",
      corporate_doc: "Document société",
      signed_form: "Bulletin de souscription (hors ligne)",
      allocation_doc: "Document d'allocation",
      payment_confirmation: "Confirmation de paiement",
      proof_of_transfer: "Preuve de virement",
      payment_evidence: "Justificatif de paiement",
    },

    projectsTitle: "Projets",
    projectsSubtitle: "Gérez les opérations de projet, le suivi et les paramètres de chaque projet.",
    newProject: "Nouveau projet",
    thProject: "Projet",
    thAssetClass: "Classe d'actifs",
    thTarget: "Objectif",
    thReserved: "Réservé",
    thSubs: "Souscrip.",
    thWaiting: "Attente",
    noProjects: "Aucun projet.",
    createFirstProject: "Créer le premier projet",
    editProject: "Modifier le projet",
    saveProject: "Enregistrer le projet",
    duplicate: "Dupliquer",
    preview: "Aperçu",
    basicInfo: "Informations de base",
    detailsContent: "Détails & Contenu",
    financials: "Financier",
    documentsTab: "Documents",
    faqsRisk: "FAQ & Risques",
    projectName: "Nom du projet",
    subtitle: "Sous-titre",
    location: "Localisation",
    assetClass: "Classe d'actifs",
    stage: "Phase",
    legalStructure: "Structure juridique",
    timeline: "Horizon",
    targetRaise: "Objectif de levée (EUR)",
    minSubscription: "Souscription minimum (EUR)",
    windowStart: "Début de la fenêtre de souscription",
    windowEnd: "Fin de la fenêtre de souscription",
    investmentThesisLabel: "Thèse de projet",
    fullDescription: "Description complète",
    keyHighlightsLabel: "Points clés",
    addHighlight: "Ajouter un point clé...",
    riskDisclosures: "Avertissements sur les risques",
    addRisk: "Ajouter un avertissement...",
    faqSection: "Questions fréquentes",
    question: "Question...",
    answer: "Réponse...",
    addFaq: "Ajouter une FAQ",
    projectDocuments: "Documents du projet",
    uploadDocument: "Téléverser un document",
    saveFirst: "Enregistrez d'abord le projet, puis téléversez des documents.",
    noDocuments: "Aucun document téléversé.",
    statusLabel: "Statut",
    visibilityLabel: "Visibilité",
    waitingListLabel: "Liste d'attente",

    subscriptionsTitle: "Souscriptions",
    subscriptionsSubtitle: "Suivez et traitez les demandes de souscription des investisseurs.",
    manageSubscription: "Gérer la souscription",
    thRequested: "Demandé",
    thApproved: "Approuvé",
    approvedAmountLabel: "Montant approuvé (EUR)",
    allocate: "Allouer",
    awaitingTransfer: "En attente de transfert",
    noSubscriptionsFound: "Aucune souscription trouvée.",
    filterSubmitted: "Soumises",
    filterPendingReview: "En attente",
    filterAllocated: "Allouées",

    // Subscription creation dialog
    newSubscription: "Nouvelle souscription",
    selectInvestor: "Sélectionner un investisseur",
    subscriptionDetails: "Détails de la souscription",
    searchInvestorPlaceholder: "Rechercher par nom ou e-mail...",
    searchMinChars: "Saisissez au moins 2 caractères",
    noInvestorsFound: "Aucun investisseur trouvé",
    searching: "Recherche...",
    changeInvestor: "Modifier",
    projectLabel: "Projet",
    selectProject: "Sélectionner un projet...",
    amountLabel: "Montant (EUR)",
    typeLabel: "Type",
    initialStatusLabel: "Statut initial",
    internalNotesLabel: "Notes internes",
    internalNotesPlaceholder: "Note facultative...",
    summaryLabel: "Résumé",
    createSubscription: "Créer la souscription",
    creating: "Création en cours...",
    cancelLabel: "Annuler",
    selectInvestorAndProject: "Veuillez sélectionner un investisseur et un projet.",
    enterValidAmount: "Veuillez saisir un montant valide.",

    waitingListTitle: "Listes d'attente",
    waitingListSubtitle: "Gérez les inscriptions en liste d'attente des projets.",
    thDesiredAmount: "Montant souhaité",
    thJoined: "Inscrit le",
    convertToSubscription: "Convertir en souscription",
    noWaitingListEntries: "Aucune inscription en liste d'attente.",

    movementsTitle: "Mouvements",
    movementsSubtitle: "Enregistrez et suivez les mouvements financiers liés aux opérations.",
    createMovement: "Enregistrer un mouvement",
    recordMovementTitle: "Enregistrer un mouvement",
    thMovDate: "Date",
    thMovInvestor: "Investisseur",
    thMovType: "Type",
    thMovProject: "Projet",
    thMovAmount: "Montant",
    thMovStatus: "Statut",
    selectInvestor: "Sélectionnez un investisseur",
    selectProject: "Sélectionnez un projet (optionnel)",
    typeIncoming: "Entrant (de l'investisseur)",
    typeDistribution: "Distribution (vers l'investisseur)",
    typeRefund: "Remboursement",
    statusExpected: "Prévu",
    statusPendingConfirmation: "Confirmation en attente",
    statusReceived: "Reçu",
    statusSent: "Envoyé",
    statusReconciled: "Rapproché",
    currency: "Devise",
    comment: "Commentaire",
    noMovements: "Aucun mouvement enregistré.",

    settingsTitle: "Paramètres",
    settingsSubtitle: "Configuration et paramètres de la plateforme.",
    settingsComingSoon: "Gestion des paramètres bientôt disponible.",
    auditLogsTitle: "Journal d'audit",
    auditLogsSubtitle: "Suivez l'activité et les modifications de la plateforme.",
    auditLogsComingSoon: "Consultation du journal d'audit bientôt disponible.",
    sponsorsTitle: "Gestion des commandités",
    sponsorsSubtitle: "Gérez les commandités et partenaires des projets.",
    noSponsors: "Aucun commandité enregistré.",
    notificationsTitle: "Notifications",
    notificationsSubtitle: "Envoyez des notifications aux investisseurs.",
    notificationsComingSoon: "Centre de notifications bientôt disponible.",
  },

  sponsorOps: {
    title: "Opérations commandités",
    subtitle: "Suivi des livrables et obligations des commandités.",
    overview: "Vue d'ensemble",
    totalDeliverables: "Livrables totaux",
    overdue: "En retard",
    pendingSubmission: "En attente",
    pendingReview: "Soumis / en revue",
    approved: "Approuvés",
    sponsorBreakdown: "Par commandité",
    urgentItems: "Actions urgentes",
    noUrgent: "Aucune action urgente.",
    createDeliverable: "Nouveau livrable",
    deliverablesList: "Livrables",
    noDeliverables: "Aucun livrable.",
    filterSponsor: "Filtrer par commandité",
    filterProject: "Filtrer par projet",
    filterStatus: "Filtrer par statut",
    filterCategory: "Filtrer par catégorie",
    allSponsors: "Tous les commandités",
    allProjects: "Tous les projets",
    allStatuses: "Tous les statuts",
    allCategories: "Toutes les catégories",
    reviewSubmission: "Évaluer la soumission",
    approve: "Approuver",
    requestChanges: "Demander des modifications",
    waive: "Dispenser",
    reviewerNotes: "Notes de revue",
    adminNotes: "Notes internes",
    project: "Projet",
    sponsor: "Commandité",
    priority: "Priorité",
    category: "Catégorie",
    description: "Description",
    projectProgress: "Avancement par projet",
    waived: "Dispensés",
    createTask: "Créer une tâche",
    applyPlaybook: "Appliquer un playbook",
    linkedTasks: "Tâches liées",
    linkedTasksOpen: "ouvertes",
    noLinkedTasks: "Aucune tâche liée.",
    suggestedFollowup: "Suivi suggéré",
    taskTitle: "Titre de la tâche",
    taskPriority: "Priorité",
    taskAssignee: "Assigné à",
    taskDueDate: "Échéance",
    selectPlaybook: "Sélectionner un playbook",
    playbook: "Playbook",
    noPlaybooks: "Aucun playbook actif disponible.",
    tasksGenerated: "tâche(s) générée(s)",
    viewLinkedTasks: "Voir les tâches",
    createTaskFromDeliverable: "Créer une tâche de suivi",
    applyPlaybookToDeliverable: "Appliquer un playbook opérationnel",
    followupOverdue: "Livrable en retard — aucune tâche de suivi active",
    followupReview: "Soumission en revue — aucune tâche de suivi active",
  },

  goLive: {
    title: "Production & go-live",
    subtitle: "Tableau de bord de préparation au lancement et suivi des migrations.",
    overallReadiness: "État de préparation global",
    runbookRef: "Consultez les runbooks opérationnels (docs/) pour les procédures de déploiement, sécurité, sauvegarde et vérification post-lancement.",
    readinessOk: "Opérationnel",
    readinessWarning: "Avertissements",
    readinessBlocked: "Bloqué",
    readinessNeedsReview: "Revue nécessaire",
    categoryReady: "Prêt",
    categoryItems: "points",
    noIssues: "Aucun point de blocage.",
    states: {
      ok: "OK",
      warning: "Avertissement",
      blocked: "Bloqué",
      needs_review: "Revue nécessaire",
    },
    categories: {
      platform_config: "Configuration plateforme",
      // Re-passe recette Sprint 1 — clés brutes détectées à l'écran :
      // security_config et content_integrations manquaient (Lot 343B).
      security_config: "Sécurité & Authentification",
      projects: "Projets",
      investors: "Investisseurs",
      documents: "Conformité documentaire",
      financial: "Données financières",
      content_integrations: "Contenu & intégrations",
      import_qa: "Import & QA",
    },
    blockersCount: "blocage(s) go-live",
    noBlockers: "Aucun blocage",
    waves: {
      title: "Vagues de migration",
      subtitle: "Gestion des vagues d'import et de migration.",
      create: "Nouvelle vague",
      name: "Nom de la vague",
      description: "Description",
      notes: "Notes opérationnelles",
      targetEntities: "Entités cibles",
      noWaves: "Aucune vague de migration.",
      sessions: "Sessions d'import liées",
      noSessions: "Aucune session liée.",
      linkSession: "Lier une session d'import",
      sessionId: "ID de la session",
      totalCreated: "Enregistrements créés",
      totalRejected: "Enregistrements rejetés",
      qaFlags: "Indicateurs QA",
      noQaFlags: "Aucun indicateur de qualité.",
      status: {
        planned: "Planifiée",
        in_progress: "En cours",
        review_needed: "Revue nécessaire",
        validated: "Validée",
        go_live: "Go-live",
      },
      backToOnboarding: "Retour à la mise en place",
      linkedOnboarding: "Mise en place liée",
    },
    postImport: {
      title: "Revue post-import",
      subtitle: "Contrôle qualité des données importées.",
      importedCounts: "Données importées",
      projectsReview: "Revue par projet",
      investorsReview: "Revue par investisseur",
      ok: "Conforme",
      needsReview: "Revue nécessaire",
      noImportedData: "Aucune donnée importée.",
      issues: {
        no_subscriptions: "Aucune souscription",
        pending_docs: "Documents en attente",
        rejected_docs: "Documents refusés",
        not_activated: "Non activé",
        kyc_incomplete: "KYC incomplet",
      },
    },
  },

  importToolkit: {
    title: "Import de données",
    subtitle: "Console d'import opérationnel pour la mise en place de projets, d'investisseurs et de positions.",
    selectDataset: "Type de données",
    uploadFile: "Charger un fichier Excel",
    uploadHint: "Glissez un fichier .xlsx ou cliquez pour sélectionner",
    downloadTemplate: "Télécharger le modèle",
    validate: "Valider (aperçu)",
    execute: "Exécuter l'import",
    cancel: "Annuler",
    backToList: "Retour",
    step1: "1. Sélectionner",
    step2: "2. Valider",
    step3: "3. Résultat",
    validating: "Validation en cours...",
    executing: "Import en cours...",
    validationPassed: "Validation réussie",
    validationFailed: "Erreurs détectées",
    canExecute: "Prêt pour l'import",
    cannotExecute: "Corrigez les erreurs et ré-uploadez le fichier.",
    importComplete: "Import terminé",
    importPartial: "Import partiel",
    importFailed: "Import échoué",
    totalRecords: "Lignes analysées",
    validRecords: "Lignes valides",
    errorsCount: "Erreurs",
    warningsCount: "Avertissements",
    created: "Créés",
    skipped: "Ignorés",
    rejected: "Rejetés",
    row: "Ligne",
    status: "Statut",
    messages: "Messages",
    ok: "OK",
    warning: "Avertissement",
    error: "Erreur",
    dependencyWarning: "Dépendances manquantes",
    historyTitle: "Historique des imports",
    historyEmpty: "Aucun import effectué pour le moment.",
    dataset: "Données",
    mode: "Mode",
    file: "Fichier",
    date: "Date",
    result: "Résultat",
    dryRun: "Validation",
    execution: "Exécution",
    by: "Par",
    detail: "Détail",
    deleteSession: "Supprimer",
    deleteConfirm: "Supprimer cette session d'import ?",
    projects: "Projets",
    investors: "Investisseurs",
    subscriptions: "Souscriptions",
    movements: "Mouvements",
    documents: "Documents",
    requiredFields: "Champs obligatoires",
    optionalFields: "Champs optionnels",
    dependsOn: "Nécessite l'import préalable de",
    importOrder: "Ordre d'import recommandé",
    orderNote: "Respectez l'ordre d'import pour garantir la cohérence des références entre les données.",
    rollback: "Annuler l'import",
    rollbackPreview: "Aperçu du rollback",
    rollbackAffected: "Enregistrements concernés",
    rollbackNone: "Aucun enregistrement trouvé pour cette session.",
    rollbackRecordsIn: "enregistrement(s) dans",
    rollbackTotal: "Total",
    rollbackBlocked: "Rollback bloqué — références externes détectées",
    rollbackConfirm: "Confirmer le rollback",
    rollbackDone: "Import annulé",
    rollbackRecordsRemoved: "enregistrement(s) supprimé(s)",
    rolledBackBy: "Annulé par",
    rollbackDeleted: "Enregistrements supprimés",
    operationalGuide: {
      title: "Guide opérationnel d'import",
      step1Title: "1. Télécharger le template",
      step1Desc: "Téléchargez le modèle Excel pour le type de données souhaité. Remplissez-le avec les données source.",
      step2Title: "2. Valider (dry-run)",
      step2Desc: "Lancez une validation sans insertion. Corrigez les erreurs détectées dans les fichiers source.",
      step3Title: "3. Exécuter l'import",
      step3Desc: "Une fois la validation réussie, exécutez l'import définitif. Les données seront créées dans la plateforme.",
      step4Title: "4. Vérifier en QA",
      step4Desc: "Ouvrez la Console QA pour vérifier la qualité des données importées. Exportez le rapport si nécessaire.",
      orderTitle: "Ordre d'import obligatoire",
      orderDesc: "Les imports doivent respecter cet ordre strict pour garantir les références entre les données :",
      orderSteps: "Projets > Investisseurs > Souscriptions > Mouvements > Documents",
      goToQA: "Ouvrir la Console QA",
      goToOnboarding: "Retour à la mise en place",
    },
    templateNames: {
      projects: "Template Projets (.xlsx)",
      investors: "Template Investisseurs (.xlsx)",
      subscriptions: "Template Souscriptions (.xlsx)",
      movements: "Template Mouvements (.xlsx)",
      documents: "Template Documents (.xlsx)",
    },
  },

  audit: {
    title: "Journal d'audit",
    subtitle: "Historique des actions et modifications effectuées sur la plateforme.",
    totalEntries: "entrées au total",
    searchPlaceholder: "Rechercher par action, nom ou description...",
    allTargets: "Tous les types",
    targetInvestor: "Investisseur",
    targetProject: "Projet",
    targetSubscription: "Souscription",
    targetMovement: "Mouvement",
    targetDocument: "Document",
    targetAccessRequest: "Demande d'accès",
    targetSponsor: "Commandité",
    allActors: "Tous les acteurs",
    actor: "Acteur",
    target: "Cible",
    timestamp: "Horodatage",
    changes: "Modifications",
    noEntries: "Aucune entrée dans le journal d'audit.",
  },

  internalUsers: {
    title: "Utilisateurs internes",
    subtitle: "Gérez les comptes Super Admin et Admin / Operations.",
    addUser: "Ajouter un utilisateur",
    email: "Adresse e-mail",
    firstName: "Prénom",
    lastName: "Nom",
    role: "Rôle",
    status: "Statut",
    superAdmin: "Super Admin",
    adminOps: "Admin / Operations",
    active: "Actif",
    suspended: "Suspendu",
    pendingActivation: "En attente d'activation",
    changeRole: "Changer le rôle",
    suspend: "Suspendre",
    activate: "Activer",
    createdAt: "Créé le",
    noUsers: "Aucun utilisateur interne.",
    confirmSuspend: "Êtes-vous sûr de vouloir suspendre cet utilisateur ?",
    selfEditError: "Vous ne pouvez pas modifier votre propre compte.",
  },

  secondaryMarket: {
    title: "Marché secondaire",
    subtitle: "Gestion contrôlée des transferts de positions entre investisseurs.",
    investorTitle: "Marché secondaire",
    investorSubtitle: "Gérez vos demandes de cession ou d'acquisition de positions.",
    newRequest: "Nouvelle demande",
    createRequest: "Créer une demande",
    sellRequest: "Demande de cession",
    buyInterest: "Intérêt d'acquisition",
    sell: "Cession",
    buy: "Acquisition",
    type: "Type de demande",
    selectType: "Sélectionner le type",
    selectProject: "Sélectionner un projet",
    selectInvestmentType: "Sélectionner la nature",
    amount: "Montant (EUR)",
    unitPrice: "Prix unitaire proposé (EUR)",
    unitPriceHint: "Optionnel — prix indicatif par part",
    investorNotes: "Notes / Commentaires",
    investorNotesHint: "Précisez votre motivation ou vos conditions.",
    adminNotes: "Notes internes",
    adminNotesHint: "Notes visibles uniquement par les administrateurs.",
    subscription: "Souscription liée",
    selectSubscription: "Sélectionner une souscription",
    noActivePosition: "Aucune position active trouvée pour ce projet.",
    requestCreated: "Demande créée avec succès.",
    requestSubmitted: "Demande soumise avec succès.",
    requestCancelled: "Demande annulée.",
    statusUpdated: "Statut mis à jour.",
    notesUpdated: "Notes mises à jour.",
    matchCompleted: "Mise en correspondance effectuée.",
    noRequests: "Aucune demande de marché secondaire.",
    noInvestorRequests: "Vous n'avez aucune demande en cours.",
    allRequests: "Toutes les demandes",
    activeRequests: "Demandes actives",
    completedTransfers: "Transferts réalisés",
    totalAmount: "Montant total",
    filterByType: "Filtrer par type",
    filterByStatus: "Filtrer par statut",
    allTypes: "Tous les types",
    allStatuses: "Tous les statuts",
    investor: "Investisseur",
    project: "Projet",
    counterparty: "Contrepartie",
    matchedWith: "Mis en correspondance avec",
    matchRequest: "Mettre en correspondance",
    matchWithRequest: "Apparier avec une demande",
    matchWithInvestor: "Apparier avec un investisseur",
    counterpartyRequest: "Demande contrepartie",
    counterpartyInvestor: "Investisseur contrepartie",
    viewDetails: "Voir le détail",
    updateStatus: "Mettre à jour le statut",
    selectStatus: "Sélectionner un statut",
    reason: "Motif",
    reasonHint: "Requis pour le rejet ou l'annulation.",
    statusHistory: "Historique des statuts",
    relatedSubscription: "Souscription associée",
    submitDraft: "Soumettre la demande",
    cancelRequest: "Annuler la demande",
    editDraft: "Modifier le brouillon",
    confirmCancel: "Êtes-vous sûr de vouloir annuler cette demande ?",
    createdAt: "Créé le",
    updatedAt: "Mis à jour le",
    submittedAt: "Soumis le",
    reviewedAt: "Examiné le",
    matchedAt: "Apparié le",
    completedAt: "Finalisé le",
    status: {
      draft: "Brouillon",
      submitted: "Soumise",
      under_review: "En cours d'examen",
      eligible: "Éligible",
      matched: "Appariée",
      pending_approval: "En attente d'approbation",
      pending_documentation: "En attente de documentation",
      pending_transfer: "En attente de transfert",
      completed: "Finalisée",
      cancelled: "Annulée",
      rejected: "Rejetée",
    },
    disclaimer: "Les transferts de positions sont soumis à validation et approbation par l'équipe Wealth Management - Global Real Assets. Aucun transfert n'est automatique ni garanti.",
    cancelRestricted: "Annulation non disponible à ce stade du processus.",
    // Transfer workflow
    transfer: {
      readiness: "Prêt pour le transfert",
      notReady: "Non prêt",
      ready: "Prêt à avancer",
      blockers: "Points de blocage",
      noBlockers: "Aucun point de blocage.",
      checklistTitle: "Checklist documentaire",
      documentsSection: "Documents de transfert",
      uploadDocument: "Téléverser un document",
      selectDocType: "Type de document",
      docTypes: {
        transfer_agreement: "Accord de cession",
        compliance_clearance: "Attestation de conformité",
        counterparty_kyc: "KYC contrepartie",
        transfer_confirmation: "Confirmation de transfert",
      },
      docStatus: {
        missing: "Manquant",
        pending_review: "En attente de revue",
        uploaded: "Téléversé",
        approved: "Approuvé",
        rejected: "Refusé",
        replaced: "Remplacé",
      },
      sellerKyc: "KYC vendeur",
      counterpartyKyc: "KYC contrepartie",
      kycComplete: "Complet",
      kycIncomplete: "Incomplet",
      transitionTitle: "Progression du dossier",
      transitionConfirm: "Confirmer la transition",
      transitionBlocked: "Transition bloquée",
      transitionBlockedMsg: "Certaines conditions ne sont pas remplies.",
      workflowSteps: "Étapes du processus",
      currentStage: "Étape actuelle",
      pendingAction: "Action requise",
      noPendingAction: "Aucune action requise de votre part.",
      investorDocsNeeded: "Des documents sont nécessaires pour poursuivre le transfert.",
      investorDocsComplete: "Vos documents de transfert sont complets.",
      investorKycNeeded: "Votre dossier KYC requiert des mises à jour.",
      investorKycComplete: "Votre dossier KYC est à jour.",
      progressMessage: "Votre dossier progresse normalement.",
      blockedMessage: "Votre dossier nécessite des éléments complémentaires.",
      cashFlowLinked: "Événement de trésorerie lié",
      applyPlaybook: "Appliquer le playbook transfert",
    },
    ops: {
      stageBreakdownTitle: "Ventilation par étape",
      pendingDocumentation: "En attente de docs",
      pendingApproval: "En attente d'approbation",
      pendingTransfer: "En attente de transfert",
      rejectedTotal: "Rejetées",
      cancelledTotal: "Annulées",
    },
    v2: {
      compatibilityTab: "Compatibilités",
      reportingTab: "Suivi opérationnel",
      caseFileTab: "Dossier complet",
      requestsTab: "Demandes",
      noCompatiblePairs: "Aucune paire compatible identifiée pour le moment.",
      totalSells: "Cessions ouvertes",
      totalBuys: "Acquisitions ouvertes",
      matchablePairs: "Paires compatibles",
      compatScore: "Score de compatibilité",
      strong: "Fort",
      moderate: "Modéré",
      weak: "Faible",
      factors: "Facteurs d'analyse",
      assignMatch: "Rapprocher",
      viewCaseFile: "Voir le dossier",
      byProject: "Par projet",
      byStage: "Par étape",
      blockedRequests: "Demandes bloquées",
      needsAction: "Actions requises",
      requestAging: "Ancienneté des demandes",
      completedSummary: "Transferts réalisés",
      ageDays: "Ancienneté (jours)",
      staleDays: "Inactivité (jours)",
      blockerCategories: "Catégories de blocage",
      totalAmountLabel: "Montant total",
      sells: "Cessions",
      buys: "Acquisitions",
      active: "Actives",
      completed: "Réalisés",
      caseFile: {
        timeline: "Chronologie du dossier",
        durationHours: "h depuis étape précédente",
        documentProgression: "Progression documentaire",
        versionCount: "versions",
        linkedTasks: "Tâches liées",
        linkedCashflow: "Événement de trésorerie lié",
        crmContext: "Contexte relation investisseur",
        relationshipOwner: "Responsable relation",
        totalAge: "Ancienneté totale du dossier",
        days: "jours",
        noTasks: "Aucune tâche liée.",
        noCashflow: "Aucun événement de trésorerie lié.",
        noCrm: "Aucun contact CRM trouvé.",
      },
    },
    investorProgress: {
      stepsTitle: "Progression de votre dossier",
      stepCompleted: "Terminé",
      stepActive: "En cours",
      stepUpcoming: "À venir",
      stepDesc: {
        submitted: "Votre demande a été reçue et enregistrée. Notre équipe va l'examiner dans les meilleurs délais.",
        under_review: "Notre équipe analyse votre demande : vérification d'éligibilité, conformité et conditions. Aucune action de votre part n'est requise à ce stade.",
        eligible: "Votre demande est éligible. Nous recherchons une contrepartie compatible parmi les investisseurs qualifiés.",
        matched: "Une contrepartie a été identifiée. L'équipe procède aux vérifications croisées nécessaires.",
        pending_approval: "Le dossier de transfert est en cours de validation interne par notre comité. Aucune action de votre part.",
        pending_documentation: "Des documents complémentaires sont nécessaires pour finaliser le transfert. Consultez la section documents ci-dessous.",
        pending_transfer: "Tous les éléments sont réunis. Le transfert est en cours de finalisation dans nos systèmes.",
        completed: "Le transfert a été finalisé avec succès. Votre position a été mise à jour.",
      },
      whatHappensNext: "Prochaine étape",
      whatYouNeedToDo: "Ce que vous devez faire",
      internalProcess: "Traitement interne en cours",
      noActionRequired: "Aucune action de votre part n'est requise pour le moment.",
    },
  },

  qa: {
    title: "Contrôle qualité post-import",
    subtitle: "Console de vérification et de réconciliation des données importées. Contrôle de cohérence, détection d'anomalies et validation par projet et par investisseur.",
    globalStatus: "État global des imports",
    globalStatusDesc: "Vue d'ensemble des anomalies détectées sur l'ensemble des données importées.",
    noGlobalIssues: "Aucune anomalie globale détectée.",
    refresh: "Actualiser",
    importedProjects: "Projets importés",
    importedInvestors: "Investisseurs importés",
    importedSubscriptions: "Souscriptions importées",
    importedMovements: "Mouvements importés",
    importedDocuments: "Documents importés",
    recentSessions: "Sessions d'import récentes",
    recentSessionsDesc: "Sélectionnez une session pour accéder au détail de la réconciliation.",
    noSessions: "Aucune session d'import exécutée.",
    created: "créé(s)",
    skipped: "ignoré(s)",
    rolledBack: "Annulé",
    datasetType: "Type de données",
    sessionStatus: "Statut de la session",
    createdBy: "Importé par",
    totalCreated: "Créés",
    totalSkipped: "Ignorés",
    totalRejected: "Rejetés",
    flaggedRecords: "Avec anomalies",
    globalFlags: "Alertes globales",
    issues: "Anomalies détectées",
    details: "Détails de l'enregistrement",
    viewInvestor: "Voir le profil investisseur",
    tab: {
      sessions: "Sessions d'import",
      projects: "Projets",
      investors: "Investisseurs",
    },
    projectVerification: "Vérification par projet",
    projectVerificationDesc: "Sélectionnez un projet pour vérifier la cohérence de ses données.",
    investorVerification: "Vérification par investisseur",
    investorVerificationDesc: "Sélectionnez un investisseur pour contrôler son entrée en relation.",
    imported: "Importé",
    investmentTypes: "Types de projet",
    targetRaise: "Objectif de levée",
    totalInvestors: "Investisseurs",
    noIssuesFound: "Aucune anomalie détectée.",
    subscriptionsBreakdown: "Détail des souscriptions",
    totalSubscriptions: "Souscriptions",
    totalRequested: "Montant demandé",
    totalApproved: "Montant approuvé",
    orphanedMovements: "Mouvements orphelins",
    byInvestmentType: "Par type de projet",
    movementsSummary: "Synthèse des mouvements",
    totalMovements: "Mouvements",
    totalIncoming: "Total entrant",
    totalDistributed: "Total distribué",
    documents: "Documents",
    profilePresent: "Profil existant",
    validationStatus: "Statut de validation",
    country: "Pays",
    investorType: "Type investisseur",
    company: "Société",
    linkedSubscriptions: "Souscriptions liées",
    subscriptions: "souscription(s)",
    approved: "Approuvé",
    movementsCount: "Nombre de mouvements",
    documentsCount: "Nombre de documents",
    exportXlsx: "Exporter Excel",
    exportPdf: "Exporter PDF",
    flag: {
      ok: "OK",
      warning: "Attention",
      needs_review: "À vérifier",
      blocking: "Bloquant",
    },
  },

  projectOps: {
    title: "Centre opérationnel du projet",
    subtitle: "Vue complète des positions, flux financiers et événements pour ce projet.",
    backToProjects: "Retour aux projets",
    projectIdentity: "Identité du projet",
    assetClass: "Classe d'actif",
    targetRaise: "Objectif de levée",
    minSubscription: "Souscription minimale",
    investorCount: "Investisseurs",
    positionsCount: "Positions actives",
    totalRequested: "Montant total demandé",
    totalApproved: "Montant total approuvé",
    typeBreakdown: "Répartition par type de projet",
    count: "Nombre",
    investors: "Investisseurs",
    requested: "Demandé",
    approved: "Approuvé",
    movementsSummary: "Synthèse des mouvements",
    totalIncoming: "Entrants confirmés",
    totalOutgoing: "Sortants",
    pendingMovements: "En attente",
    events: "Événements financiers",
    recentMovements: "Mouvements récents",
    qaFlags: "Alertes qualité",
    noFlags: "Aucune alerte.",
    documents: "Documents",
    updates: "Mises à jour",
    tab: {
      overview: "Vue d'ensemble",
      positions: "Registre des positions",
      flows: "Flux financiers",
      events: "Événements",
    },
    positions: {
      title: "Registre des positions",
      subtitle: "Table de capitalisation et positions par investisseur.",
      investorName: "Investisseur",
      email: "E-mail",
      investorType: "Type",
      country: "Pays",
      positionTypes: "Types de position",
      totalRequested: "Demandé",
      totalApproved: "Approuvé",
      incoming: "Reçu",
      distributed: "Distribué",
      movements: "Mouvements",
      flags: "Alertes",
      noPositions: "Aucune position enregistrée.",
      filterByType: "Filtrer par type",
      allTypes: "Tous",
      viewDetail: "Détail investisseur",
    },
    investorDetail: {
      title: "Détail de la position investisseur",
      profile: "Profil",
      subscriptions: "Souscriptions",
      movements: "Mouvements",
      cashflowEvents: "Événements de trésorerie",
      totals: "Synthèse financière",
      netPosition: "Position nette",
      warnings: "Alertes",
      noWarnings: "Aucune alerte détectée.",
      noMovements: "Aucun mouvement enregistré.",
      noEvents: "Aucun événement.",
      noDocuments: "Aucun document lié.",
      documents: "Documents",
    },
    flows: {
      title: "Réconciliation des flux",
      subtitle: "Vue globale des flux entrants et sortants, par investisseur et par type de projet.",
      totalIncoming: "Total entrant",
      incomingConfirmed: "Entrant confirmé",
      distribution: "Distributions",
      reimbursement: "Remboursements",
      totalOutgoing: "Total sortant",
      net: "Solde net",
      byInvestor: "Par investisseur",
      byInvestmentType: "Par type de projet",
      flags: "Cohérence",
      noFlags: "Les flux semblent cohérents.",
    },
    eventTypes: {
      capital_contribution: "Apport en capital",
      cca_contribution: "Apport CCA",
      bond_subscription: "Souscription obligataire",
      distribution: "Distribution",
      reimbursement: "Remboursement",
      repayment: "Remboursement de prêt",
      transfer_event: "Événement de cession",
      other: "Autre",
    },
    eventStatuses: {
      planned: "Planifié",
      confirmed: "Confirmé",
      executed: "Exécuté",
      cancelled: "Annulé",
    },
    eventsTab: {
      title: "Événements financiers du projet",
      subtitle: "Historique structuré des principaux événements de trésorerie.",
      create: "Nouvel événement",
      noEvents: "Aucun événement enregistré.",
      type: "Type",
      investmentType: "Type de projet",
      investor: "Investisseur",
      date: "Date",
      amount: "Montant",
      status: "Statut",
      description: "Description",
      notes: "Notes internes",
      save: "Enregistrer",
      cancel: "Annuler",
      edit: "Modifier",
      delete: "Supprimer",
      confirmDelete: "Confirmer la suppression ?",
      projectLevel: "Niveau projet",
      linkedMovements: "Mouvements liés",
    },
    distributions: "Distributions",
    distributionsCount: "Événements de distribution",
    distributionsTotal: "Total distribué",
    tasksActive: "Tâches actives",
    tasksOverdue: "En retard",
    docsPending: "Documents en attente de revue",
    sponsor: "Commandité",
    deliverables: "Livrables",
    deliverableOverdue: "en retard",
    complianceComplete: "Conformité complète",
    compliancePending: "En attente de conformité",
    noSponsor: "Aucun commandité associé",
    searchInvestors: "Rechercher un investisseur...",
  },

  alerts: {
    title: "Alertes opérationnelles",
    subtitle: "Éléments nécessitant une attention immédiate ou un suivi.",
    noAlerts: "Aucune alerte en cours — tout est en ordre.",
    severity: {
      critical: "Critique",
      warning: "Attention",
      info: "Information",
    },
    categories: {
      deliverable: "Livrables commandités",
      task: "Tâches en retard",
      compliance: "Conformité",
      distribution: "Distributions",
      secondary_market: "Marché secondaire",
      crm: "Relations CRM",
      qa: "Qualité",
    },
    viewAll: "Voir toutes les alertes",
  },

  exports: {
    title: "Exports opérationnels",
    crm: "Exporter CRM (Excel)",
    tasks: "Exporter tâches (Excel)",
    positions: "Exporter positions (Excel)",
    distributions: "Exporter distributions (Excel)",
    deliverables: "Exporter livrables (Excel)",
    downloading: "Téléchargement en cours...",
  },

  comms: {
    title: "Communications & mises à jour",
    subtitle: "Publiez et gérez les communications structurées à destination des investisseurs.",
    backToProject: "Retour au projet",
    create: "Nouvelle communication",
    noDrafts: "Aucun brouillon.",
    noPublished: "Aucune communication publiée.",
    noArchived: "Aucune communication archivée.",
    tab: {
      all: "Toutes",
      draft: "Brouillons",
      published: "Publiées",
      archived: "Archivées",
    },
    status: {
      draft: "Brouillon",
      published: "Publiée",
      archived: "Archivée",
    },
    category: {
      project_progress: "Avancement du projet",
      operational_milestone: "Jalon opérationnel",
      administrative: "Administratif",
      legal_structuring: "Juridique & structuration",
      reporting: "Reporting",
      distribution_info: "Distribution & remboursement",
      important_notice: "Avis important",
      other: "Autre",
    },
    visibility: {
      project_investors: "Investisseurs du projet",
      internal_only: "Interne uniquement",
    },
    form: {
      title: "Titre",
      summary: "Résumé",
      summaryHint: "Court résumé visible dans la liste des communications.",
      body: "Contenu",
      bodyHint: "Contenu complet de la communication.",
      category: "Catégorie",
      visibility: "Visibilité",
      pinned: "Épingler en tête",
      internalNotes: "Notes internes",
      internalNotesHint: "Visibles uniquement par l'équipe interne.",
      linkedDocuments: "Documents liés",
      noDocuments: "Aucun document disponible.",
      saveDraft: "Enregistrer le brouillon",
      publish: "Publier",
      update: "Mettre à jour",
      cancel: "Annuler",
    },
    actions: {
      edit: "Modifier",
      publish: "Publier",
      archive: "Archiver",
      delete: "Supprimer",
      confirmPublish: "Confirmer la publication ? Les investisseurs seront notifiés.",
      confirmArchive: "Confirmer l'archivage ?",
      confirmDelete: "Confirmer la suppression du brouillon ?",
    },
    preview: "Aperçu",
    publishedAt: "Publié le",
    by: "par",
    pinned: "Épinglé",
    linkedDocs: "Documents joints",
    new: "Nouveau",
    readCount: "Lectures",
    readRate: "Taux de lecture",
    statsPublished: "publiées",
    statsDrafts: "brouillons",
    statsInternal: "internes",
  },

  investorComms: {
    title: "Actualités des projets",
    subtitle: "Suivez les mises à jour et communications de vos projets.",
    noUpdates: "Aucune mise à jour pour le moment.",
    allProjects: "Tous les projets",
    unreadCount: "non lu(s)",
    readMore: "Lire la suite",
    attachments: "Documents joints",
    markAsRead: "Marquer comme lu",
  },

  dist: {
    title: "Distributions & remboursements",
    subtitle: "Gestion opérationnelle des événements de distribution et de remboursement aux investisseurs.",
    backToProject: "Retour au projet",
    createEvent: "Nouvel événement",
    noEvents: "Aucun événement de distribution enregistré pour ce projet.",
    eventTitle: "Intitulé",
    eventType: "Type d'événement",
    investmentType: "Type de projet",
    totalAmount: "Montant total",
    date: "Date",
    currency: "Devise",
    description: "Description",
    notes: "Notes internes",
    status: "Statut",
    autoAllocate: "Allocation automatique",
    autoAllocateHelp: "Génère une proposition d'allocation pro-rata basée sur les montants approuvés des investisseurs.",
    save: "Enregistrer",
    cancel: "Annuler",
    edit: "Modifier",
    delete: "Supprimer",
    confirmDelete: "Confirmer la suppression de cet événement et de toutes ses allocations ?",
    onlyDraftDelete: "Seuls les événements en brouillon peuvent être supprimés. Les autres doivent être annulés.",
    eventCreated: "Événement créé avec succès.",
    eventUpdated: "Événement mis à jour.",
    eventDeleted: "Événement supprimé.",
    allocations: "Allocations",
    allocationCount: "Nombre d'allocations",
    allocatedTotal: "Total alloué",
    paidTotal: "Total versé",
    pendingCount: "En attente",
    paidCount: "Versé",
    investor: "Investisseur",
    amount: "Montant",
    paymentDate: "Date de versement",
    basis: "Base de calcul",
    adjustAmount: "Ajuster le montant",
    markAsPaid: "Marquer comme versé",
    cancelAllocation: "Annuler l'allocation",
    bulkMarkPaid: "Tout marquer versé",
    bulkApprove: "Tout approuver",
    triggerAutoAllocate: "Relancer l'allocation automatique",
    reAllocateConfirm: "Relancer l'allocation supprimera les allocations existantes et générera de nouvelles propositions. Continuer ?",
    allocationUpdated: "Allocation mise à jour.",
    allocationsGenerated: "allocation(s) générée(s).",
    bulkUpdated: "allocation(s) mise(s) à jour.",
    noAllocations: "Aucune allocation. Utilisez l'allocation automatique ou ajoutez manuellement.",
    viewAllocations: "Voir les allocations",
    linkedCashflow: "Événement de trésorerie lié",
    linkedDistribution: "Événement de distribution lié",
    exportXlsx: "Exporter Excel",
    exportPdf: "Exporter PDF",
    eventSummary: "Synthèse de l'événement",
    projectSummary: "Synthèse des distributions",
    totalDistributed: "Total distribué",
    totalPending: "Total en attente",
    totalEvents: "Événements",
    eventTypes: {
      distribution: "Distribution",
      repayment: "Remboursement",
      reimbursement: "Remboursement de frais",
      cca_repayment: "Remboursement CCA",
      bond_repayment: "Remboursement obligataire",
      other: "Autre",
    },
    eventStatuses: {
      draft: "Brouillon",
      validated: "Validé",
      in_progress: "En cours",
      completed: "Terminé",
      cancelled: "Annulé",
      scheduled: "Programmé",
    },
    allocStatuses: {
      pending: "En attente",
      approved: "Approuvé",
      partial: "Partiellement versé",
      paid: "Versé",
      cancelled: "Annulé",
    },
    calendarTitle: "Calendrier opérationnel",
    calendarSubtitle: "Distributions & remboursements",
    calendarDesc: "Vue consolidée des événements de distribution et remboursement programmés et passés, tous projets confondus.",
    actualCompleted: "Événements réels",
    scheduledUpcoming: "Cycles programmés",
    legendActual: "Événement réel (traité ou en cours)",
    legendScheduled: "Cycle programmé (prévisionnel)",
    scheduledLabel: "prévu(s)",
    pastDue: "Échu",
    amountTbd: "Montant à définir",
    filterAll: "Tous les statuts",
    upcomingTitle: "Prochaines distributions prévues",
    upcomingDesc: "Calendrier prévisionnel des distributions à venir pour vos projets actifs.",
    upcomingEmpty: "Aucune distribution programmée pour le moment.",
    nextExpected: "Prochain versement attendu",
    scheduledQuarterly: "Versement trimestriel programmé",
    scheduledFor: "Prévue le",
    investorView: {
      title: "Mes flux reçus et remboursements",
      subtitle: "Historique des flux reçus et remboursements associés à vos projets.",
      noAllocations: "Aucun flux ou remboursement enregistré pour le moment.",
      totalAllocated: "Total attribué aux projets",
      totalPaid: "Total réglé",
      totalPending: "En attente",
      eventTitle: "Événement",
      project: "Projet",
      investmentType: "Type de projet",
      amount: "Montant",
      status: "Statut",
      paymentDate: "Date de versement",
      basis: "Base de calcul",
      exportXlsx: "Exporter en Excel",
      exporting: "Export en cours...",
      exportSuccess: "Historique exporté avec succès.",
      exportError: "Échec de l'export. Veuillez réessayer.",
    },
  },

  footer: {
    description: "Une plateforme de projet privée offrant un accès sélectionné à des opportunités de projet en actifs réels sur mesure sur les marchés internationaux.",
    quickLinks: "Liens rapides",
    aboutUs: "À propos",
    howItWorksLink: "Fonctionnement",
    requestAccessLink: "Demander l'accès",
    investorLogin: "Connexion investisseur",
    legal: "Juridique",
    privacy: "Politique de confidentialité",
    terms: "Conditions générales",
    riskDisclosure: "Avertissement sur les risques",
    cookies: "Politique de cookies",
    mentionsLegales: "Mentions légales",
    contact: "Contact",
    copyright: "Wealth Management - Global Real Assets. Tous droits réservés.",
    legalDisclaimer: "Wealth Management - Global Real Assets n'est pas un établissement bancaire ou financier réglementé. Tout projet comporte des risques. La valeur des projets et les revenus qui en découlent peuvent baisser comme augmenter.",
  },

  mentionsLegales: {
    overline: "Informations légales",
    title: "Mentions légales",
    editeur: {
      title: "Éditeur du site",
      companyNameLabel: "Dénomination sociale",
      legalFormLabel: "Forme juridique",
      capitalLabel: "Capital social",
      siegeLabel: "Siège social",
    },
    immatriculation: {
      title: "Immatriculation et identification",
      tvaLabel: "N° TVA intracommunautaire",
    },
    direction: {
      title: "Direction et publication",
      presidentLabel: "Président",
      publicationLabel: "Directeur de la publication",
      publicationValue: "Daniel Roger Sylvain Scortatore, en qualité de Président de la société.",
    },
    contact: {
      title: "Contact",
      legalLabel: "Contact juridique",
      generalLabel: "Contact général",
      phoneLabel: "Téléphone",
      addressLabel: "Adresse",
    },
    hebergement: {
      title: "Hébergement",
      pending: "Les informations relatives à l'hébergeur du site seront complétées prochainement.",
    },
    propriete: {
      title: "Propriété intellectuelle",
      text: "L'ensemble du contenu du présent site — incluant, de façon non limitative, les textes, images, graphismes, logos, icônes, sons et logiciels — est la propriété exclusive de Wealth Management - Global Real Assets ou de ses partenaires et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle. Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sauf autorisation écrite préalable de Wealth Management - Global Real Assets.",
    },
    responsabilite: {
      title: "Limitation de responsabilité",
      text: "Les informations diffusées sur ce site sont présentées à titre informatif et ne constituent en aucun cas un conseil en projet, une offre de souscription ou une sollicitation d'achat de produits financiers. Wealth Management - Global Real Assets s'efforce d'assurer l'exactitude et la mise à jour des informations publiées mais ne saurait garantir l'exhaustivité, la précision ou la pertinence de ces informations. L'utilisation du site et des informations qu'il contient se fait sous la seule responsabilité de l'utilisateur.",
    },
    donnees: {
      title: "Données personnelles et cookies",
      text: "Conformément à la réglementation applicable en matière de protection des données personnelles, Wealth Management - Global Real Assets s'engage à respecter la vie privée de ses utilisateurs. Pour toute question relative au traitement de vos données personnelles ou à l'exercice de vos droits, vous pouvez contacter notre responsable juridique à l'adresse line.medy@wealth-management-assets.com. Des informations complémentaires sur notre politique de confidentialité et notre gestion des cookies sont accessibles via les liens dédiés en pied de page.",
    },
  },

  tasks: {
    title: "Tâches internes",
    subtitle: "Gestion opérationnelle des tâches et suivis internes.",
    cockpitTitle: "Centre de contrôle opérationnel",
    cockpitSubtitle: "Vue d'ensemble de l'activité interne et des priorités.",
    createTask: "Nouvelle tâche",
    editTask: "Modifier la tâche",
    taskTitle: "Intitulé",
    description: "Description",
    status: "Statut",
    priority: "Priorité",
    dueDate: "Échéance",
    assignedTo: "Assigné à",
    createdBy: "Créé par",
    linkedEntity: "Entité liée",
    entityType: "Type d'entité",
    entityId: "Identifiant",
    project: "Projet",
    investor: "Investisseur",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    confirmDelete: "Confirmer la suppression de cette tâche ?",
    taskCreated: "Tâche créée.",
    taskUpdated: "Tâche mise à jour.",
    taskDeleted: "Tâche supprimée.",
    noTasks: "Aucune tâche enregistrée.",
    search: "Rechercher...",
    filter: "Filtrer",
    allStatuses: "Tous statuts",
    allPriorities: "Toutes priorités",
    allEntities: "Toutes entités",
    allAssignees: "Tous assignés",
    myTasks: "Mes tâches",
    overdue: "En retard",
    dueSoon: "Échéance proche",
    dueThisWeek: "Cette semaine",
    comments: "Notes internes",
    addComment: "Ajouter une note",
    commentPlaceholder: "Écrire une note de suivi...",
    commentAdded: "Note ajoutée.",
    noComments: "Aucune note.",
    completedAt: "Terminée le",
    statuses: {
      open: "Ouverte",
      in_progress: "En cours",
      waiting: "En attente",
      completed: "Terminée",
      cancelled: "Annulée",
    },
    priorities: {
      low: "Basse",
      normal: "Normale",
      high: "Haute",
      urgent: "Urgente",
    },
    entityTypes: {
      project: "Projet",
      investor: "Investisseur",
      subscription: "Souscription",
      document: "Document",
      import_session: "Session d'import",
      distribution_event: "Événement de distribution",
      distribution_allocation: "Allocation",
      secondary_market_request: "Demande marché secondaire",
      project_update: "Communication projet",
      cashflow_event: "Événement de trésorerie",
      reconciliation: "Réconciliation",
      movement: "Mouvement",
      deliverable: "Livrable commandité",
      onboarding_project: "Mise en place de projet",
      other: "Autre",
    },
    cockpit: {
      open: "Ouvertes",
      inProgress: "En cours",
      waiting: "En attente",
      completed: "Terminées",
      overdue: "En retard",
      urgent: "Urgentes",
      highPriority: "Priorité haute",
      dueThisWeek: "Cette semaine",
      myTasks: "Mes tâches",
      myCreated: "Créées par moi",
      byEntityType: "Par type d'entité",
      teamWorkload: "Charge d'équipe",
    },
    contextCreate: "Créer une tâche liée",
    sourceTemplate: "Modèle source",
    fromTemplate: "Issu du modèle",
  },

  templates: {
    title: "Modèles opérationnels",
    subtitle: "Playbooks et modèles de workflows pour les processus récurrents.",
    /* LOT 3 · S3-B — Le bloc `templates.*` reste maintenu tel quel pour
     * compatibilité avec les composants qui l'utilisent encore (aliasé
     * ci-dessous par `playbooks.*`). NE PAS SUPPRIMER (mandat PO). */
    createTemplate: "Nouveau modèle",
    editTemplate: "Modifier le modèle",
    templateName: "Nom du modèle",
    description: "Description",
    category: "Catégorie",
    active: "Actif",
    inactive: "Inactif",
    status: "Statut",
    notes: "Notes internes",
    defaultEntityType: "Type d'entité par défaut",
    requiresProject: "Requiert un projet",
    requiresInvestor: "Requiert un investisseur",
    items: "Étapes",
    itemCount: "étapes",
    addItem: "Ajouter une étape",
    editItem: "Modifier l'étape",
    itemTitle: "Intitulé de l'étape",
    itemDescription: "Description de l'étape",
    itemPriority: "Priorité",
    dueOffsetDays: "Délai (jours)",
    dueOffsetHelp: "Nombre de jours après application du modèle",
    order: "Ordre",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    confirmDelete: "Confirmer la suppression de ce modèle ?",
    confirmDeleteItem: "Confirmer la suppression de cette étape ?",
    templateCreated: "Modèle créé.",
    templateUpdated: "Modèle mis à jour.",
    templateDeleted: "Modèle supprimé.",
    templateDuplicated: "Modèle dupliqué.",
    duplicate: "Dupliquer",
    itemCreated: "Étape ajoutée.",
    itemUpdated: "Étape mise à jour.",
    itemDeleted: "Étape supprimée.",
    noTemplates: "Aucun modèle opérationnel enregistré.",
    noItems: "Aucune étape définie pour ce modèle.",
    applyTemplate: "Appliquer ce modèle",
    applyAction: "Appliquer",
    preview: "Aperçu",
    previewTitle: "Aperçu des tâches à générer",
    applying: "Application en cours...",
    applied: "Modèle appliqué avec succès.",
    appliedCount: "tâche(s) générée(s)",
    applyCount: "Applications",
    selectTemplate: "Sélectionner un modèle",
    applyFromTemplate: "Appliquer un playbook",
    confirmApply: "Confirmer l'application de ce modèle ? Les tâches seront créées immédiatement.",
    allCategories: "Toutes catégories",
    allStatuses: "Tous statuts",
    search: "Rechercher...",
    activate: "Activer",
    deactivate: "Désactiver",
    createdBy: "Créé par",
    lastApplied: "Dernière application",
    templateGenerated: "Généré par modèle",
    generatedTasks: "Tâches générées",
    appliedOn: "Appliqué le",
    categories: {
      investor_onboarding: "Entrée en relation investisseur",
      project_onboarding: "Mise en place projet",
      import_migration: "Import / Migration",
      qa_reconciliation: "Réconciliation QA",
      compliance_documentation: "Conformité documentaire",
      distribution_repayment: "Distribution / Remboursement",
      secondary_market: "Marché secondaire",
      project_communications: "Communications projet",
      internal_operations: "Opérations internes",
      other: "Autre",
    },
  },

  /* LOT 3 · S3-B — Bloc `playbooks` réintroduit pour clarifier la sémantique
   * dans la nav / le PageHeader. Le bloc `templates` (ci-dessus) reste
   * source primaire pour les libellés opérationnels (createTemplate,
   * editTemplate, items, categories, etc.) — le renommage est UX-only.
   * NE PAS SUPPRIMER `templates` (mandat PO). */
  playbooks: {
    title: "Playbooks",
    subtitle: "Checklists internes et modèles de workflows pour vos processus récurrents.",
    lede: "Génère des tâches internes (aucun envoi d'e-mail — voir « Templates e-mail transactionnels »).",
    navLabel: "Playbooks & modèles opérationnels",
    system: "Système A — modèles de tâches internes",
    counterSystem: "Système B — templates e-mail transactionnels",
    counterSystemHref: "/admin/email-templates",
  },

  crm: {
    title: "Relation investisseurs",
    subtitle: "Gestion interne des relations, segmentation et suivi opérationnel.",
    nav: "CRM Investisseurs",
    profile: "Profil CRM",
    overview: "Vue d'ensemble",
    filters: "Filtres",
    search: "Rechercher un investisseur...",
    noInvestors: "Aucun investisseur ne correspond aux filtres sélectionnés.",
    allStatuses: "Tous statuts",
    allStages: "Toutes étapes",
    allLevels: "Tous niveaux",
    allSegments: "Tous segments",
    allOwners: "Tous responsables",
    allTags: "Tous tags",
    sortBy: "Trier par",
    sortName: "Nom",
    sortLifecycle: "Cycle de vie",
    sortEngagement: "Engagement",
    sortUpdated: "Mis à jour",
    investorCount: "investisseurs",
    subscriptions: "Souscriptions",
    totalInvested: "Total investi",
    activeTasks: "Tâches actives",
    interactions: "Interactions",
    lastInteraction: "Dernière interaction",
    noProfile: "Profil non initialisé",

    lifecycleStatus: "Statut du cycle de vie",
    lifecycle: {
      prospect: "Prospect",
      onboarding: "Entrée en relation en cours",
      active: "Actif",
      dormant: "Dormant",
      churned: "Perdu",
      blocked: "Bloqué",
    },
    relationshipStage: "Étape relationnelle",
    stages: {
      initial_contact: "Premier contact",
      qualification: "Qualification",
      due_diligence: "Due diligence",
      first_investment: "Premier projet",
      active_investor: "Investisseur actif",
      strategic_partner: "Partenaire stratégique",
      inactive: "Inactif",
    },
    engagementLevel: "Niveau d'engagement",
    engagement: {
      high: "Élevé",
      medium: "Moyen",
      low: "Faible",
      none: "Aucun",
    },
    investorSegment: "Segment investisseur",
    segments: {
      high_net_worth: "High Net Worth",
      ultra_high_net_worth: "Ultra High Net Worth",
      institutional: "Institutionnel",
      family_office: "Family office",
      retail_qualified: "Particulier qualifié",
      strategic: "Stratégique",
    },
    relationshipOwner: "Responsable relation",
    source: "Source / Origine",
    minTicket: "Ticket minimum",
    typicalTicket: "Ticket habituel",
    investmentPreferences: "Préférences de projet",
    geographicFocus: "Focus géographique",
    nextAction: "Prochaine action",
    nextActionDate: "Date prochaine action",
    strategicNotes: "Notes stratégiques",
    save: "Enregistrer",
    saved: "Profil mis à jour.",

    tags: "Tags",
    manageTags: "Gérer les tags",
    addTag: "Ajouter un tag",
    newTag: "Nouveau tag",
    tagName: "Nom du tag",
    tagCreated: "Tag créé.",
    tagDeleted: "Tag supprimé.",
    tagsUpdated: "Tags mis à jour.",
    noTags: "Aucun tag défini.",
    confirmDeleteTag: "Confirmer la suppression de ce tag ? Il sera retiré de tous les investisseurs.",

    notes: "Notes internes",
    addNote: "Ajouter une note",
    noteContent: "Contenu de la note",
    noteCategory: "Catégorie",
    noteCreated: "Note ajoutée.",
    noteDeleted: "Note supprimée.",
    noNotes: "Aucune note interne.",
    noteCategories: {
      general: "Général",
      relationship: "Relation",
      preferences: "Préférences",
      constraints: "Contraintes",
      followup: "Suivi",
      compliance: "Conformité",
      special_case: "Cas particulier",
      observation: "Observation",
    },

    interactionHistory: "Historique des interactions",
    addInteraction: "Enregistrer une interaction",
    interactionType: "Type d'interaction",
    interactionSummary: "Résumé",
    interactionDate: "Date",
    interactionNotes: "Notes",
    interactionProject: "Projet lié",
    interactionUser: "Interlocuteur interne",
    interactionCreated: "Interaction enregistrée.",
    interactionDeleted: "Interaction supprimée.",
    noInteractions: "Aucune interaction enregistrée.",
    interactionTypes: {
      call: "Appel",
      email: "E-mail",
      meeting: "Réunion",
      onboarding_followup: "Suivi d'entrée en relation",
      compliance_followup: "Suivi conformité",
      project_discussion: "Discussion projet",
      distribution_discussion: "Discussion distribution",
      secondary_market_discussion: "Discussion marché secondaire",
      portfolio_review: "Revue de portefeuille",
      event: "Événement",
      other: "Autre",
    },

    stats: {
      totalInvestors: "Investisseurs totaux",
      profilesCreated: "Profils CRM créés",
      unprofiledCount: "Sans profil CRM",
      totalInteractions: "Interactions totales",
      totalNotes: "Notes internes",
      byLifecycle: "Par statut de cycle de vie",
      byEngagement: "Par niveau d'engagement",
      byOwner: "Par responsable",
    },
    detail: "Détail relation",
    backToList: "Retour à la liste",
    timeline: "Chronologie",
    timelineTitle: "Fil d'activité",
    noTimelineEvents: "Aucun événement enregistré pour cet investisseur.",
    timelineTypes: {
      interaction: "Interaction",
      note: "Note interne",
      task: "Tâche",
      distribution: "Distribution",
      communication: "Communication",
      document: "Document",
    },
    bulkActions: "Actions groupées",
    bulkTagAssign: "Appliquer des tags",
    bulkLifecycleUpdate: "Modifier le statut de cycle",
    bulkApply: "Appliquer",
    bulkSelected: "sélectionné(s)",
    bulkSelectAll: "Tout sélectionner",
    bulkDeselectAll: "Tout désélectionner",
    bulkSuccess: "Action groupée appliquée.",
    bulkConfirm: "Confirmer cette action groupée ?",
    exportExcel: "Exporter Excel",
    exporting: "Export en cours…",
    exportSuccess: "Base investisseurs exportée avec succès.",
    exportError: "Échec de l'export. Veuillez réessayer.",

    intelligence: {
      title: "Intelligence CRM",
      subtitle: "Scoring d'engagement, signaux de dormance et priorités de suivi.",
      tab: "Intelligence",
      summary: "Vue d'ensemble",
      contacts: "Contacts scorés",
      followUp: "Priorités de suivi",
      followUpDesc: "Contacts dormants ou froids ayant des projets actifs — à recontacter en priorité.",
      noFollowUp: "Aucune priorité de suivi identifiée.",
      noContacts: "Aucun profil CRM à analyser.",
      totalContacts: "Contacts totaux",
      avgScore: "Score moyen",
      heat: {
        hot: "Chaud",
        warm: "Tiède",
        cold: "Froid",
      },
      dormant: "Dormant",
      dormantLabel: "Dormant",
      activeLabel: "Actif",
      score: "Score",
      signals: "Signaux",
      signal: {
        recent_login: "Connexion récente",
        moderate_login: "Connexion modérée",
        stale_login: "Aucune connexion récente",
        invested: "Portefeuille actif",
        recent_contact: "Contact récent",
        moderate_contact: "Contact modéré",
        dormant_contact: "Contact dormant",
        no_contact: "Aucun contact enregistré",
        vip_tag: "Contact VIP / Stratégique",
      },
      daysAgo: "j",
      invested: "Investi",
      lastContact: "Dernier contact",
      noContact: "Jamais contacté",
      interactions: "interactions",
      subscriptions: "souscriptions",
      filterHeat: "Filtrer par chaleur",
      all: "Tous",
    },
  },

  notifications: {
    title: "Notifications",
    subtitle: "Mises \u00e0 jour importantes concernant vos projets et votre compte.",
    empty: "Aucune notification",
    emptyDesc: "Vous \u00eates \u00e0 jour. Les nouvelles notifications appara\u00eetront ici.",
    markAllRead: "Tout marquer comme lu",
    markRead: "Marquer comme lu",
    noNotifications: "Aucune notification.",
    viewAll: "Voir toutes les notifications",
    unread: "Non lues",
    all: "Toutes",
    history: "Historique des notifications",
    historySubtitle: "Suivi des notifications et de la livraison des e-mails.",
    eventType: "Type d'événement",
    recipient: "Destinataire",
    emailSent: "E-mail envoyé",
    emailFailed: "Échec e-mail",
    read: "Lue",
    unreadLabel: "Non lue",
    allTypes: "Tous types",
    delivered: "Livré",
    failed: "Échoué",
    stats: {
      total: "Notifications totales",
      emailsSent: "E-mails envoyés",
      emailsFailed: "Échecs",
      readRate: "Taux de lecture",
      recent7d: "7 derniers jours",
    },
    eventTypes: {
      project_update_published: "Communication projet publiée",
      document_approved: "Document approuvé",
      document_rejected: "Document refusé",
      document_replacement_requested: "Remplacement demandé",
      document_expiring_soon: "Document bientôt expiré",
      distribution_published: "Distribution publiée",
      secondary_market_status_change: "Marché secondaire — statut",
      internal_task_assigned: "Tâche assignée",
      internal_import_completed: "Import terminé",
      transfer_documentation_required: "Documents de transfert requis",
      transfer_completed: "Transfert finalisé",
      transfer_rejected: "Transfert refusé",
    },
    preferences: {
      title: "Préférences de notification",
      subtitle: "Contrôlez les types de notifications que vous recevez.",
      emailToggle: "Recevoir les notifications par e-mail",
      emailEnabled: "Notifications e-mail activées",
      emailDisabled: "Notifications e-mail désactivées",
      save: "Enregistrer les préférences",
      saved: "Préférences mises à jour.",
      saveError: "Erreur lors de la mise à jour des préférences.",
      categories: {
        investments: "Investissements",
        documents: "Documents",
        transfers: "Transferts",
      },
      types: {
        project_update_published: "Communications projet publiées",
        document_approved: "Documents approuvés",
        document_rejected: "Documents refusés",
        document_replacement_requested: "Demandes de remplacement de documents",
        document_expiring_soon: "Documents bientôt expirés",
        distribution_published: "Distributions publiées",
        secondary_market_status_change: "Changements de statut marché secondaire",
        transfer_documentation_required: "Documents de transfert requis",
        transfer_completed: "Transferts finalisés",
        transfer_rejected: "Transferts refusés",
      },
    },
  },
  invDetail: {
    // Re-passe recette Sprint 1 — suppression de souscription (ExposureTab)
    deleteSub: "Supprimer la souscription",
    deleteSubReasonPrompt: "Raison de la suppression de la souscription ? (Soft-suppression — récupérable depuis la Corbeille.)",
    subDeleted: "Souscription supprimée.",
    backToList: "Retour aux investisseurs",
    notFound: "Investisseur introuvable",
    identitySection: "Identité & Contact",
    complianceSection: "Conformité & KYC",
    subscriptionsSection: "Souscriptions & Investissements",
    timelineSection: "Historique d'activité",
    actionsSection: "Gestion du compte",
    summarySection: "Aperçu rapide",
    documentsOverview: "Documents par catégorie",
    notesSection: "Notes internes",
    lifecycleTitle: "Cycle de vie investisseur",
    investorType: "Type d'investisseur",
    nationality: "Nationalité",
    taxResidence: "Résidence fiscale",
    address: "Adresse",
    companyName: "Raison sociale",
    accountCreated: "Compte créé le",
    lastLogin: "Dernière connexion",
    neverLoggedIn: "Jamais connecté",
    crmTags: "Tags CRM",
    kycValidated: "KYC Validé",
    kycPending: "KYC En attente",
    docsApproved: "approuvés",
    docsPending: "en attente de revue",
    docsMissing: "manquants",
    expires: "Expire",
    noComplianceDocs: "Aucun document de conformité téléversé.",
    subProject: "Projet",
    subType: "Type",
    subAmount: "Montant",
    noSubscriptions: "Aucune souscription enregistrée.",
    currentStatus: "Statut actuel du compte",
    activateAccount: "Activer le compte",
    suspendAccount: "Suspendre le compte",
    summaryActiveInvestments: "Investissements actifs",
    summaryPendingSubs: "Souscriptions en cours",
    summaryActiveTasks: "Tâches actives",
    summaryWaitingList: "Liste d'attente",
    summarySmRequests: "Demandes de transfert",
    summaryDocuments: "Total documents",
    notesPlaceholder: "Ajouter une note interne...",
    pendingActions: "Actions requises",
    actionActivation: "Compte en attente d'activation",
    actionMissingDocs: "documents de conformité manquants",
    actionDocsReview: "documents en attente de revue",
    actionPendingSubs: "souscriptions en attente d'action",
    metricTotalInvested: "Total investi",
    metricSubscriptions: "souscriptions",
    metricDistributed: "Distribué",
    metricAllocations: "allocations",
    metricCompliance: "Conformité",
    metricTasks: "Tâches ouvertes",
    metricCompleted: "terminées",
    lifecycle: {
      account_created: "Compte créé",
      profile_completed: "Profil complet",
      kyc_submitted: "KYC soumis",
      kyc_approved: "KYC approuvé",
      subscribed: "Souscrit",
      active_investor: "Investisseur actif",
    },
    timelineAccountCreated: "Compte créé",
    timelineLastLogin: "Dernière connexion",
    timelineDocUploaded: "Document téléversé",
    timelineDocReviewed: "Document examiné",
    timelineSubCreated: "Souscription initiée",
    timelineMovement: "Mouvement de fonds",
    timelineEmpty: "Aucune activité enregistrée.",
    tabExposure: "Exposition",
    tabChecklist: "Checklist docs",
    tabProfile: "Profil & KYC",
    tabCrm: "CRM & Relation",
    tabTimeline: "Historique",
    exposureTitle: "Positions de projet",
    noExposure: "Aucune position de projet enregistrée.",
    distributionSummary: "Synthèse des distributions",
    pendingSubsTitle: "Souscriptions en cours",
    colGross: "Brut",
    colFees: "Frais",
    colNetReal: "Montant réel",
    colDisplayAmount: "Montant affiché",
    colActions: "Actions",
    colFunded: "Financé",
    colFundsReceived: "Fonds reçus",
    colDate: "Date",
    colProject: "Projet",
    noOverride: "pas de surcharge",
    realSourceOfTruth: "Montant réel (source de vérité)",
    currentDisplayAmount: "Affichage actuel (vu par l'investisseur)",
    newDisplayAmount: "Nouveau montant affiché",
    notSet: "non défini",
    investorWillSee: "L'investisseur verra",
    derivedWarning: "Certaines positions utilisent des montants dérivés. Mettez à jour les détails financiers sur les souscriptions individuelles.",
    metricCommitted: "Engagé",
    metricFunded: "Financé",
    metricAllocated: "Alloué",
    metricActive: "Actif",
    metricProjects: "Projets",
    metricPending: "En attente",
    metricLastFunding: "Dernier financement",
    metricFirstFunding: "Premier financement",
    metricCompliance: "Conformité",
  },
  schedules: {
    overline: "Opérations",
    title: "Échéanciers récurrents",
    subtitle: "Gérez les calendriers récurrents de distribution, conformité et reporting pour tous les projets.",
    createNew: "Nouvel échéancier",
    statTotal: "Total",
    statActive: "Actifs",
    statPaused: "En pause",
    statDisabled: "Désactivés",
    searchPlaceholder: "Rechercher un échéancier...",
    filterAll: "Tous",
    allProjects: "Tous les projets",
    emptyState: "Aucun échéancier récurrent trouvé.",
    createFirst: "Créer votre premier échéancier",
    colName: "Échéancier",
    colProject: "Projet",
    colFrequency: "Fréquence",
    colRecurrence: "Récurrence",
    colStatus: "Statut",
    colNextRun: "Prochaine exécution",
    colLastRun: "Dernière exécution",
    colActions: "Actions",
    actionView: "Voir les détails",
    actionEdit: "Modifier",
    actionActivate: "Activer",
    actionPause: "Mettre en pause",
    actionDisable: "Désactiver",
    actionDuplicate: "Dupliquer",
    actionDelete: "Supprimer",
    backToList: "Retour aux échéanciers",
    backToDetail: "Retour à l'échéancier",
    recurrencePattern: "Modèle de récurrence",
    rawDates: "Dates (MM-JJ)",
    detailsSection: "Détails de l'échéancier",
    upcomingEvents: "Événements programmés à venir",
    actualEvents: "Historique des événements réels",
    noActualEvents: "Aucun événement de distribution enregistré pour ce projet.",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer définitivement cet échéancier ?",
    confirmDelete: "Supprimer définitivement",
    fieldLabel: "Nom de l'échéancier",
    fieldProject: "Projet associé",
    fieldEventType: "Type d'événement",
    fieldCategory: "Catégorie",
    fieldFrequency: "Fréquence",
    fieldAmount: "Montant par événement",
    fieldStartDate: "Date de début",
    fieldEndDate: "Date de fin",
    fieldTimezone: "Fuseau horaire",
    fieldCurrency: "Devise",
    fieldNotification: "Notifications",
    fieldCreatedBy: "Créé par",
    fieldAssignedTo: "Assigné à",
    fieldCreatedAt: "Date de création",
    fieldUpdatedAt: "Dernière mise à jour",
    fieldDescription: "Description",
    fieldNotes: "Notes internes",
    fieldDayOfMonth: "Jour du mois",
    fieldSelectMonths: "Sélectionner les mois",
    sectionGeneral: "Informations générales",
    sectionRecurrence: "Calendrier de récurrence",
    sectionFinancial: "Financier & Opérationnel",
    sectionSettings: "Assignation & Paramètres",
    recurrencePreview: "Aperçu de la récurrence",
    endDateHint: "Laisser vide pour un échéancier indéfini",
    amountHint: "Laisser vide si le montant est à déterminer par événement",
    createTitle: "Créer un échéancier récurrent",
    editTitle: "Modifier l'échéancier récurrent",
    saveChanges: "Enregistrer les modifications",
    createSchedule: "Créer l'échéancier",
  },
  docCenter: {
    title: "Centre documentaire",
    subtitle: "Gérez, examinez et organisez tous les documents de la plateforme.",
    requiresAttention: "Actions requises",
    allCategories: "Toutes catégories",
    allStatuses: "Tous statuts",
    allVisibility: "Toute visibilité",
    catInvestor: "Investisseur",
    catProject: "Projet",
    catSubscription: "Souscription",
    catMovement: "Mouvement",
    statusPendingClass: "Classification en attente",
    searchPlaceholder: "Rechercher des documents...",
    clearFilters: "Réinitialiser",
    thCategory: "Catégorie",
    thRelatedTo: "Lié à",
    thVisibility: "Visibilité",
    statTotal: "Total documents",
    statPending: "En attente de revue",
    statExpired: "Expirés",
    actionPendingReview: "documents en attente de revue",
    actionPendingClass: "en attente de classification",
    actionExpired: "documents expirés",
    visPublic: "Public",
    visInvestors: "Tous investisseurs",
    visValidated: "Validés uniquement",
    visSpecific: "Investisseur spécifique",
    visInternal: "Interne uniquement",
    visibilityLabel: "Visibilité / Niveau d'accès",
    visKeepCurrent: "Conserver la visibilité actuelle",
  },
  updates: {
    title: "Mises à jour & Communications",
    subtitle: "Gérez les mises à jour de projets, les communications investisseurs et les workflows de publication.",
    createUpdate: "Nouvelle mise à jour",
    backToList: "Retour aux mises à jour",
    statTotal: "Total mises à jour",
    statPublished: "Publiées",
    statDrafts: "Brouillons",
    statCategories: "Catégories",
    allProjects: "Tous les projets",
    allStatuses: "Tous statuts",
    allVisibility: "Toute visibilité",
    allCategories: "Toutes catégories",
    statusDraft: "Brouillon",
    statusPublished: "Publiée",
    statusArchived: "Archivée",
    visPublic: "Public",
    visRegistered: "Utilisateurs inscrits",
    visValidated: "Investisseurs validés",
    visProjectInvestors: "Investisseurs du projet",
    visInternal: "Interne uniquement",
    draftsPending: "brouillons en attente de publication",
    viewDrafts: "Voir les brouillons",
    published: "Mise à jour publiée avec succès",
    draftSaved: "Brouillon enregistré",
    saved: "Mise à jour enregistrée",
    archived: "Mise à jour archivée",
    noUpdates: "Aucune mise à jour. Commencez à communiquer avec vos investisseurs.",
    selectProject: "Projet",
    chooseProject: "Sélectionner un projet...",
    updateTitle: "Titre",
    titlePlaceholder: "Titre de la mise à jour...",
    updateSummary: "Résumé",
    summaryPlaceholder: "Résumé bref pour le fil d'actualités...",
    updateContent: "Contenu",
    contentPlaceholder: "Contenu complet (visible par les investisseurs)...",
    category: "Catégorie",
    visibility: "Audience",
    pubStatus: "Statut",
    publishNow: "Publier maintenant",
    saveAsDraft: "Enregistrer en brouillon",
    publish: "Publier",
    archive: "Archiver",
    summaryLabel: "Résumé",
    contentLabel: "Contenu complet",
    noSummary: "Aucun résumé fourni",
    noContent: "Pas encore de contenu",
    linkedDocs: "Documents liés",
    metadata: "Détails",
    project: "Projet",
    author: "Auteur",
    createdAt: "Créée le",
    publishedAt: "Publiée le",
    lastEdited: "Dernière modification",
    audienceReach: "Portée de l'audience",
    investorsReached: "investisseurs concernés",
    settings: "Paramètres",
    pinUpdate: "Épingler cette mise à jour",
  },
  projDetail: {
    backToList: "Retour aux projets",
    notFound: "Projet introuvable",
    noProjectData: "Les données du projet sont incomplètes.",
    identitySection: "Identité",
    raiseSection: "Financier",
    subscriptionsSection: "Souscriptions",
    updatesSection: "Mises à jour",
    timelineSection: "Chronologie opérationnelle",
    statusSection: "Statut & Workflow",
    summarySection: "Aperçu rapide",
    documentsSection: "Documents",
    notesSection: "Notes internes",
    visualsSection: "Visuels",
    contentSection: "Contenu",
    publicationSection: "Publication",
    investorPreview: "Aperçu investisseur",
    studioSubBehavior: "Comportement de souscription",
    studioVisibility: "Visibilité & Accès",
    studioStatusLifecycle: "Statut & Cycle de vie",
    studioHighlights: "Points forts",
    studioNoHighlights: "Aucun point fort défini",
    studioCoverImage: "Image de couverture",
    studioNoCover: "Aucune image de couverture",
    studioCoverDesc: "C'est le premier visuel que les investisseurs voient",
    studioGallery: "Galerie & Carrousel",
    studioGalleryDesc: "Gérer la galerie photos dans l'éditeur de page",
    studioPreviewDesc: "Visualisez exactement ce que les investisseurs voient — vérifiez visuels, textes et contenus avant publication.",
    studioOpenPreview: "Ouvrir l'aperçu complet",
    studioEditPage: "Modifier le contenu",
    studioModeChanged: "Les changements s'appliquent aux nouvelles souscriptions uniquement.",
    studioPredefined: "Structure prédéfinie",
    studioPredefinedDesc: "L'investisseur saisit un montant uniquement. Les allocations projet s'appliquent automatiquement.",
    studioChoice: "Choix investisseur",
    studioChoiceDesc: "L'investisseur sélectionne les instruments parmi les types autorisés.",
    studioAllowedInstruments: "Instruments autorisés",
    studioFeeLabel: "Frais (%)",
    studioFeeDescLabel: "Description des frais",
    studioAllocSplit: "Répartition des allocations",
    studioNoAlloc: "Aucune allocation configurée. Les souscriptions seront créées sans répartition automatique.",
    studioPreview10k: "Aperçu : projet de 10 000 €",
    studioNetInvested: "Montant net investi",
    studioTotalDue: "Total dû",
    studioAudience: "Audience",
    studioAllValidated: "Tous les investisseurs validés",
    studioAllValidatedDesc: "Tous les investisseurs avec un compte approuvé peuvent voir ce projet",
    studioPublicPreview: "Aperçu public",
    studioPublicPreviewDesc: "Visible par tous, y compris les visiteurs non authentifiés",
    studioInvitationOnly: "Sur invitation uniquement",
    studioInvitationOnlyDesc: "Seuls les investisseurs spécifiquement invités peuvent accéder à ce projet",
    studioHomepageToggle: "Afficher sur la page d'accueil publique",
    studioHomepageToggleDesc: "Lorsqu'activé, le projet apparaît sur la page d'accueil publique",
    studioVisibleHomepage: "Visible sur la page d'accueil",
    studioHiddenHomepage: "Masqué de la page d'accueil",
    studioCurrentAudience: "Paramètre d'audience actuel",
    studioPageEditorDesc: "Éditez la page investisseur avec sections, galeries, métriques et plus",
    studioSeeInvestors: "Voyez comment le projet apparaît aux investisseurs",
    legalName: "Dénomination juridique",
    location: "Localisation",
    assetClass: "Classe d'actif",
    legalStructure: "Structure juridique",
    currency: "Devise",
    stage: "Phase",
    sponsor: "Commandité",
    minInvestment: "Inv. minimum",
    openDate: "Date d'ouverture",
    closeDate: "Date de clôture",
    investmentTypes: "Types de projet",
    metricTarget: "Objectif de levée",
    metricReserved: "Réservé",
    metricFunded: "Financé",
    metricAllocated: "Alloué",
    metricActive: "Actif",
    metricSubscriptions: "Souscriptions",
    metricInvestors: "Investisseurs",
    metricRequested: "Demandé",
    metricWaiting: "Liste d'attente",
    metricTotal: "total",
    metricPendingFunding: "Financement en attente",
    metricPendingAllocation: "Allocation en attente",
    investorSummary: "Investisseurs dans ce projet",
    invName: "Investisseur",
    invCommitted: "Engagé",
    invFunded: "Financé",
    invAllocated: "Alloué",
    invActive: "Actif",
    invDisplay: "Montant affiché",
    invSubs: "Subs",
    invStatus: "Statut",
    raised: "levé",
    of: "sur",
    statusBreakdown: "Répartition par statut",
    subInvestor: "Investisseur",
    subType: "Type",
    subAmount: "Montant",
    noSubscriptions: "Aucune souscription enregistrée pour ce projet.",
    publishUpdate: "Publier une mise à jour",
    updateTitlePlaceholder: "Titre de la mise à jour...",
    updateContentPlaceholder: "Contenu (visible par les investisseurs)...",
    publish: "Publier",
    updatePublished: "Mise à jour publiée avec succès",
    noUpdates: "Aucune mise à jour publiée.",
    currentStatus: "Statut actuel du projet",
    transitionTo: "Passer à",
    confirmTransition: "Confirmer la transition",
    transitionSuccess: "Statut du projet mis à jour",
    pendingActions: "Actions requises",
    actionStillDraft: "Le projet est encore en brouillon",
    actionPendingSubs: "souscriptions en attente de revue",
    actionAwaitingFunding: "souscriptions en attente de financement",
    summaryInvestors: "Investisseurs uniques",
    summarySubs: "Total souscriptions",
    summaryFunded: "Total financé",
    summaryWaiting: "Liste d'attente",
    summaryDocs: "Documents",
    summaryUpdates: "Mises à jour publiées",
    noDocs: "Aucun document de projet.",
    notesPlaceholder: "Ajouter une note interne...",
    timelineEmpty: "Aucun historique opérationnel enregistré.",
    status: {
      draft: "Brouillon",
      coming_soon: "Bientôt disponible",
      open: "Ouvert",
      nearly_full: "Quasi complet",
      closing_soon: "Clôture imminente",
      closed: "Clôturé",
      fully_funded: "Entièrement financé",
      in_deployment: "En cours d'investissement",
      operational: "Opérationnel",
      exited: "Sorti",
      archived: "Archivé",
    },
  },
  investorUnified: {
    title: "Fiche investisseur",
    tabs: {
      profile: "Profil",
      positions: "Positions",
      distributions: "Distributions",
      tasks: "Taches",
      documents: "Documents",
      history: "Historique",
    },
    profileSection: "Identité & Statut",
    crmSection: "Relation investisseur",
    complianceSection: "Documents de conformité",
    positionsTitle: "Souscriptions & Positions",
    positionsSubtitle: "Vue consolidée de toutes les souscriptions et positions actives.",
    noPositions: "Aucune souscription enregistrée.",
    investmentType: "Type de projet",
    requestedAmount: "Montant demandé",
    approvedAmount: "Montant approuvé",
    projectName: "Projet",
    subscriptionStatus: "Statut",
    distributionsTitle: "Distributions & Remboursements",
    distributionsSubtitle: "Synthèse des allocations reçues et en attente.",
    totalAllocated: "Total attribué aux projets",
    totalPaid: "Total versé",
    totalPending: "En attente",
    noDistributions: "Aucune allocation enregistrée.",
    eventLabel: "Événement",
    allocationAmount: "Montant",
    allocationStatus: "Statut",
    recentAllocations: "Allocations récentes",
    tasksTitle: "Taches internes",
    tasksSubtitle: "Taches opérationnelles liées à cet investisseur.",
    activeTasks: "Taches actives",
    completedTasks: "Taches terminées",
    noTasks: "Aucune tache active.",
    taskTitle: "Intitulé",
    taskPriority: "Priorité",
    taskStatus: "Statut",
    taskDueDate: "Échéance",
    documentsTitle: "Centre documentaire",
    documentsSubtitle: "Tous les documents associés à cet investisseur.",
    byCategory: "Par catégorie",
    noDocuments: "Aucun document enregistré.",
    docType: "Type",
    docStatus: "Statut",
    docDate: "Date",
    historyTitle: "Historique relationnel",
    historySubtitle: "Chronologie complète des interactions, événements et jalons de la relation investisseur.",
    allCategories: "Toutes les catégories",
    timelineCategories: {
      interaction: "Interactions CRM",
      note: "Notes internes",
      task: "Jalons taches",
      distribution: "Distributions",
      communication: "Communications",
      document: "Documents",
      secondary_market: "Marché secondaire",
      onboarding: "Entrée en relation",
      subscription: "Souscriptions",
      movement: "Mouvements",
    },
    noEvents: "Aucun événement enregistré.",
    smSection: "Marché secondaire",
    smActive: "Demandes actives",
    smTotal: "Total demandes",
    noSmRequests: "Aucune demande de transfert.",
    waitingListSection: "Liste d'attente",
  },

  commandCenter: {
    title: "Centre de commande",
    subtitle: "Vue consolidée des signaux opérationnels prioritaires.",
    generatedAt: "Généré le",
    refresh: "Actualiser",
    autoRefresh: {
      label: "Rafraîchissement",
      off: "Arrêt",
      pause: "Mettre en pause",
      lastUpdated: "Mis à jour :",
    },
    severity: {
      critical: "Critique",
      warning: "Attention",
      info: "Information",
      allClear: "Aucun élément urgent — tout est en ordre.",
    },
    vitals: {
      title: "Indicateurs plateforme",
      activeInvestors: "Investisseurs actifs",
      activeProjects: "Projets actifs",
      totalAum: "Encours total",
      activeTasks: "Tâches actives",
      deliverablesProgress: "Livrables validés",
      pendingMovements: "Mouvements en attente",
      pendingAccess: "Demandes d'accès",
      pendingSubscriptions: "Souscriptions en attente",
    },
    sections: {
      criticalItems: "Signaux critiques",
      overdueDeliverables: "Livrables en retard",
      overdueTasks: "Tâches en retard",
      pendingReviews: "En attente de revue",
      pendingDocuments: "Documents en attente",
      pendingDeliverables: "Livrables soumis",
      accessRequests: "Demandes d'accès",
      subscriptionsReview: "Souscriptions en attente",
      expiringDocuments: "Documents expirés / à renouveler",
      expired: "Expirés",
      expiringSoon: "Expiration imminente",
      blockedItems: "Opérations bloquées",
      secondaryMarket: "Marché secondaire",
      staleDistributions: "Distributions en attente prolongée",
      attentionRequired: "Attention requise",
      complianceGaps: "Conformité incomplète",
      dormantCRM: "Relations dormantes",
      dueSoonTasks: "Tâches à échéance proche",
    },
    labels: {
      project: "Projet",
      assignedTo: "Assigné à",
      dueDate: "Échéance",
      investor: "Investisseur",
      category: "Catégorie",
      status: "Statut",
      approvedDocs: "Documents approuvés",
      lastInteraction: "Dernière interaction",
      pendingCount: "En attente",
      pendingAmount: "Montant en attente",
      noItems: "Aucun élément à afficher.",
      viewAll: "Voir tout",
      items: "éléments",
    },
    exports: {
      title: "Exports rapides",
      crm: "Export CRM",
      tasks: "Export tâches",
      deliverables: "Export livrables",
    },
    digest: {
      sendDigest: "Envoyer le briefing",
      previewDigest: "Apercu du briefing",
      digestSent: "Briefing envoyé avec succes.",
      digestError: "Erreur lors de l'envoi du briefing.",
      digestTitle: "Briefing operationnel",
      digestDesc: "Envoi du resume operationnel quotidien aux administrateurs.",
    },
    navigate: {
      tasks: "Tâches",
      documents: "Documents",
      deliverables: "Livrables commandités",
      secondaryMarket: "Marché secondaire",
      distributions: "Distributions",
      crm: "CRM",
      accessRequests: "Demandes d'accès",
      subscriptions: "Souscriptions",
      compliance: "Conformité",
    },
    systemHealth: {
      label: "Santé système",
      ok: "Opérationnel",
      degraded: "Dégradé",
      notConfigured: "Non configuré",
    },
    smSignals: {
      awaitingReview: "Demandes marché secondaire en attente de premier examen",
      staleRequests: "Demandes marché secondaire inactives (>7 jours)",
    },
    supervision: {
      title: "Supervision exécutive",
      subtitle: "Ce qui requiert une décision, ce qui est en retard, ce qui est bloqué, ce qui est prêt.",
      totalAttention: "Points d'attention",
      needsDecision: "Requiert une décision",
      isLate: "En retard",
      isBlocked: "Bloqué",
      isReady: "Prêt",
      smSubmitted: "Transferts soumis",
      subscriptionsPending: "Souscriptions en attente",
      docsPendingReview: "Documents en revue",
      accessRequests: "Demandes d'accès",
      overdueDeliverables: "Livrables en retard",
      overdueTasks: "Tâches en retard",
      smBlocked: "Transferts bloqués",
      onboardingStale: "Entrée en relation en attente",
      smEligible: "Transferts éligibles",
      onboardingGreen: "Entrée en relation opérationnelle",
      noItems: "Aucun élément",
    },
  },

  onboarding: {
    // Re-passe recette Sprint 1 — fusion du bloc `onboarding` DUPLIQUÉ
    // (le doublon investisseur écrasait TOUT le bloc console admin →
    // 80+ clés brutes à l'écran). Clés parcours investisseur conservées :
    done: "Fait",
    journeyComplete: "Votre parcours est complété",
    journeyCompleteDesc: "Toutes les étapes sont remplies. Vos projets sont actifs et suivis.",
    step: {
      account_created: "Compte créé",
      platform_terms_accepted: "Conditions générales acceptées",
      profile_completed: "Profil complété",
      kyc_submitted: "Documents de conformité soumis",
      kyc_approved: "Identité vérifiée",
      subscription_initiated: "Première souscription initiée",
      terms_reviewed: "Conditions de souscription acceptées",
      signature_completed: "Souscription confirmée",
      subscription_confirmed: "Souscription confirmée",
      funding_submitted: "Justificatif de virement soumis",
      funding_confirmed: "Versement confirmé",
      investment_active: "Investissement actif",
    },
    hint: {
      account_created: "Votre compte est configuré.",
      platform_terms_accepted: "Vous avez accepté les conditions générales de la plateforme.",
      profile_completed: "Complétez votre profil investisseur avec vos coordonnées personnelles et fiscales.",
      kyc_submitted: "Téléversez votre pièce d'identité, justificatif de domicile et coordonnées bancaires.",
      kyc_approved: "Notre équipe conformité examine vos documents.",
      subscription_initiated: "Parcourez les projets disponibles et initiez votre premier projet.",
      terms_reviewed: "Consultez les conditions de souscription et les avertissements sur les risques.",
      signature_completed: "Votre demande de souscription a été confirmée. Les documents seront préparés par l'équipe.",
      subscription_confirmed: "Votre demande de souscription a été confirmée. Les documents seront préparés par l'équipe.",
      funding_submitted: "Téléversez votre confirmation de virement ou relevé bancaire.",
      funding_confirmed: "Notre équipe vérifie votre virement.",
      investment_active: "Votre projet sera activé une fois le versement confirmé.",
    },
    cta: {
      profile_completed: "Compléter le profil",
      kyc_submitted: "Téléverser les documents",
      subscription_initiated: "Parcourir les projets",
      terms_reviewed: "Consulter et confirmer",
      signature_completed: "Voir le statut",
      subscription_confirmed: "Voir le statut",
      funding_submitted: "Soumettre le justificatif",
    },
    title: "Console de mise en place",
    subtitle: "Exécution contrôlée de la mise en place des projets.",
    createProject: "Nouveau projet",
    editProject: "Modifier",
    projectName: "Nom du projet",
    description: "Description",
    linkedProject: "Projet lié",
    linkedWaves: "Vagues de migration liées",
    owner: "Responsable",
    targetDate: "Date cible",
    noProjects: "Aucun projet en mise en place. Créez-en un pour démarrer.",
    stage: "Étape",
    progress: "Avancement",
    readiness: "Préparation",
    stages: {
      not_started: "Non démarré",
      source_files_received: "Fichiers source reçus",
      source_files_reviewed: "Fichiers source revus",
      migration_wave_created: "Vague de migration créée",
      dry_run_completed: "Dry-run terminé",
      qa_review_completed: "Revue QA terminée",
      corrections_applied: "Corrections appliquées",
      final_import_executed: "Import final exécuté",
      post_import_validation: "Validation post-import",
      validated_internally: "Validé en interne",
      live: "En production",
    },
    readinessStates: {
      ok: "OK",
      warning: "Attention",
      needs_review: "Revue nécessaire",
      blocked: "Bloqué",
    },
    checklist: {
      title: "Checklist d'exécution",
      autoDetected: "Auto-détecté",
      manualValidation: "Validation manuelle",
      pending: "En attente",
      completed: "Terminé",
      markCompleted: "Valider",
      markPending: "Remettre en attente",
      addNote: "Ajouter une note",
    },
    blockers: {
      title: "Bloquants et signaux",
      noBlockers: "Aucun bloquant détecté.",
    },
    journal: {
      title: "Journal d'exécution",
      noEntries: "Aucune entrée.",
      addNote: "Ajouter une note",
      notePlaceholder: "Note d'exécution...",
      types: {
        stage_change: "Changement d'étape",
        checklist: "Checklist",
        note: "Note",
        task_created: "Tâche créée",
        playbook_applied: "Playbook appliqué",
      },
    },
    transitions: {
      title: "Changer l'étape",
      confirm: "Confirmer la transition",
      notePlaceholder: "Note de transition (optionnel)...",
    },
    actions: {
      createTask: "Créer une tâche",
      applyPlaybook: "Appliquer un playbook",
      openImportToolkit: "Import toolkit",
      openQAConsole: "Console QA",
      openMigrationWaves: "Vagues de migration",
      openProjectOps: "Opérations projet",
      openCommandCenter: "Centre de commande",
    },
    linkedSessions: "Sessions d'import liées",
    linkedTasks: "Tâches liées",
    linkedWavesList: "Vagues de migration",
    noLinkedWaves: "Aucune vague liée.",
    noLinkedSessions: "Aucune session liée.",
    noLinkedTasks: "Aucune tâche liée.",
    nextAction: "Prochaine étape",
    allChecklistComplete: "Checklist complète",
    phases: {
      preparation: "Préparation",
      import_validation: "Import & Validation",
      post_import: "Post-import & go-live",
    },
    guidance: {
      responsible: "Responsable",
      expectedDuration: "Durée estimée",
      showGuidance: "Voir le guide",
      hideGuidance: "Masquer le guide",
      ops: "Équipe opérations",
      admin: "Administrateur",
      super_admin: "Super administrateur",
    },
    quickActions: {
      title: "Actions rapides",
      createWave: "Créer une vague de migration",
      startImport: "Lancer un import",
      openQAReview: "Revue QA",
      exportQA: "Exporter le rapport QA",
      postImportReview: "Revue post-import",
      openProjectOps: "Opérations projet",
    },
    entityContext: {
      title: "Contexte du projet",
      expectedInvestors: "Investisseurs attendus",
      expectedSubscriptions: "Souscriptions attendues",
      expectedDocuments: "Documents attendus",
      specialConsiderations: "Points d'attention",
      importOrder: "Ordre d'import",
      suggestedWaveName: "Nom de vague suggéré",
    },
    preflight: {
      title: "Contrôle pré-import",
      subtitle: "Vérification de l'état de préparation avant de lancer un import.",
      running: "Vérification en cours...",
      canProceed: "Tous les contrôles bloquants sont résolus. Vous pouvez lancer l'import.",
      cannotProceed: "Des problèmes bloquants empêchent le lancement de l'import.",
      proceedToImport: "Lancer l'import",
      cancel: "Annuler",
      blocking: "Bloquant",
      warning: "Avertissement",
      ready: "Prêt",
      summaryBlocking: "bloquant(s)",
      summaryWarnings: "avertissement(s)",
      summaryReady: "prêt(s)",
      showDetail: "Détail",
      hideDetail: "Masquer",
    },
    reconciliation: {
      title: "Réconciliation post-import",
      subtitle: "Comparaison entre les fichiers source et les enregistrements créés sur la plateforme.",
      noData: "Aucune session d'import exécutée trouvée.",
      noDataHint: "Lancez un import depuis l'Import Toolkit pour obtenir une réconciliation.",
      overallOk: "Import aligné — aucun écart détecté.",
      overallWarning: "Avertissements détectés — vérification recommandée.",
      overallMismatch: "Écarts détectés — revue nécessaire.",
      dataset: "Dataset",
      sourceRows: "Lignes source",
      created: "Créés",
      skipped: "Ignorés",
      rejected: "Rejetés",
      platformCount: "Plateforme",
      status: "Statut",
      sessions: "Session(s)",
      ok: "OK",
      warning: "Attention",
      mismatch: "Écart",
      totals: "Totaux",
      openQA: "Ouvrir la Console QA",
      openImport: "Retour à l'Import Toolkit",
      close: "Fermer",
      refreshing: "Actualisation...",
    },
  },

  automation: {
    title: "Centre d'automatisation",
    subtitle: "Signaux opérationnels, suggestions de tâches et suivi des déclencheurs.",
    rescan: "Relancer le scan",
    history: "Historique",
    totalSignals: "Signaux détectés",
    activeTriggers: "Déclencheurs actifs",
    totalTriggers: "Déclencheurs surveillés",
    createTask: "Créer une tâche",
    taskCreated: "Tâche créée avec succès.",
    noSignals: "Aucun signal pour ces déclencheurs",
    noHistory: "Aucune tâche créée par automatisation.",
    lastScan: "Dernier scan",
  },


  reporting: {
    title: "Centre de rapports",
    subtitle: "Vue consolidée de votre patrimoine, de vos flux reçus et de vos positions.",
    exportGlobal: "Exporter le relevé global",
    exportProject: "Exporter le relevé projet",
    exporting: "Export en cours...",
    exportSuccess: "Relevé exporté avec succès.",
    exportError: "Échec de l'export. Veuillez réessayer.",
    totalPortfolio: "Capital investi",
    totalDistributed: "Flux reçus",
    pendingDist: "Flux à venir",
    projectCount: "Projets",
    activeProjects: "Projets actifs",
    positions: "Positions",
    operations: "opérations",
    byProject: "Rapport par projet",
    invested: "Investi",
    distributed: "Flux reçus",
    distributionTimeline: "Historique des flux reçus",
    distributionHistory: "Historique global des flux reçus",
    noDistributions: "Aucun flux reçu pour le moment.",
    operation: "Opération",
    date: "Date",
    amount: "Montant",
  },

  subFlow: {
    stepInvestment: "Investissement",
    stepIdentity: "Identité",
    stepReview: "Vérification",
    stepSign: "Confirmation",
    stepConfirmation: "Confirmation",
    stepSubmission: "Envoi",
    stepLabel: "Étape",
    selectInvestmentType: "Sélectionnez votre type de projet",
    enterAmount: "Définissez votre montant de projet",
    minInvestment: "Investissement minimum",
    quickAmounts: "Montants courants",
    investmentSummary: "Votre projet",
    entityType: "Type d'entité",
    individual: "Personne physique",
    company: "Société",
    holdingSpv: "Holding / SPV",
    entityName: "Raison sociale complète",
    legalDocsNotice: "Les documents juridiques de l'entité devront être fournis dans votre espace conformité avant validation.",
    profileInfoTitle: "Informations du profil",
    nameLabel: "Nom",
    countryLabel: "Pays",
    reviewTitle: "Vérifiez votre souscription",
    investmentTypeLabel: "Type de projet",
    amountLabel: "Montant",
    subscriberLabel: "Souscripteur",
    projectLabel: "Projet",
    docTitle: "Récapitulatif de l'intention de projet",
    docSubtitle: "",
    docSubscriber: "Souscripteur",
    docEntityType: "Type d'entité",
    docProject: "Projet",
    docInvestmentType: "Type de projet",
    docAmount: "Montant",
    docFooter: "Le bulletin de souscription complet vous sera transmis par email pour signature électronique après validation de votre demande par notre équipe.",
    confirmCheckboxTitle: "Je confirme ma volonté de souscrire",
    confirmCheckboxDesc: "En cochant cette case, je confirme avoir lu et accepté les conditions de souscription, et j'autorise le traitement de ma demande. Les documents de souscription seront préparés et envoyés pour signature électronique après validation.",
    confirmationTitle: "Souscription enregistrée",
    confirmationText: "Votre demande de souscription de",
    confirmationTextFor: "pour le projet",
    confirmationTextEnd: "a été soumise. Notre équipe examinera et traitera votre demande.",
    next: "Continuer",
    submit: "Soumettre la souscription",
    back: "Retour",
    close: "Fermer",
    goToDashboard: "Accéder au tableau de bord",
    goToSubscriptions: "Voir mes souscriptions",
    wireTitle: "Instructions de virement",
    wireSubtitle: "Veuillez utiliser les coordonnées ci-dessous pour votre virement.",
    wireBank: "Banque",
    wireIban: "IBAN",
    wireBic: "BIC/SWIFT",
    wireRef: "Référence",
    wireAmount: "Montant",
    amountTitle: "Montant de souscription",
    amountSubtitle: "Définissez le montant que vous souhaitez investir dans",
    investTypeLabel: "Type de projet",
    amountEur: "Montant (EUR)",
    entityTitle: "Identité du souscripteur",
    entitySubtitle: "Confirmez l'entité au nom de laquelle vous souscrivez.",
    subscriberTypeLabel: "Type de souscripteur",
    entityNameLabel: "Nom complet",
    entityNameLabelCompany: "Dénomination sociale",
    reviewConditionsTitle: "Vérification et conditions",
    reviewConditionsSubtitle: "Veuillez confirmer les informations et accepter les conditions avant de soumettre.",
    complianceValidated: "Dossier de conformité validé",
    complianceIncomplete: "Dossier de conformité incomplet",
    docsApproved: "documents approuvés",
    pendingKycNotice: "Votre souscription sera soumise en attente de validation de vos documents KYC.",
    summaryTitle: "Récapitulatif",
    locationLabel: "Localisation",
    subscriptionAmount: "Montant de souscription",
    riskAcknowledge: "J'ai pris connaissance des risques liés à cet investissement, notamment le risque de perte en capital.",
    termsAccept: "J'accepte les conditions générales de souscription et la documentation juridique du projet.",
    nonLiquidAccept: "Je comprends que cet investissement est non-liquide et que la durée de détention recommandée est de plusieurs années.",
    notesLabel: "Notes (optionnel)",
    notesPlaceholder: "Précisions ou commentaires...",
    signTitle: "Confirmation de souscription",
    signSubtitle: "Confirmez votre intention de projet avant soumission.",
    confirmTitle: "Bulletin de souscription en cours d'édition",
    confirmSubtitle: "Après validation de votre dossier",
    confirmSubmitTitle: "Confirmer et soumettre",
    confirmSubmitSubtitle: "Dernière étape avant soumission de votre demande de souscription.",
    subscriptionSummary: "Récapitulatif de souscription",
    entityLabel: "Entité",
    signatureLabel: "Confirmation",
    signatureConfirmed: "Confirmée",
    confirmLabel: "Confirmation",
    intentConfirmed: "Confirmée",
    wireIntroTitle: "Procédure de souscription",
    wireIntroDesc: "Les coordonnées bancaires complètes vous seront communiquées par email après validation de votre souscription. Voici un aperçu de la procédure :",
    wireStep1Title: "Validation",
    wireStep1Desc: "Notre équipe examine et valide votre demande sous 48h ouvrées.",
    wireStep2Title: "Documents",
    wireStep2Desc: "Vous recevez le bulletin de souscription et les documents juridiques pour signature électronique.",
    wireStep3Title: "Virement",
    wireStep3Desc: "Vous effectuez le virement du montant souscrit selon les coordonnées communiquées.",
    wireStep4Title: "Confirmation",
    wireStep4Desc: "Réception des fonds confirmée et parts inscrites à votre patrimoine.",
    confirmSubscription: "Confirmer la souscription",
    processingLabel: "Traitement en cours...",
    submitDisclaimer: "Cette demande sera examinée par notre équipe. Elle n'est pas un engagement irrévocable tant que les documents de souscription n'ont pas été signés électroniquement.",
    cancel: "Annuler",
    successTitle: "Souscription enregistrée",
    successText: "Votre demande de souscription de",
    successTextProject: "pour le projet",
    successTextEnd: "a été transmise à notre équipe pour validation.",
    nextStepsTitle: "Prochaines étapes",
    successStep1: "Vérification de votre dossier par notre équipe",
    successStep2: "Préparation et envoi des documents pour signature électronique",
    successStep3: "Instructions de virement communiquées",
    successStep4: "Confirmation de réception des fonds",
    backToProject: "Retour au projet",
  },


  security: {
    // Re-passe recette Sprint 1
    connectionError: "Erreur de connexion au serveur. Vérifiez votre connexion internet.",
    title: "Console de sécurité",
    subtitle: "Surveillance de la sécurité d'authentification et contrôle MFA.",
    dashboard: "Tableau de bord",
    authEvents: "Événements d'authentification",
    mfaManagement: "Gestion MFA",
    failedAttempts24h: "Tentatives échouées (24h)",
    lockedAccounts24h: "Comptes verrouillés (24h)",
    suspiciousIps24h: "IP suspectes (24h)",
    passwordResets7d: "Réinitialisations (7j)",
    mfaSummary: "Statut MFA administrateurs",
    mfaActive: "MFA actif",
    mfaPending: "En attente",
    mfaNone: "Sans MFA",
    totalAdmins: "Total administrateurs",
    recentAdminLogins: "Connexions admin récentes",
    concerningEvents: "Événements préoccupants",
    activeLocks: "Comptes actuellement verrouillés",
    noRecentLogins: "Aucune connexion admin récente.",
    noConcerningEvents: "Aucun événement préoccupant.",
    noActiveLocks: "Aucun compte verrouillé.",
    adminAccounts: "Comptes administrateurs",
    mfaStatus: "Statut MFA",
    lastLogin: "Dernière connexion",
    mfaEnabled: "MFA activé",
    mfaDisabled: "MFA désactivé",
    setupMfa: "Configurer le MFA",
    disableMfa: "Désactiver le MFA",
    scanQrCode: "Scannez ce QR code avec votre application d'authentification.",
    enterCode: "Entrez le code à 6 chiffres",
    confirmSetup: "Confirmer l'activation",
    mfaSetupSuccess: "MFA activé avec succès.",
    mfaDisableSuccess: "MFA désactivé.",
    invalidCode: "Code invalide. Réessayez.",
    enterCodeToDisable: "Entrez un code MFA pour confirmer la désactivation.",
    eventType: "Type",
    email: "E-mail",
    ip: "Adresse IP",
    detail: "Détail",
    timestamp: "Date",
    filterByType: "Filtrer par type",
    allTypes: "Tous les types",
    noEvents: "Aucun événement.",
    lockedUntil: "Verrouillé jusqu'au",
    sessionsTab: "Sessions",
    device: "Appareil",
    sessionCreated: "Créée le",
    lastActivity: "Dernière activité",
    sessionStatus: "Statut",
    currentSession: "Session actuelle",
    activeStatus: "Active",
    revokedStatus: "Révoquée",
    expiredStatus: "Expirée",
    revoke: "Révoquer",
    confirmRevoke: "Êtes-vous sûr de vouloir révoquer cette session ? L'utilisateur sera déconnecté immédiatement.",
    confirmRevokeAll: "Êtes-vous sûr de vouloir révoquer toutes les sessions de cet utilisateur ?",
    showRevoked: "Afficher les sessions révoquées",
    noSessions: "Aucune session active.",
    mfaEnrollmentTitle: "Configuration MFA obligatoire",
    mfaEnrollmentSubtitle: "La double authentification est requise pour ce compte. Configurez votre application pour continuer.",
    // APEX M2 — enrôlement universel + codes de récupération
    mfaImposedSubtitle: "La double authentification a été rendue obligatoire sur votre compte par votre administrateur. Configurez votre application pour continuer.",
    mfaSessionExpired: "Session expirée. Veuillez vous reconnecter.",
    recoveryCodesTitle: "Codes de récupération",
    recoveryCodesWarning: "Conservez ces codes en lieu sûr : chacun ne peut être utilisé qu'une seule fois pour vous connecter si vous perdez l'accès à votre application. Ils ne seront plus jamais affichés.",
    mfaContinue: "J'ai sauvegardé mes codes — Continuer",
    mfaEnrollmentWarning: "Vous devez configurer le MFA avant de pouvoir accéder aux fonctionnalités d'administration.",
    mfaEnrollmentComplete: "Veuillez vous reconnecter pour accéder à l'administration avec votre code MFA.",
    goToLogin: "Se connecter",
  },
  contributions: {
    label: "CONTRIBUTION PROJET",
    title: "Contribution au contenu projet",
    backToProject: "Retour au projet",
    submitForReview: "Soumettre pour validation",
    submitting: "Soumission en cours...",
    submitted: "Contribution soumise pour validation.",
    submitConfirm: "Soumettre cette contribution pour validation par l'équipe interne ?",
    submitError: "Échec de la soumission.",
    sectionSaved: "Section enregistrée.",
    saveError: "Erreur lors de l'enregistrement.",
    saveSection: "Enregistrer",
    saving: "Enregistrement...",
    reviewFeedback: "Retours de l'équipe de validation",
    globalReview: "Décision globale",
    mediaTitle: "Visuels et documents",
    mediaDesc: "Ajoutez des visuels projet, galerie d'images, présentations et documents complémentaires.",
    mediaUploaded: "Fichier téléchargé.",
    uploadError: "Échec du téléchargement.",
    deleteMediaConfirm: "Supprimer ce fichier ?",
    mediaDeleted: "Fichier supprimé.",
    deleteError: "Erreur lors de la suppression.",
    noMedia: "Aucun visuel ou document ajouté.",
    highlightItem: "Point clé",
    addHighlight: "Ajouter un point clé",
    milestoneTitle: "Étape",
    milestoneDesc: "Description",
    addMilestone: "Ajouter une étape",
    metricLabel: "Indicateur",
    metricValue: "Valeur",
    addMetric: "Ajouter un indicateur",
    mediaType: {
      main_visual: "Visuel principal",
      gallery: "Galerie d'images",
      document: "Document",
      presentation: "Présentation",
    },
    status: {
      draft: "Brouillon",
      submitted: "Soumis",
      in_review: "En cours de validation",
      approved: "Approuvé",
      changes_requested: "Modifications demandées",
      rejected: "Refusé",
    },
    sections: {
      short_summary: "Résumé court",
      long_description: "Description détaillée",
      highlights: "Points clés / Thèse de projet",
      timeline_milestones: "Calendrier / Jalons",
      sponsor_presentation: "Présentation du commandité / opérateur",
      key_metrics: "Indicateurs clés",
      legal_notes: "Notes juridiques / Structuration",
      risk_notes: "Notes sur les risques",
      fundraising_notes: "Notes sur la levée de fonds",
    },
    sectionHelp: {
      short_summary: "Résumé synthétique du projet (2-3 phrases).",
      long_description: "Description complète du projet, son contexte et ses objectifs.",
      highlights: "Points clés différenciants et éléments de la thèse de projet.",
      timeline_milestones: "Étapes clés du projet avec dates prévisionnelles.",
      sponsor_presentation: "Présentation de l'opérateur ou du commandité du projet.",
      key_metrics: "Indicateurs factuels clés du projet (surface, rendement, etc.).",
      legal_notes: "Informations sur la structure juridique et les aspects légaux.",
      risk_notes: "Facteurs de risque identifiés et mesures de mitigation.",
      fundraising_notes: "Informations relatives à la levée de fonds et aux conditions de projet.",
    },
    sectionPlaceholder: {
      short_summary: "Résumé concis du projet...",
      long_description: "Description détaillée du projet, contexte, objectifs...",
      highlights: "",
      timeline_milestones: "",
      sponsor_presentation: "Présentation du commandité, son expérience, son équipe...",
      key_metrics: "",
      legal_notes: "Structure juridique, véhicule de projet, cadre réglementaire...",
      risk_notes: "Risques identifiés, facteurs de sensibilité...",
      fundraising_notes: "Conditions de la levée, ticket minimum, calendrier de souscription...",
    },
    adminLabel: "VALIDATION CONTRIBUTIONS",
    adminTitle: "Contributions projets commandités",
    adminSubtitle: "Validation et publication du contenu proposé par les commandités.",
    allStatuses: "Tous",
    noContributions: "Aucune contribution commandité en attente.",
    pendingSections: "sections soumises",
    mediaFiles: "fichiers",
    submittedAt: "Soumis le",
    reviewLabel: "VALIDATION",
    sponsorLabel: "Commandité",
    globalDecision: "Décision globale",
    reviewNotePlaceholder: "Note ou commentaire pour le commandité (optionnel)...",
    approveAll: "Tout approuver",
    requestChanges: "Demander des modifications",
    rejectAll: "Tout refuser",
    decisionApplied: "Décision appliquée.",
    reviewError: "Erreur lors de la validation.",
    approve: "Approuver",
    requestChange: "Demander une modification",
    reject: "Refuser",
    noContent: "Aucun contenu proposé.",
    mediaReviewed: "Fichier validé.",
    reviewHistory: "Historique des validations",
    backToList: "Retour aux contributions",
    navContributions: "Contributions projets",
    sponsorNavContribute: "Contribuer au projet",
  },
  pageEditor: {
    label: "EDITEUR PAGE PROJET",
    backToProjects: "Retour aux projets",
    untitled: "Page sans titre",
    status: {
      draft: "Brouillon",
      published: "Publiée",
      archived: "Archivée",
    },
    saveDraft: "Enregistrer",
    saving: "Enregistrement...",
    saved: "Page enregistrée.",
    saveError: "Erreur d'enregistrement.",
    publish: "Publier",
    publishConfirm: "Publier cette page projet ? Elle sera visible par les investisseurs.",
    status_published: "Page publiée.",
    status_draft: "Page repassée en brouillon.",
    status_archived: "Page archivée.",
    statusError: "Erreur de changement de statut.",
    unpublish: "Dépublier",
    archive: "Archiver",
    contributionAvailable: "Contenu commandité approuvé disponible",
    approvedSections: "sections approuvées",
    approvedMedia: "fichiers approuvés",
    prefillAction: "Pré-remplir depuis la contribution",
    prefilling: "Import en cours...",
    prefilled: "Page pré-remplie depuis la contribution commandité.",
    prefillConfirm: "Importer le contenu approuvé de la contribution commandité ? Les champs existants seront écrasés.",
    prefillError: "Erreur lors du pré-remplissage.",
    titleAndSlug: "Titre, sous-titre et URL",
    titlePlaceholder: "Titre du projet",
    subtitlePlaceholder: "Sous-titre ou accroche",
    shortSummary: "Résumé court",
    summaryPlaceholder: "Résumé synthétique du projet (2-3 phrases)...",
    investmentThesis: "Thèse de projet",
    thesisPlaceholder: "Pourquoi ce projet est une opportunité de projet...",
    longDescription: "Description détaillée",
    descPlaceholder: "Description complète du projet...",
    highlights: "Points clés",
    highlightPlaceholder: "Point clé",
    addHighlight: "Ajouter un point clé",
    sponsorPresentation: "Présentation du commandité / opérateur",
    sponsorPlaceholder: "Présentation du commandité, son expérience, son équipe...",
    legalNotes: "Structure juridique",
    legalPlaceholder: "Structure juridique, véhicule, cadre réglementaire...",
    riskNotes: "Facteurs de risque",
    riskPlaceholder: "Risques identifiés, facteurs de sensibilité...",
    keyMetrics: "Indicateurs clés",
    metricLabel: "Indicateur",
    metricValue: "Valeur",
    addMetric: "Ajouter un indicateur",
    timeline: "Calendrier / Jalons",
    milestoneTitle: "Étape",
    milestoneDesc: "Description",
    addMilestone: "Ajouter un jalon",
    fundraisingNotes: "Notes sur la levée",
    fundraisingNotesPlaceholder: "Conditions de la levée, ticket minimum...",
    contactBlock: "Bloc contact investisseur",
    contactPlaceholder: "Informations de contact pour les investisseurs...",
    fundraising: "Levée de fonds",
    refresh: "Actualiser",
    targetAmount: "Objectif de levée (EUR)",
    amountRaised: "Montant levé (EUR)",
    openingDate: "Date d'ouverture",
    closingDate: "Date de clôture",
    showProgress: "Afficher la barre de progression",
    fundraisingRefreshed: "Données de levée actualisées.",
    refreshError: "Erreur d'actualisation.",
    heroVisual: "Visuel principal",
    uploadHero: "Ajouter un visuel principal",
    fromSponsor: "contribution commandité",
    gallery: "Galerie",
    addToGallery: "Ajouter à la galerie",
    documents: "Documents",
    addDocument: "Ajouter un document",
    mediaUploaded: "Fichier ajouté.",
    uploadError: "Erreur de téléchargement.",
    deleteError: "Erreur de suppression.",
    publishedAt: "Publiée le",
    prefillSource: "Contenu pré-rempli depuis une contribution commandité.",
    navPageEditor: "Pages projets",
    preview: "Apercu",
    previewMode: "Mode apercu — Vue investisseur",
    previewStatus: "Statut actuel",
    closePreview: "Fermer l'apercu",
    previewSubscriptionNote: "Le formulaire de souscription s'affichera ici pour les investisseurs.",
  },
  projectPage: {
    keyMetrics: "Indicateurs clés",
    sponsor: "Commandité / Opérateur",
    timeline: "Calendrier du projet",
    gallery: "Galerie",
    legalStructure: "Structure juridique",
    fundraisingConditions: "Conditions de la levée",
    projectDocument: "Document projet",
    opening: "Ouverture",
    closing: "Clôture",
  },
  investmentDetail: {
    overline: "Mes projets",
    backToPortfolio: "Retour à mon patrimoine",
    commitment: "Engagement",
    investmentType: "Type de projet",
    subscriptionDate: "Date de souscription",
    currentStatus: "Statut actuel",
    projectLabel: "Projet",
    locationLabel: "Localisation",
    entityLabel: "Entité",
    lifecycleTitle: "Cycle de vie de votre investissement",
    stageSubmitted: "Soumis",
    stageApproved: "Validé",
    stageAllocated: "Financé",
    stageActive: "Actif",
    stageCompleted: "Clôturé",
    timelineTitle: "Chronologie",
    timelineEmpty: "Aucune activité enregistrée pour cet investissement.",
    timelineStatusChange: "Changement de statut",
    timelineMovement: "Mouvement de fonds",
    timelineDistribution: "Flux reçu",
    timelineUpdate: "Mise à jour projet",
    movementsTitle: "Mouvements de fonds",
    movementsEmpty: "Aucun mouvement enregistré pour cet investissement.",
    distributionsTitle: "Distributions et rendements",
    distributionsEmpty: "Aucune distribution versée sur cet investissement à ce jour.",
    totalDistributed: "Total distribué",
    documentsTitle: "Documents de projet",
    documentsEmpty: "Aucun document associé à cet investissement.",
    updatesTitle: "Mises à jour du projet",
    updatesEmpty: "Aucune mise à jour projet disponible.",
    nextStepsTitle: "Prochaines étapes",
    nextReview: "Votre souscription est en cours d'examen par notre équipe. Vous serez notifié dès sa validation.",
    nextFunding: "Votre souscription a été validée. Veuillez suivre les instructions de virement envoyées par email.",
    nextAcceptTerms: "Votre souscription a été validée. Veuillez consulter les conditions et confirmer votre demande de souscription.",
    nextSignDocuments: "Vos conditions ont été acceptées. Notre équipe préparera et vous enverra les documents de souscription pour signature électronique.",
    nextCompleteFunding: "Votre demande de souscription a été confirmée. Veuillez compléter le versement par virement bancaire.",
    nextFundingReview: "Votre justificatif de versement a été soumis et est en cours de vérification.",
    nextAllocationPending: "Votre versement a été confirmé. Votre projet est en cours d'allocation.",
    nextConfirmation: "Nous confirmons la réception de vos fonds. Votre projet sera activé sous peu.",
    nextMonitoring: "Votre projet est actif. Suivez l'avancement du projet, les flux reçus et les mises à jour depuis cette page.",
    ctaAcceptTerms: "Consulter et confirmer",
    ctaSignDocuments: "Voir la souscription",
    ctaCompleteFunding: "Compléter le versement",
    stagePendingSignature: "En attente de documents",
    stageSigned: "Documents reçus",
    stageAwaitingTransfer: "Virement en attente",
    stageTransferConfirmed: "Virement confirmé",
    stagePendingFunding: "Versement",
    stageFunded: "Financé",
    viewAllUpdates: "Voir toutes les mises à jour",
    viewAllMovements: "Voir tous les mouvements",
    // Lot 343D · #2 — libellés FR manquants (bloc FINANCIALBREAKDOWN)
    financialBreakdown: "Détail financier",
    grossSent: "Brut versé",
    fees: "Frais",
    netInvested: "Net investi",
    netInvestedCapital: "Capital net investi",
    allocationComposition: "Composition de votre investissement",
  },
  dashboardEnhanced: {
    activityTitle: "Activité récente",
    activityEmpty: "Aucune activité récente sur vos projets.",
    portfolioOverviewTitle: "Patrimoine en un coup d'œil",
    totalCommitted: "Capital investi",
    activeInvestments: "Investissements actifs",
    pendingActions: "Actions en attente",
    totalDistributed: "Flux reçus",
    quickActionsTitle: "Accès rapides",
    viewPortfolio: "Mon patrimoine",
    viewProjects: "Opportunités",
    viewDocuments: "Mes documents",
    viewReporting: "Centre de reporting",
    investmentSummary: "Synthèse des projets",
    latestUpdates: "Dernières mises à jour",
    noUpdatesYet: "Aucune mise à jour projet. Les informations apparaîtront ici au fur et à mesure de l'avancement de vos projets.",
    viewUpdate: "Lire la suite",
    seeAllUpdates: "Voir toutes les mises à jour",
  },

  pinnedBanner: {
    label: "Communications importantes",
    readUpdate: "Lire la mise à jour",
    dismiss: "Fermer",
  },

  subCompletion: {
    backToInvestment: "Retour à l'investissement",
    backToPortfolio: "Retour à mon patrimoine",
    overline: "FINALISATION DE SOUSCRIPTION",
    stepRecap: "Récapitulatif",
    stepDocuments: "Documents et versement",
    stepConfirmation: "Confirmation",
    step: {
      recap: "Récapitulatif",
      signature: "Documents et versement",
      funding: "Versement",
      confirmation: "Confirmation",
    },
    recapTitle: "Récapitulatif de souscription",
    project: "Projet",
    vehicle: "Véhicule de projet",
    amount: "Montant d'engagement",
    type: "Type de projet",
    holdingPeriod: "Durée de détention cible",
    expectedReturn: "Rendement attendu",
    investor: "Investisseur",
    investorType: "Catégorie d'investisseur",
    entity: "Entité",
    taxResidence: "Résidence fiscale",
    nationality: "Nationalité",
    status: "Statut",
    feeStructure: "Structure de frais",
    subscriptionFee: "Frais de souscription",
    managementFee: "Frais de gestion",
    performanceFee: "Commission de performance",
    documentsToSign: "Documents de souscription",
    documentsRequired: "Documents requis",
    documentsRequiredNote: "Les documents suivants seront préparés par notre équipe et envoyés pour votre signature électronique.",
    documentsTitle: "Documents de souscription",
    documentsSubtitle: "Vos documents de souscription sont en cours de préparation par notre équipe.",
    manualProcessTitle: "Processus de signature électronique",
    manualProcessDesc: "Les documents de souscription vous seront envoyés pour signature électronique. Aucune signature papier n'est requise.",
    processSteps: "Ce qui va se passer",
    processStep1: "Notre équipe valide votre demande de souscription.",
    processStep2: "Le bulletin de souscription est préparé et vous est envoyé par email ou envoi sécurisé.",
    processStep3: "Vous signez les documents et les retournez à notre équipe.",
    processStep4: "Une fois reçus et vérifiés, vos instructions de versement sont confirmées.",
    confirmSubscriptionRequest: "Confirmer la demande de souscription",
    acknowledgements: "Avertissements sur les risques",
    risk: {
      capital_risk: "Le capital est à risque. Vous pourriez perdre tout ou partie de votre projet.",
      liquidity_risk: "Cet projet est illiquide. Vous pourriez ne pas pouvoir vendre ou transférer votre position avant la fin de la période de détention.",
      market_risk: "La valeur de l'investissement peut être affectée par les conditions de marché, les taux d'intérêt ou des facteurs économiques.",
      regulatory_risk: "Des modifications législatives, réglementaires ou fiscales peuvent affecter défavorablement l'investissement.",
      no_guaranteed_return: "Les performances passées ne garantissent pas les résultats futurs. Les rendements ne sont pas garantis.",
    },
    confirmTerms: "J'ai lu et j'accepte les conditions de souscription, y compris le mémorandum de projet.",
    confirmRisk: "Je reconnais les risques décrits ci-dessus et confirme comprendre la nature de cet investissement.",
    confirmLockup: "Je comprends que cet investissement est soumis à une période de blocage et qu'un remboursement anticipé peut ne pas être possible.",
    acceptAndSign: "Accepter les conditions et confirmer",
    termsAccepted: "Conditions acceptées. Demande de souscription confirmée.",
    signatureTitle: "Traitement des documents",
    signatureSubtitle: "Notre équipe préparera et enverra les documents de souscription pour signature électronique.",
    noSignatureRequests: "Aucun document en attente. Acceptez d'abord les conditions.",
    signNow: "Voir les documents",
    signed: "Demande de souscription confirmée.",
    allSigned: "Tous les documents traités",
    proceedToFunding: "Votre souscription a été confirmée. Vous pouvez maintenant procéder au versement.",
    proceedToFundingBtn: "Procéder au versement",
    sigStatus: {
      sent: "En attente",
      delivered: "Délivré",
      viewed: "Consulté",
      signed: "Reçu",
      completed: "Complété",
      declined: "Refusé",
      expired: "Expiré",
    },
    fundingTitle: "Instructions de versement",
    fundingSubtitle: "Complétez votre projet en transférant les fonds selon les détails ci-dessous.",
    wireDetails: "Détails du virement bancaire",
    beneficiary: "Bénéficiaire",
    bankName: "Banque",
    reference: "Référence de paiement",
    amountToPay: "Montant à transférer",
    fundingNote: "Veuillez utiliser la référence de paiement exacte indiquée ci-dessus. Les fonds sont généralement confirmés sous 2 à 5 jours ouvrés.",
    uploadProof: "Téléverser un justificatif de virement",
    uploadProofDesc: "Téléversez une copie de votre confirmation de virement ou un relevé bancaire montrant le paiement.",
    selectFile: "Sélectionner un fichier (PDF, PNG, JPG)",
    proofNotes: "Notes optionnelles (ex. date du virement, numéro de référence)",
    submitProof: "Soumettre le justificatif",
    proofUploaded: "Justificatif de versement soumis pour vérification.",
    submittedProofs: "Justificatifs soumis",
    proofStatus: {
      submitted: "Soumis",
      underReview: "En cours de vérification",
      approved: "Approuvé",
      rejected: "Rejeté",
    },
    proofPending: "En attente de vérification",
    proofApproved: "Approuvé",
    proofRejected: "Rejeté",
    whatHappensNext: "Prochaines étapes",
    nextStep1: "Notre équipe vérifiera votre virement sous 2 à 5 jours ouvrés.",
    nextStep2: "Une fois confirmé, vos parts seront attribuées et votre souscription activée.",
    nextStep3: "Vous recevrez une notification lorsque votre projet sera entièrement actif.",
    completionTitle: "Souscription finalisée",
    completionDesc: "Votre souscription a été financée et est en cours de traitement. Vous recevrez une confirmation dès que vos parts auront été attribuées.",
    goToPortfolio: "Accéder à mon patrimoine",
    browseProjects: "Parcourir les projets",
    viewInvestment: "Voir les détails de l'investissement",
  },

  accountAdmin: {
    overline: "Console Super Admin",
    title: "Administration Identité & Accès",
    subtitle: "Gérer tous les comptes de la plateforme, identifiants, MFA, sessions et usurpation contrôlée.",
    bulkOps: "Opérations en lot",
    impersonationLog: "Journal d'usurpation",
    createUser: "Créer un compte",

    // Stats
    statTotal: "Total",
    statActive: "Actifs",
    statPending: "En attente",
    statSuspended: "Suspendus",
    statLocked: "Verrouillés",

    // Search & Filters
    searchPlaceholder: "Rechercher par nom ou e-mail...",
    allTypes: "Tous les types",
    typeInvestor: "Investisseur",
    typeInternal: "Interne",
    allStatuses: "Tous les statuts",
    statusActive: "Actif",
    statusPending: "Activation en attente",
    statusSuspended: "Suspendu",
    statusLocked: "Verrouillé",
    statusDeactivated: "Désactivé",
    allMfa: "Tous MFA",
    mfaEnrolled: "MFA activé",
    mfaNotEnrolled: "MFA non activé",
    results: "résultats",

    // Table Columns
    colName: "Nom",
    colEmail: "E-mail",
    colRole: "Rôle",
    colStatus: "Statut",
    colLastLogin: "Dernière connexion",
    colSubs: "Souscrip.",
    loading: "Chargement des comptes...",
    noResults: "Aucun compte ne correspond à vos filtres.",

    // Status display
    status_active: "Actif",
    status_pending_activation: "En attente",
    status_invited: "Invité",
    status_suspended: "Suspendu",
    status_locked: "Verrouillé",
    status_deactivated: "Désactivé",
    status_revoked: "Révoqué",

    // Role display — LOT 536
    role_super_admin: "Super admin",
    role_admin: "Admin",
    role_extended_admin: "Admin étendu",
    role_investor: "Investisseur",
    role_sponsor: "Commandité",
    role_read_only: "Lecture seule",

    // MFA display
    mfa_enrolled: "Activée",
    mfa_pending: "En attente",
    mfa_none: "Désactivée",
    // APEX M2 — 3e état PO : imposée par un admin, enrôlement non réalisé
    mfa_imposed_not_enrolled: "Imposée — non enrôlée",

    // Create User
    createUserTitle: "Créer un nouveau compte",
    createUserDesc: "Créer un compte investisseur ou utilisateur interne. Les doublons d'e-mail seront détectés automatiquement.",
    duplicateFound: "Compte existant trouvé",
    duplicateSuggestions: "Actions suggérées",
    openExisting: "Ouvrir le compte existant",
    tryDifferent: "Essayer un autre e-mail",
    firstName: "Prénom",
    lastName: "Nom",
    email: "E-mail",
    userType: "Type de compte",
    locale: "Langue",
    notes: "Notes admin",
    sendInviteImmediately: "Envoyer l'invitation d'activation immédiatement",
    createAndInvite: "Créer le compte",

    // Detail Page
    userDetail: "Détail du compte",
    tabIdentity: "Identité",
    tabSecurity: "Sécurité",
    tabSessions: "Sessions",
    tabAudit: "Activité",

    // Quick Actions
    sendInvite: "Envoyer l'invitation",
    sendReset: "Envoyer un e-mail de réinitialisation",
    forceReset: "Forcer la réinitialisation",
    tempPassword: "Mot de passe temporaire",
    resetMfa: "Réinitialiser le MFA",
    imposeMfa: "Imposer la MFA",
    revokeMfa: "Révoquer la MFA",
    impersonate: "Usurper l'identité",
    revokeSessions: "Révoquer les sessions",
    suspend: "Suspendre",
    lock: "Verrouiller",
    reactivate: "Réactiver",
    unlock: "Déverrouiller",
    deactivate: "Désactiver",
    actionSuccess: "Action effectuée avec succès.",

    // Confirmation Dialogs
    confirm_impersonate: "Démarrer l'usurpation",
    confirmDesc_impersonate: "Vous agirez en tant que cet investisseur. Toutes les actions seront attribuées à vous dans le journal d'audit. Un bandeau d'avertissement visible apparaîtra sur toute la plateforme.",
    "confirm_force-reset": "Forcer la réinitialisation du mot de passe",
    "confirmDesc_force-reset": "Cela invalidera le mot de passe actuel et forcera l'utilisateur à définir un nouveau mot de passe à la prochaine connexion. Toutes les sessions actives seront révoquées immédiatement.",
    "confirm_temp-password": "Définir un mot de passe temporaire",
    "confirmDesc_temp-password": "Un mot de passe temporaire sera défini pour cet utilisateur interne. Il devra le changer à la première connexion. Toutes les sessions actives seront révoquées.",
    "confirm_reset-mfa": "Réinitialiser l'inscription MFA",
    "confirmDesc_reset-mfa": "Cela supprimera la configuration MFA de l'utilisateur (secret + codes de récupération). Il devra se réinscrire à la prochaine connexion si la MFA est obligatoire pour son compte. Toutes les sessions actives seront révoquées.",
    "confirm_impose-mfa": "Imposer la double authentification",
    "confirmDesc_impose-mfa": "L'utilisateur sera guidé vers l'enrôlement TOTP à sa prochaine connexion et ne pourra plus désactiver la MFA lui-même. Vous ne verrez jamais son secret : l'enrôlement est réalisé par l'utilisateur.",
    "confirm_revoke-mfa": "Révoquer la double authentification",
    "confirmDesc_revoke-mfa": "L'obligation MFA sera levée et l'enrôlement effacé (secret + codes de récupération). Toutes les sessions actives seront révoquées. Le compte redevient protégé par mot de passe seul.",
    "confirm_revoke-sessions": "Révoquer toutes les sessions",
    "confirmDesc_revoke-sessions": "Cela terminera immédiatement toutes les sessions actives de cet utilisateur. Il sera déconnecté partout.",
    confirm_suspend: "Suspendre le compte",
    confirmDesc_suspend: "L'utilisateur sera immédiatement déconnecté et ne pourra plus accéder à la plateforme. Toutes les sessions seront révoquées.",
    confirm_lock: "Verrouiller le compte",
    confirmDesc_lock: "Le compte sera verrouillé pour des raisons de sécurité. Toutes les sessions seront révoquées.",
    confirm_reactivate: "Réactiver le compte",
    confirmDesc_reactivate: "Le compte sera restauré au statut actif. L'utilisateur pourra se reconnecter.",
    confirm_unlock: "Déverrouiller le compte",
    confirmDesc_unlock: "Le compte sera déverrouillé. Les tentatives de connexion échouées seront effacées.",
    confirm_deactivate: "Désactiver le compte",
    confirmDesc_deactivate: "Le compte sera définitivement désactivé. Toutes les sessions seront révoquées. Cette action est réversible.",
    reason: "Motif",
    reasonPlaceholder: "Indiquez un motif pour cette action (requis pour le journal d'audit)...",
    cancel: "Annuler",
    confirm: "Confirmer",
    processing: "Traitement...",

    // Identity Tab
    identityInfo: "Informations du compte",
    fieldFullName: "Nom complet",
    fieldEmail: "E-mail",
    fieldRole: "Rôle",
    fieldStatus: "Statut",
    fieldLocale: "Langue",
    fieldCreated: "Créé le",
    fieldCreatedBy: "Créé par",
    fieldLastLogin: "Dernière connexion",
    fieldHasPassword: "Mot de passe défini",
    fieldForceReset: "Réinitialisation forcée",
    yes: "Oui",
    no: "Non",
    neverLoggedIn: "Jamais connecté",
    investorProfile: "Profil investisseur",
    fieldProfileId: "ID du profil",
    fieldInvestorType: "Type d'investisseur",
    fieldEntityName: "Nom de l'entité",
    fieldPhone: "Téléphone",
    adminNotes: "Notes admin",

    // Security Tab
    passwordSecurity: "Sécurité mot de passe",
    mfaSecurity: "Sécurité MFA",
    fieldMfaState: "Statut MFA",
    fieldMfaImposedAt: "MFA imposée le",
    fieldMfaImposedReason: "Motif d'imposition",
    fieldMfaSetupAt: "Date configuration MFA",
    fieldMfaResetAt: "Dernière réinitialisation MFA",
    fieldPasswordChanged: "Dernier changement de mot de passe",
    activeImpersonation: "Usurpation en cours",
    impersonatedBy: "Usurpé par",
    since: "Depuis",

    // Sessions Tab
    activeSessions: "Sessions actives",
    noActiveSessions: "Aucune session active.",
    lastActivity: "Dernière activité",

    // Audit Tab
    recentActivity: "Activité récente",
    noActivity: "Aucune activité enregistrée.",
  },

  impersonation: {
    bannerWarning: "Admin sur session",
    actingAs: "Agissant en tant que",
    startedBy: "Par",
    reason: "Motif",
    stopImpersonation: "Quitter la session",
    since: "Depuis",
  },

  bulk: {
    // Re-passe recette Sprint 1 — fusion du bloc `bulk` DUPLIQUÉ
    // (le doublon écrasait les libellés des actions groupées du
    // Centre documentaire → clés brutes à l'écran).
    // Re-passe recette Sprint 1 — actions groupées du Centre documentaire
    selected: "sélectionné(s)",
    approve: "Approuver",
    reject: "Refuser",
    requestReplacement: "Demander un remplacement",
    noneSelected: "Aucun élément sélectionné.",
    error: "Erreur lors de l'action groupée.",
    selected: "sélectionné(s)",
    confirmBulk: "Confirmer l'action groupée",
    bulkStatusChange: "Changement de statut groupé",
    bulkAssign: "Assignation groupée",
    bulkReview: "Revue groupée",
    applyToSelected: "Appliquer aux sélectionnés",
    approve: "Approuver",
    reject: "Rejeter",
    requestReplacement: "Demander un remplacement",
    markComplete: "Marquer comme terminé",
    markInProgress: "Marquer en cours",
    assign: "Assigner",
    activate: "Activer",
    suspend: "Suspendre",
    success: "Action groupée effectuée avec succès.",
    error: "Erreur lors de l'action groupée.",
    noneSelected: "Aucun élément sélectionné.",
    confirmAction: "Confirmez-vous cette action groupée ?",
    accessDenied: "Accès refusé. Réservé au Super Admin.",
    backToAccounts: "Retour à Identité & Accès",
    overline: "Préparation des comptes",
    title: "Activation en masse des comptes",
    subtitle: "Identifier, prioriser et inviter les investisseurs en attente. Prioriser ceux ayant des souscriptions actives.",
    refresh: "Actualiser",
    loadError: "Impossible de charger les comptes en attente",

    totalPending: "Total en attente",
    neverInvited: "Jamais invités",
    invitedWaiting: "Invités, en attente",
    withSubscriptions: "Avec souscriptions",

    searchPlaceholder: "Rechercher par nom ou email...",
    filterAll: "Tous en attente",
    filterNeverInvited: "Jamais invités",
    filterInvitedWaiting: "Invités, non activés",
    filterWithSubs: "Avec souscriptions",
    filterNoSubs: "Sans souscription",
    shown: "affichés",

    selectAll: "Tout sélectionner",
    selectNeverInvited: "Sélect. jamais invités",
    selectWithSubs: "Sélect. avec souscrip.",
    deselectAll: "Tout désélectionner",
    accountsSelected: "comptes sélectionnés",

    colName: "Nom",
    colEmail: "Email",
    colSubs: "Souscrip.",
    colAmount: "Montant",
    colInviteState: "État d'invitation",
    colLastInvite: "Dernier envoi",
    colPriority: "Priorité",
    colActions: "Actions",

    stateNeverInvited: "Jamais invité",
    stateInvitedWaiting: "Invité — en attente",

    sendInvitesToSelected: "Envoyer les invitations",
    openDetail: "Ouvrir le détail du compte",
    never: "jamais",
    highPriority: "Haute priorité — a des souscriptions",
    mediumPriority: "Priorité moyenne",

    confirmTitle: "Confirmer l'envoi en masse",
    confirmDesc: "Ceci enverra des emails d'activation aux comptes sélectionnés.",
    accountsWillReceive: "comptes recevront un email d'activation :",
    andMore: "+ {count} de plus...",
    confirmWarning: "Chaque compte recevra un lien d'activation unique valable 7 jours. Les anciens liens non utilisés seront invalidés.",
    confirmSend: "Envoyer les invitations",

    resultsTitle: "Résultats de l'envoi en masse",
    invitesSent: "invitations envoyées avec succès",
    sendError: "Échec de l'envoi des invitations",
    sent: "Envoyées",
    skipped: "Ignorées",
    failed: "Échouées",
    noResults: "Aucun compte en attente ne correspond à vos filtres.",

    guideTitle: "Guide opérationnel",
    guideWhenInvite: "Quand envoyer une invitation",
    guideWhenInviteDesc: "Le compte est en attente d'activation et n'a jamais été invité. Commencer par les investisseurs ayant des souscriptions actives.",
    guideWhenResend: "Quand renvoyer une invitation",
    guideWhenResendDesc: "L'investisseur a été invité mais n'a pas activé après 7+ jours. Renvoyer depuis sa fiche. L'ancien lien est invalidé automatiquement.",
    guideWhenReset: "Quand utiliser la réinitialisation",
    guideWhenResetDesc: "L'investisseur a activé son compte mais a oublié son mot de passe. Utiliser 'Envoyer réinitialisation' depuis la fiche. NE PAS utiliser l'invitation pour les comptes actifs.",
    guideWhenEscalate: "Quand escalader manuellement",
    guideWhenEscalateDesc: "Compte verrouillé, suspendu ou compromis. Ouvrir la fiche du compte et utiliser les actions du cycle de vie ou contacter un super admin.",
  },
  // Re-passe recette Sprint 1 — espace de noms manquant (Investors.js)
  operations: {
    investorDetail: {
      movements: "Mouvements",
    },
  },
  // PHASE 2 — « Performance de votre patrimoine » (data-lot="phase2-performance")
  performance: {
    eyebrow: "Lecture de performance",
    title: "Performance de votre patrimoine",
    error: "Les graphiques sont momentanément indisponibles.",
    retry: "Réessayer",
    empty: "Vos graphiques de performance apparaîtront dès votre premier investissement.",
    emptyLink: "Découvrir les opportunités",
    capital: { eyebrow: "Dans le temps", title: "Capital investi", cumulative: "Cumul investi", event: "Ce jour-là", empty: "Votre courbe apparaîtra dès la réception effective de vos fonds." },
    distributions: { eyebrow: "Flux reçus", title: "Distributions reçues", quarter: "Ce trimestre", cumulative: "Cumul reçu", legendQuarter: "Par trimestre", legendCumulative: "Cumul", empty: "Aucune distribution reçue à ce jour." },
    allocation: { eyebrow: "Répartition", title: "Votre capital investi", center: "Capital investi", amount: "Montant", share: "Part", others: "Autres", notSet: "Non renseigné", views: { project: "Par projet", country: "Par pays", asset_class: "Par type d'actif" } },
    yield: { eyebrow: "Indicateur", title: "Rendement des distributions", tooltip: "Total des distributions reçues rapporté au capital investi, depuis l'origine. Indicateur non annualisé, hors plus-value de sortie.", distributions: "Distributions reçues", invested: "Capital investi", note: "Distributions reçues ÷ capital investi, depuis l'origine." },
  },
};

export default fr;
